var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreviousPaperAnalysis({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 254.732,
    height: 154.275,
    viewBox: "0 0 254.732 154.275",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.ad{fill:#fff;}.b{fill:#fad057;}.c{fill:#d8d9be;}.d{fill:#e9eaee;}.e{fill:#5798ff;}.aa,.ab,.ac,.am,.an,.as,.au,.f,.k,.s,.z{fill:none;stroke-miterlimit:10;}.f,.z{stroke:#472c91;}.g,.y{fill:#bcd5f4;}.g{opacity:0.56;}.h{fill:#3385ff;}.i{fill:#5798fd;}.j{fill:#3284ff;}.k{stroke:#5798fd;}.l{fill:#2564bf;}.m{fill:#0a2c45;}.n{fill:#e57b6a;}.o{fill:#fc8f77;}.p{fill:#e8d3cf;}.q{fill:#e5cfca;}.r{fill:#f4dfd9;}.s{stroke:#231f20;}.t{fill:#a5424e;}.u{fill:#b4d3ef;}.v{fill:#f7e8e4;}.w{fill:#d8c2bf;}.x{fill:#574199;}.aa,.ab,.ac,.z{stroke-width:3px;}.aa{stroke:#b5adea;}.ab{stroke:#a398d8;}.ac{stroke:#fc8f77;}.ad{font-size:1px;font-family:BebasNeue-Regular, Bebas Neue;letter-spacing:0.2em;}.ae{fill:#95bffe;}.af{fill:#252f5f;}.ag{fill:#472c91;}.ah{fill:#d0e1f4;}.ai{fill:#5b34b3;}.aj{fill:#43487c;}.ak{fill:#2e315c;}.al{fill:#3c5490;}.am{stroke:#a7b8db;stroke-width:0.5px;}.an{stroke:#3385ff;}.ao{fill:#335e96;}.ap{fill:#384ea8;}.aq{fill:#4172b7;}.ar{fill:#5286d8;}.as{stroke:#476489;}.at{fill:#274fa0;}.au{stroke:#b0c4ff;}.av{fill:#408cfe;}.aw{fill:#69bbff;}.ax{fill:#8ec3ef;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-126.474 -100.101)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M147.1,325.125H394.971s15.046-108.944-59.16-108.99c-53.59-.033-68.042,22.077-100.709,53.86C202.022,302.179,148.625,224.71,147.1,325.125Z",
    transform: "translate(-16.839 -74.114)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(126.474 219.88)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M422.115,814.883h-.983v-1.224h.983Z",
    transform: "translate(-366.974 -781.693)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M422.568,801.448h-.881v-1.113h.881Z",
    transform: "translate(-367.427 -770.819)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M422.863,787.766h-.815v-1.058h.815Z",
    transform: "translate(-367.721 -759.696)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M423.149,774.084H422.4v-1h.751Z",
    transform: "translate(-368.007 -748.575)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M423.6,760.649h-.65v-.891h.65Z",
    transform: "translate(-368.455 -737.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M423.934,747.022,423.36,747v-.837l.574-.028Z",
    transform: "translate(-368.792 -726.577)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M424.335,733.531h-.483v-.724h.483Z",
    transform: "translate(-369.194 -715.702)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M424.631,719.9l-.417-.032v-.691h.417Z",
    transform: "translate(-369.489 -704.581)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M424.881,706.222h-.361v-.634l.361-.034Z",
    transform: "translate(-369.739 -693.458)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M425.34,692.786l-.257-.017v-.525l.257-.015Z",
    transform: "translate(-370.199 -682.582)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M425.551,679.1c-.159.038-.22-.028-.208-.187s-.053-.335.208-.314Z",
    transform: "translate(-370.41 -671.454)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M400.124,821.347c0-.351.016-.7.007-1.053,0-.171.056-.227.224-.222.339.01.679,0,1.043,0v1.271l.008-.009h-1.289Z",
    transform: "translate(-349.821 -786.928)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M386.484,821.185v-1.249h1.244v1.24h-1.253Z",
    transform: "translate(-338.687 -786.817)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M415.292,821.7l-1.2-.055v-1.229h1.2q0,.645,0,1.289Z",
    transform: "translate(-361.228 -787.207)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M304.529,819.839v-1.176h1.19v1.176Z",
    transform: "translate(-271.802 -785.778)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M256.65,812.155v-1.182h1.2v1.182Z",
    transform: "translate(-232.724 -779.501)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M374.768,820.4h-1.213v-1.208h1.213Z",
    transform: "translate(-328.141 -786.21)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M311.465,813.122v-1.176h1.2v1.176Z",
    transform: "translate(-277.464 -780.295)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M367.5,814.067H366.31v-1.189H367.5Z",
    transform: "translate(-322.228 -781.056)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M181.286,816.447h1.173v1.2h-1.173Z",
    transform: "translate(-171.212 -783.969)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M196.147,818h-1.208V816.8h1.2v1.217Z",
    transform: "translate(-182.355 -784.254)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M359.324,820.781V819.61h1.2v1.171Z",
    transform: "translate(-316.526 -786.551)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M250.934,817.7v1.177h-1.19V817.7Z",
    transform: "translate(-227.087 -784.989)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M318.232,820.059v-1.17h1.18v1.17Z",
    transform: "translate(-282.987 -785.962)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M237.307,817.5v1.164h-1.174V817.5Z",
    transform: "translate(-215.978 -784.827)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M353.891,812.619V813.8h-1.17v-1.179Z",
    transform: "translate(-311.137 -780.845)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M407.445,814.736V813.55h1.18v1.186Z",
    transform: "translate(-355.802 -781.605)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M381.22,813.162v1.17h-1.179v-1.17Z",
    transform: "translate(-333.435 -781.288)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M326.408,813.351h-1.174v-1.2h1.174Z",
    transform: "translate(-288.702 -780.465)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M126.474,815.547h1.178v1.179h-1.178Z",
    transform: "translate(-126.474 -783.234)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M264.617,817.944v1.185h-1.18v-1.185Z",
    transform: "translate(-238.263 -785.191)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M215.589,810.17h1.172v1.2h-1.172Z",
    transform: "translate(-199.21 -778.846)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M290.879,819.562V818.4h1.177v1.167Z",
    transform: "translate(-260.661 -785.559)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M297.87,811.708h1.178v1.177H297.87Z",
    transform: "translate(-266.367 -780.101)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M244.264,810.738v1.169h-1.178v-1.169Z",
    transform: "translate(-221.653 -779.309)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M270.424,811.252H271.6v1.158h-1.174Z",
    transform: "translate(-243.966 -779.729)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M167.61,816.246h1.16v1.18h-1.16Z",
    transform: "translate(-160.049 -783.805)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M208.63,816.984H209.8v1.166H208.63Z",
    transform: "translate(-193.53 -784.407)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M345.739,819.41h1.173v1.16h-1.173Z",
    transform: "translate(-305.438 -786.387)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M332.038,819.11h1.157V820.3h-1.157Z",
    transform: "translate(-294.255 -786.143)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M230.522,811.671h-1.159v-1.179h1.159Z",
    transform: "translate(-210.452 -779.109)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M285.355,812.6h-1.162v-1.177h1.162Z",
    transform: "translate(-255.204 -779.865)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M153.846,816.1h1.172v1.156h-1.172Z",
    transform: "translate(-148.815 -783.688)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M222.411,817.145h1.16v1.187h-1.16Z",
    transform: "translate(-204.778 -784.539)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M141.317,815.792v1.165h-1.191v-1.165Z",
    transform: "translate(-137.617 -783.435)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M338.991,812.444h1.161v1.16h-1.161Z",
    transform: "translate(-299.93 -780.702)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M195.3,803.136h1.135v1.134H195.3Z",
    transform: "translate(-182.65 -773.105)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M181.623,802.908h1.13v1.125h-1.13Z",
    transform: "translate(-171.487 -772.919)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M394.959,814.563H393.8V813.4h1.162Z",
    transform: "translate(-344.663 -781.484)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M236.4,804.979V803.85h1.139v1.129Z",
    transform: "translate(-216.192 -773.687)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M400.794,807.92V806.8h1.144v1.12Z",
    transform: "translate(-350.374 -776.095)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M127.916,803.071h-1.13v-1.142h1.13Z",
    transform: "translate(-126.729 -772.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M134.668,810.033h-1.13v-1.14h1.13Z",
    transform: "translate(-132.24 -777.804)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M332.352,806.737v-1.126h1.131v1.126Z",
    transform: "translate(-294.512 -775.125)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M387.185,807.609v-1.131h1.125v1.131Z",
    transform: "translate(-339.266 -775.832)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M346,805.8h1.143v1.134H346Z",
    transform: "translate(-305.654 -775.277)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M277.2,819.389v-1.158h1.157v1.158Z",
    transform: "translate(-249.496 -785.425)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M189.5,809.9v1.133h-1.131V809.9Z",
    transform: "translate(-176.994 -778.624)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M222.767,804.822V803.7h1.119v1.122Z",
    transform: "translate(-205.068 -773.565)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M278.724,805.722H277.6V804.58h1.119Z",
    transform: "translate(-249.827 -774.283)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M304.912,806.182v-1.135h1.131v1.135Z",
    transform: "translate(-272.115 -774.664)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M250.118,804.1h1.125v1.122h-1.125Z",
    transform: "translate(-227.392 -773.894)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M167.95,802.6h1.121v1.131H167.95Z",
    transform: "translate(-160.327 -772.667)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M161.01,809.435h1.122v1.133H161.01Z",
    transform: "translate(-154.662 -778.246)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M154.281,802.455h1.131v1.13h-1.131Z",
    transform: "translate(-149.17 -772.549)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M415.684,808.139h-1.129V807h1.129Z",
    transform: "translate(-361.606 -776.259)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M141.658,803.4h-1.124v-1.119h1.124Z",
    transform: "translate(-137.95 -772.41)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M263.9,804.346H265v1.142h-1.1Z",
    transform: "translate(-238.638 -774.092)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M318.708,805.315h1.1v1.122h-1.1Z",
    transform: "translate(-283.375 -774.883)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M374.617,807.423h-1.1v-1.132h1.1Z",
    transform: "translate(-328.107 -775.68)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M202.133,810.111h1.1v1.137h-1.1Z",
    transform: "translate(-188.227 -778.798)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M175.766,810.877H174.63v-1.106h1.136Z",
    transform: "translate(-165.779 -778.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M292.342,806.013H291.2v-1.106h1.14Z",
    transform: "translate(-260.925 -774.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M210.187,804.58h-1.1v-1.123h1.1Z",
    transform: "translate(-193.904 -773.367)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M359.717,807.212V806.1h1.132v1.108Z",
    transform: "translate(-316.847 -775.527)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M147.339,809.185h1.1v1.124h-1.1Z",
    transform: "translate(-143.504 -778.042)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M402.3,794.242h-1.071v-1.088H402.3Z",
    transform: "translate(-350.732 -764.957)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M381.644,800.821h-1.071v-1.08h1.071Z",
    transform: "translate(-333.87 -770.334)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M162.382,796.957h-1.075v-1.086h1.075Z",
    transform: "translate(-154.905 -767.175)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M216.135,796.774h1.078v1.077h-1.078Z",
    transform: "translate(-199.655 -767.912)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M333.773,791.974v1.075h-1.087v-1.075Z",
    transform: "translate(-294.784 -763.994)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M388.6,794.023h-1.07v-1.089h1.07Z",
    transform: "translate(-339.55 -764.778)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M272.009,797.795v1.072h-1.088v-1.072Z",
    transform: "translate(-244.372 -768.745)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M326.823,799.763h-1.072v-1.081h1.072Z",
    transform: "translate(-289.124 -769.469)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M148.784,795.594v1.08h-1.077v-1.08Z",
    transform: "translate(-143.804 -766.949)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M408.016,801.212v-1.073H409.1v1.073Z",
    transform: "translate(-356.269 -770.659)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M414.977,794.547v-1.075h1.074v1.075Z",
    transform: "translate(-361.95 -765.217)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M285.717,799.074h-1.074V797.99h1.074Z",
    transform: "translate(-255.571 -768.904)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M347.5,792.243v1.082h-1.078v-1.082Z",
    transform: "translate(-305.996 -764.214)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M229.811,798.189v-1.073h1.083v1.073Z",
    transform: "translate(-210.818 -768.191)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M353.166,800.309V799.24h1.088v1.069Z",
    transform: "translate(-311.5 -769.925)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M278.969,791.072v1.072h-1.086v-1.072Z",
    transform: "translate(-250.054 -763.258)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M174.981,797.208v-1.069h1.085v1.069Z",
    transform: "translate(-166.065 -767.394)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M373.8,793.873V792.8h1.081v1.07Z",
    transform: "translate(-328.345 -764.671)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M298.434,798.225H299.5V799.3h-1.071Z",
    transform: "translate(-266.828 -769.096)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M188.783,796.262h1.081v1.075h-1.081Z",
    transform: "translate(-177.331 -767.494)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M133.94,796.461V795.4h1.084v1.064Z",
    transform: "translate(-132.568 -766.788)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M367.94,799.478v1.065h-1.083v-1.065Z",
    transform: "translate(-322.675 -770.119)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M394.265,799.893h1.073v1.072h-1.073Z",
    transform: "translate(-345.045 -770.458)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M291.592,791.259h1.081v1.077h-1.081Z",
    transform: "translate(-261.243 -763.411)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M340.514,799.013v1.071h-1.082v-1.071Z",
    transform: "translate(-300.29 -769.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M313.133,799.61h-1.069v-1.079h1.069Z",
    transform: "translate(-277.952 -769.346)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M202.4,797.65v-1.076h1.076v1.076Z",
    transform: "translate(-188.442 -767.749)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M257.257,797.473h1.071v1.076h-1.071Z",
    transform: "translate(-233.219 -768.482)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M243.605,797.3h1.077v1.077h-1.077Z",
    transform: "translate(-222.076 -768.342)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M320.083,791.747v1.069H319v-1.069Z",
    transform: "translate(-283.611 -763.809)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M360.177,792.473h1.081v1.076h-1.081Z",
    transform: "translate(-317.222 -764.402)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M306.443,792.661H305.36v-1.076h1.083Z",
    transform: "translate(-272.481 -763.677)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M243.983,783.713H245v1.031h-1.017Z",
    transform: "translate(-222.385 -757.252)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M127.423,788.488h1.013v1.033h-1.013Z",
    transform: "translate(-127.249 -761.149)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M141.007,789.873v-1.019h1.028v1.019Z",
    transform: "translate(-138.336 -761.448)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M312.412,784.959h1.024v1.023h-1.024Z",
    transform: "translate(-278.237 -758.269)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M409.432,787.632h-1.021v-1.021h1.021Z",
    transform: "translate(-356.591 -759.617)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M190.21,783.81H189.2v-1.023h1.013Z",
    transform: "translate(-177.669 -756.496)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M135.387,781.9v1.015h-1.034V781.9Z",
    transform: "translate(-132.905 -755.775)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M238.042,790.424v1.022h-1.028v-1.022Z",
    transform: "translate(-216.697 -762.729)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M251.655,790.762v1.019h-1.031v-1.019Z",
    transform: "translate(-227.805 -763.005)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M149,783.075h-1.026v-1.024H149Z",
    transform: "translate(-144.025 -755.895)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M354.631,786.7h-1.014v-1.033h1.014Z",
    transform: "translate(-311.868 -758.846)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M182.2,789.514h1.018v1.023H182.2Z",
    transform: "translate(-171.961 -761.987)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M368.244,786.914h-1.017v-1.031h1.017Z",
    transform: "translate(-322.977 -759.023)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M195.851,789.7h1.014v1.032h-1.014Z",
    transform: "translate(-183.1 -762.137)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M257.619,783.983h1.019v1.028h-1.019Z",
    transform: "translate(-233.515 -757.472)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M161.683,783.3v-1.016h1.025V783.3Z",
    transform: "translate(-155.212 -756.085)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M176.491,783.614h-1.022v-1.022h1.022Z",
    transform: "translate(-166.464 -756.337)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M202.821,783.038h1.015v1.033h-1.015Z",
    transform: "translate(-188.788 -756.701)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M230.3,783.429h1.015v1.032H230.3Z",
    transform: "translate(-211.215 -757.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M298.757,785.7v-1.018h1.031V785.7Z",
    transform: "translate(-267.091 -758.042)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M155.751,790.058h-1.019V789.04h1.019Z",
    transform: "translate(-149.538 -761.6)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M286.1,784.471v1.016h-1.026v-1.016Z",
    transform: "translate(-255.924 -757.87)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M381.974,786.118v1.024h-1.02v-1.024Z",
    transform: "translate(-334.181 -759.214)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M216.466,784.3v-1.008h1.026V784.3Z",
    transform: "translate(-199.925 -756.906)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M264.373,790.963h1.013v1.023h-1.013Z",
    transform: "translate(-239.027 -763.169)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M169.526,789.326v1.013H168.5v-1.013Z",
    transform: "translate(-160.772 -761.833)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M340.952,786.306h-1.035v-1.04c.3,0,.593-.007.885.007a.207.207,0,0,1,.144.141C340.96,785.706,340.952,786,340.952,786.306Z",
    transform: "translate(-300.686 -758.517)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M272.336,785.215h-1.018V784.2h1.018Z",
    transform: "translate(-244.696 -757.647)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M394.728,786.415h1.016v1.016h-1.016Z",
    transform: "translate(-345.423 -759.457)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M326.141,785.205h1.015v1.025h-1.015Z",
    transform: "translate(-289.442 -758.469)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M210.542,791.1h-1.016v-1.02h1.016Z",
    transform: "translate(-194.261 -762.446)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M224.343,791.228h-1.018V790.2h1.018Z",
    transform: "translate(-205.524 -762.547)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M354.885,772.077v.987H353.9v-.987Z",
    transform: "translate(-312.102 -747.754)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M292.072,778.811v-.989h.984v.989Z",
    transform: "translate(-261.635 -752.443)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M360.636,780v-.986h.963V780Z",
    transform: "translate(-317.597 -753.42)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M279.408,777.661v.965h-.985v-.965Z",
    transform: "translate(-250.495 -752.312)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M408.656,774.09v-.961h.984v.961Z",
    transform: "translate(-356.791 -748.613)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M168.836,776.677v-.964h.974v.964Z",
    transform: "translate(-161.05 -750.722)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M395.027,772.763H396v.985h-.976Z",
    transform: "translate(-345.667 -748.314)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M183.494,775.907v.978h-.986v-.978Z",
    transform: "translate(-172.209 -750.88)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M382.366,773.545h-.957v-.976h.957Z",
    transform: "translate(-334.552 -748.156)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M250.988,778.1v-.97h.976v.97Z",
    transform: "translate(-228.102 -751.876)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M209.978,777.405v-.978h.965v.978Z",
    transform: "translate(-194.63 -751.305)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M141.376,776.231v-.975h.972v.975Z",
    transform: "translate(-138.637 -750.349)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M334.241,779.6h-.977v-.974h.977Z",
    transform: "translate(-295.256 -753.095)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M223.624,776.707h.975v.971h-.975Z",
    transform: "translate(-205.768 -751.533)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M128.69,774.98v.967h-.98v-.967Z",
    transform: "translate(-127.483 -750.124)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M237.264,777.874v-.963h.984v.963Z",
    transform: "translate(-216.901 -751.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M401.742,779.742h.981v.985h-.981Z",
    transform: "translate(-351.148 -754.011)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M319.581,779.324v-.975h.971v.975Z",
    transform: "translate(-284.088 -752.874)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M347.919,778.883v.961h-.985v-.961Z",
    transform: "translate(-306.413 -753.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M197.2,777.187h-.954v-.973h.954Z",
    transform: "translate(-183.42 -751.131)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M389.015,780.513h-.981v-.968h.981Z",
    transform: "translate(-339.959 -753.85)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M264.784,778.389v-.962h.972v.962Z",
    transform: "translate(-239.363 -752.121)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M306.817,778.147v.95h-.97v-.95Z",
    transform: "translate(-272.878 -752.709)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M155.184,775.5h.965v.964h-.965Z",
    transform: "translate(-149.907 -750.548)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M415.471,780.057h.959v.969h-.959Z",
    transform: "translate(-362.353 -754.268)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M375.426,780.2h-.978v-.981c.284,0,.567-.006.849.006a.188.188,0,0,1,.123.135C375.432,779.635,375.426,779.909,375.426,780.2Z",
    transform: "translate(-328.87 -753.583)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M367.6,772.331h.968v.965H367.6Z",
    transform: "translate(-323.281 -747.962)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M293.444,764.308v.925H292.5v-.925Z",
    transform: "translate(-261.983 -741.413)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M286.49,771.041v.917h-.938v-.917Z",
    transform: "translate(-256.313 -746.909)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M326.677,771.717h.918v.937h-.918Z",
    transform: "translate(-289.88 -747.461)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M340.348,772.869v-.926h.938v.926Z",
    transform: "translate(-301.038 -747.645)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M403.072,766.226v.924h-.939v-.924Z",
    transform: "translate(-351.467 -742.979)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M347.294,766.155v-.917h.937v.917Z",
    transform: "translate(-306.707 -742.172)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M230.7,771.022V770.1h.946v.922Z",
    transform: "translate(-211.542 -746.141)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M374.684,766.65v-.931h.937v.931Z",
    transform: "translate(-329.063 -742.565)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M312.937,772.383v-.939h.925v.939Z",
    transform: "translate(-278.665 -747.238)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M258.124,771.467v-.931h.926v.931Z",
    transform: "translate(-233.927 -746.497)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M189.7,769.283h.9v.936h-.9Z",
    transform: "translate(-178.082 -745.474)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M238.652,763.451v.9h-.944v-.9Z",
    transform: "translate(-217.263 -740.714)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M252.376,764.506h-.908v-.94h.908Z",
    transform: "translate(-228.494 -740.808)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M176.882,769.152v.905h-.942v-.905Z",
    transform: "translate(-166.848 -745.367)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M307.182,765.408h-.911v-.94h.911Z",
    transform: "translate(-273.224 -741.544)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M223.954,764.05v-.918h.928v.918Z",
    transform: "translate(-206.037 -740.454)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M416.823,766.452v.926h-.91v-.926Z",
    transform: "translate(-362.714 -743.163)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M299.313,772.2v-.922h.908v.922Z",
    transform: "translate(-267.545 -747.105)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M272.789,771.707h-.924v-.923h.924Z",
    transform: "translate(-245.142 -746.699)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M149.472,768.656v.916h-.926v-.916Z",
    transform: "translate(-144.489 -744.962)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M210.285,763.793v-.93h.92v.93Z",
    transform: "translate(-194.881 -740.234)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M278.778,765v-.9h.928v.9Z",
    transform: "translate(-250.785 -741.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M204.252,769.531v.929h-.93v-.929Z",
    transform: "translate(-189.197 -745.676)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M266.023,764.7h-.93v-.93h.93Z",
    transform: "translate(-239.615 -740.978)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M162.253,768.853h.92v.93h-.92Z",
    transform: "translate(-155.677 -745.123)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M361.068,766.457v-.917h.91v.917Z",
    transform: "translate(-317.95 -742.419)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M334.534,765.933h-.925V765h.925Z",
    transform: "translate(-295.538 -741.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M388.444,765.965h.919v.91h-.919Z",
    transform: "translate(-340.294 -742.766)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M319.9,765.685v-.9h.927v.9Z",
    transform: "translate(-284.346 -741.799)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M197.578,762.572v.921h-.917v-.921Z",
    transform: "translate(-183.761 -739.996)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M217,770.786v-.915h.925v.915Z",
    transform: "translate(-200.361 -745.954)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M135.823,768.406v.912h-.909v-.912Z",
    transform: "translate(-133.363 -744.758)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M244.514,770.352h.91v.909h-.91Z",
    transform: "translate(-222.818 -746.346)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M217.411,756.168h.878v.9h-.878Z",
    transform: "translate(-200.697 -734.769)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M396.389,760.213H395.5v-.888h.892Z",
    transform: "translate(-346.05 -737.346)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M340.617,759.33v-.874h.908v.874Z",
    transform: "translate(-301.257 -736.637)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M272.19,758.119v-.873h.888v.873Z",
    transform: "translate(-245.407 -735.649)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M327.919,759.032h-.877v-.877h.877Z",
    transform: "translate(-290.177 -736.391)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M156.542,762.085v.875h-.883v-.875Z",
    transform: "translate(-150.295 -739.599)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M163.475,756.167h-.883v-.873h.883Z",
    transform: "translate(-155.953 -734.056)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M203.685,755.963h.869v.89h-.869Z",
    transform: "translate(-189.494 -734.602)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M410.108,760.527h-.866v-.881h.866Z",
    transform: "translate(-357.269 -737.608)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M142.812,762.627h-.867v-.89h.867Z",
    transform: "translate(-139.101 -739.314)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M135.2,754.783h.873v.883H135.2Z",
    transform: "translate(-133.599 -733.639)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M148.869,755.973v-.883h.872v.883Z",
    transform: "translate(-144.753 -733.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M382.74,760.08h-.879v-.872h.879Z",
    transform: "translate(-334.921 -737.251)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M355.3,758.635v.871h-.874v-.871Z",
    transform: "translate(-312.532 -736.783)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M128.215,762.5v-.864h.875v.864Z",
    transform: "translate(-127.895 -739.232)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M259.4,757.076v.862h-.871v-.862Z",
    transform: "translate(-234.26 -735.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M299.622,757.708h.871v.875h-.871Z",
    transform: "translate(-267.797 -736.026)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M170.278,762.313v.865H169.4v-.865Z",
    transform: "translate(-161.513 -739.785)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M416.175,753.758v-.867h.875v.867Z",
    transform: "translate(-362.928 -732.094)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M245.7,757.638h-.865v-.874h.865Z",
    transform: "translate(-223.077 -735.256)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M314.206,758.856h-.859v-.87h.859Z",
    transform: "translate(-279 -736.253)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M183.931,763.4h-.859v-.869h.859Z",
    transform: "translate(-172.669 -739.966)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M368.124,758.835h.865v.89h-.865Z",
    transform: "translate(-323.709 -736.946)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M286.861,757.413v.874h-.874v-.874Z",
    transform: "translate(-256.668 -735.786)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M190.037,755.818h.86v.869h-.86Z",
    transform: "translate(-178.354 -734.484)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M177.243,755.528v.873h-.874v-.873Z",
    transform: "translate(-167.198 -734.247)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M232.071,757.41h-.863v-.874h.863Z",
    transform: "translate(-211.958 -735.07)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M156.8,748.445v.834h-.846v-.834Z",
    transform: "translate(-150.537 -728.466)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M273.388,743.6v.834h-.846V743.6Z",
    transform: "translate(-245.695 -724.514)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M375.171,752.27h.845v.845h-.845Z",
    transform: "translate(-329.46 -731.588)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M369.339,745.3v.84H368.5v-.84Z",
    transform: "translate(-324.019 -725.901)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M307.576,751.077v.833h-.829v-.833Z",
    transform: "translate(-273.613 -730.614)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M362.383,752.074v.816h-.831v-.816Z",
    transform: "translate(-318.345 -731.428)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M251.924,750.958v-.814h.827v.814Z",
    transform: "translate(-228.866 -729.852)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M293.861,750.834v.827h-.812v-.827Z",
    transform: "translate(-262.432 -730.416)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M314.544,744.427v.811h-.826v-.811Z",
    transform: "translate(-279.302 -725.187)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M382.984,746.413h-.835v-.826h.835Z",
    transform: "translate(-335.156 -726.133)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M320.337,752.193v-.81h.846v.81Z",
    transform: "translate(-284.705 -730.864)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M238.2,750.729v-.837h.819v.837Z",
    transform: "translate(-217.665 -729.647)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M142.325,748.265h.827v.817h-.827Z",
    transform: "translate(-139.412 -728.319)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M265.54,751.215v-.823h.846v.823Z",
    transform: "translate(-239.98 -730.055)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M286.255,744.735v-.818h.836v.818Z",
    transform: "translate(-256.887 -724.77)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M348.666,751.759v.84h-.819v-.84Z",
    transform: "translate(-307.159 -731.171)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M341.1,745.623v-.841h.825v.841Z",
    transform: "translate(-301.651 -725.476)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M355.636,745.917h-.813v-.835h.813Z",
    transform: "translate(-312.852 -725.721)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M409.609,746h.815v.844h-.815Z",
    transform: "translate(-357.569 -726.467)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M258.856,744.273v-.816h.835v.816Z",
    transform: "translate(-234.524 -724.395)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M197.941,750.029h-.83V749.2h.83Z",
    transform: "translate(-184.128 -729.085)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M224.5,750.506v-.836h.831v.836Z",
    transform: "translate(-206.481 -729.466)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M211.584,750.292h-.846v-.818h.846Z",
    transform: "translate(-195.25 -729.305)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M170.542,748.729v.82h-.835v-.82Z",
    transform: "translate(-161.761 -728.698)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M327.31,745.474v-.8h.842v.8Z",
    transform: "translate(-290.396 -725.386)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M300.809,744.943h-.814V744.1h.814Z",
    transform: "translate(-268.102 -724.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M279.362,750.672h.822v.818h-.822Z",
    transform: "translate(-251.261 -730.284)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M403.489,752.842v.8h-.814v-.8Z",
    transform: "translate(-351.909 -732.055)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M396.744,745.842v.812h-.835v-.812Z",
    transform: "translate(-346.387 -726.341)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M184.225,749.772h-.813v-.82h.813Z",
    transform: "translate(-172.947 -728.88)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M334.974,751.6v.81h-.832v-.81Z",
    transform: "translate(-295.973 -731.043)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M388.95,752.493h.829v.826h-.829Z",
    transform: "translate(-340.707 -731.77)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M129.409,747.984v.826h-.818v-.826Z",
    transform: "translate(-128.202 -728.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M253.024,737.321h-.786v-.79h.786Z",
    transform: "translate(-229.123 -718.742)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M170.874,735.891h-.786V735.1h.786Z",
    transform: "translate(-162.072 -717.574)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M245.246,744.083v-.775h.785v.775Z",
    transform: "translate(-223.416 -724.273)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M135.622,742.172v-.783h.79v.783Z",
    transform: "translate(-133.941 -722.707)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M198.233,735.642v.78h-.79v-.78Z",
    transform: "translate(-184.399 -718.016)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M390.105,738.946v.788h-.789v-.788Z",
    transform: "translate(-341.006 -720.713)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M307.839,738.333h-.781v-.79h.781Z",
    transform: "translate(-273.867 -719.568)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M361.819,739.231v-.78h.79v.78Z",
    transform: "translate(-318.563 -720.309)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M191.246,743.167h-.779V742.4h.779Z",
    transform: "translate(-178.705 -723.53)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M238.593,737.132v-.774h.771v.774Z",
    transform: "translate(-217.985 -718.601)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M293.392,738.006v-.778h.77v.778Z",
    transform: "translate(-262.712 -719.311)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M176.845,742.061h.771v.789h-.771Z",
    transform: "translate(-167.587 -723.255)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M128.98,735.184V734.4h.771v.786Z",
    transform: "translate(-128.519 -717.001)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M183.84,735.374h.76v.77h-.76Z",
    transform: "translate(-173.296 -717.797)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M204.235,743.366v-.781H205v.781Z",
    transform: "translate(-189.943 -723.683)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M375.621,739.511v-.786h.77v.786Z",
    transform: "translate(-329.828 -720.532)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M163.914,741.944v.765h-.79v-.765Z",
    transform: "translate(-156.388 -723.16)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M403.793,739.2v.769h-.78V739.2Z",
    transform: "translate(-352.185 -720.916)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M142.6,735.413v-.766h.791v.766Z",
    transform: "translate(-139.634 -717.203)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M348.212,738.272h.776v.769h-.776Z",
    transform: "translate(-307.456 -720.163)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M417.446,740.3h-.781v-.771h.781Z",
    transform: "translate(-363.328 -721.185)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M224.861,736.931v-.75h.789v.75Z",
    transform: "translate(-206.777 -718.455)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M334.508,738.027h.789v.763h-.789Z",
    transform: "translate(-296.271 -719.963)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M231.62,743.883v-.751h.77v.751Z",
    transform: "translate(-212.294 -724.13)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M320.82,737.7h.767v.789h-.767Z",
    transform: "translate(-285.099 -719.693)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M280.479,737.854h-.785v-.77h.785Z",
    transform: "translate(-251.532 -719.193)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M266,737.606v-.787h.771v.787Z",
    transform: "translate(-240.357 -718.977)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M217.913,743.6v-.772h.788v.772Z",
    transform: "translate(-201.106 -723.884)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M149.387,742.386v-.761h.781v.761Z",
    transform: "translate(-145.176 -722.899)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M157.2,734.957v.768h-.768v-.768Z",
    transform: "translate(-150.922 -717.457)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M211.185,736.634v-.768h.768v.768Z",
    transform: "translate(-195.615 -718.199)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M404.095,725.649v.725h-.734v-.725Z",
    transform: "translate(-352.469 -709.86)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M205.332,729.772H204.6v-.734h.735Z",
    transform: "translate(-190.238 -712.626)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M349.173,724.736v.746c-.208,0-.409.011-.607-.007a.21.21,0,0,1-.142-.144c-.017-.19-.007-.384-.007-.595Z",
    transform: "translate(-307.622 -709.115)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M342.306,732.133h-.725V731.4h.725Z",
    transform: "translate(-302.044 -714.553)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M149.774,728.784v-.729h.735v.729Z",
    transform: "translate(-145.491 -711.824)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M259.422,729.928h.728v.733h-.728Z",
    transform: "translate(-234.986 -713.352)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M376.727,725.1v.734h-.735V725.1Z",
    transform: "translate(-330.131 -709.41)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M321.917,724.927h-.734v-.734h.734Z",
    transform: "translate(-285.395 -708.671)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M287.49,731.212h-.73v-.734h.73Z",
    transform: "translate(-257.299 -713.801)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M396.354,733.111v-.729h.734v.729Z",
    transform: "translate(-346.75 -715.355)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M219.025,729.993h-.715v-.734h.715Z",
    transform: "translate(-201.431 -712.806)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M328.657,731.176v.731h-.716v-.731Z",
    transform: "translate(-290.911 -714.371)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M390.438,725.43v.729h-.716v-.729Z",
    transform: "translate(-341.337 -709.681)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M335.617,724.411v.728h-.723v-.728Z",
    transform: "translate(-296.586 -708.849)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M273.118,730.968v-.709h.714v.709Z",
    transform: "translate(-246.165 -713.623)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M382.754,732.221h.715v.706h-.715Z",
    transform: "translate(-335.65 -715.224)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M410.857,733.321h-.714v-.734h.714Z",
    transform: "translate(-358.005 -715.523)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M232.67,730.242h-.726v-.715h.726Z",
    transform: "translate(-212.559 -713.025)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M314.2,731.714v-.7h.736v.7Z",
    transform: "translate(-279.699 -714.236)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M163.482,729.074v-.7h.732v.7Z",
    transform: "translate(-156.68 -712.088)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M356.089,731.715v.725h-.715v-.725Z",
    transform: "translate(-313.302 -714.811)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M136.849,728.558h-.706v-.741h.706Z",
    transform: "translate(-134.366 -711.629)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M177.858,728.6v.709h-.743V728.6Z",
    transform: "translate(-167.807 -712.264)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M191.629,728.75v.726H190.9v-.726Z",
    transform: "translate(-179.061 -712.391)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M368.99,732.66v-.709h.743v.709Z",
    transform: "translate(-324.415 -715.004)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M417.824,726.635h-.713v-.707h.713Z",
    transform: "translate(-363.692 -710.088)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M245.707,730.511v-.719h.715v.719Z",
    transform: "translate(-223.792 -713.241)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M301.241,730.724v.71h-.72v-.71Z",
    transform: "translate(-268.531 -714.002)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M356.421,718.067v.681h-.677v-.681Z",
    transform: "translate(-313.604 -703.672)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M362.291,725.668v-.718h.715v.718Z",
    transform: "translate(-318.948 -709.289)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M253.525,723.168v.682h-.678v-.682Z",
    transform: "translate(-229.62 -707.835)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M293.949,723.867h.671v.678h-.671Z",
    transform: "translate(-263.167 -708.405)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M273.4,717.307v-.666h.686v.666Z",
    transform: "translate(-246.394 -702.507)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M239.825,722.92v.669h-.678v-.669Z",
    transform: "translate(-218.438 -707.633)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M300.881,717.149h.683v.669h-.683Z",
    transform: "translate(-268.825 -702.922)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M163.778,715.424v-.671h.7v.671Z",
    transform: "translate(-156.922 -700.967)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M143.889,721.89h-.669V721.2h.669Z",
    transform: "translate(-140.142 -706.23)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M411.194,719.727h-.675v-.68h.675Z",
    transform: "translate(-358.311 -704.471)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M184.288,722.673V722h.68v.67Z",
    transform: "translate(-173.662 -706.884)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M204.985,716.134v-.668h.679v.668Z",
    transform: "translate(-190.555 -701.549)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M156.876,721.453h.665v.674h-.665Z",
    transform: "translate(-151.288 -706.435)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M307.63,724.787v-.677h.68v.677Z",
    transform: "translate(-274.333 -708.604)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M218.608,716.432v-.664h.687v.664Z",
    transform: "translate(-201.674 -701.795)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M370.127,719.074h-.661V718.4h.661Z",
    transform: "translate(-324.804 -703.946)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M211.621,723.1v-.679h.685v.679Z",
    transform: "translate(-195.971 -707.225)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M246.774,716.2v.682H246.1V716.2Z",
    transform: "translate(-224.109 -702.147)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M342.682,717.852v.67h-.67v-.67Z",
    transform: "translate(-302.396 -703.496)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M328.94,718.352h-.672v-.667h.672Z",
    transform: "translate(-291.178 -703.36)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M315.3,717.423v.652h-.678v-.652Z",
    transform: "translate(-280.039 -703.146)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M287.882,716.881v.678h-.67v-.678Z",
    transform: "translate(-257.668 -702.703)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M280.9,724.278h-.652V723.6h.652Z",
    transform: "translate(-251.984 -708.188)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M266.43,724.119v-.658h.679v.658Z",
    transform: "translate(-240.706 -708.074)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M259.762,717.165v-.653h.678v.653Z",
    transform: "translate(-235.264 -702.402)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M171.286,721.685v.673h-.669v-.673Z",
    transform: "translate(-162.503 -706.625)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M232.4,715.9h.655v.678H232.4Z",
    transform: "translate(-212.928 -701.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M177.623,715.009h.654v.679h-.654Z",
    transform: "translate(-168.222 -701.176)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M226.1,722.691v.668h-.663v-.668Z",
    transform: "translate(-207.251 -707.446)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M198.736,722.227v.656h-.679v-.656Z",
    transform: "translate(-184.9 -707.067)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M191.317,715.228h.667v.659h-.667Z",
    transform: "translate(-179.399 -701.354)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M396.83,718.729h.659v.687h-.659Z",
    transform: "translate(-347.138 -704.212)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M383.037,719.269v-.66h.676v.66Z",
    transform: "translate(-335.881 -704.114)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M129.49,720.981h.677v.66h-.677Z",
    transform: "translate(-128.936 -706.05)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M294.883,710.285v.626h-.643v-.626Z",
    transform: "translate(-263.404 -697.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M239.452,709.342h.632v.625h-.632Z",
    transform: "translate(-218.687 -696.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M411.473,706.052h-.626v-.635h.626Z",
    transform: "translate(-358.579 -693.346)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M253.127,710.213v-.636h.632v.636Z",
    transform: "translate(-229.848 -696.742)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M404.483,712.871h-.642v-.633h.642Z",
    transform: "translate(-352.861 -698.914)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M185.326,709h-.612v-.644h.612Z",
    transform: "translate(-174.01 -695.744)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M307.938,710.483h.638v.633h-.638Z",
    transform: "translate(-274.585 -697.481)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M157.331,707.809h.62v.637h-.62Z",
    transform: "translate(-151.659 -695.299)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M137.216,714.451v.615h-.631v-.615Z",
    transform: "translate(-134.727 -700.72)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M129.873,708.085v-.618h.623v.618Z",
    transform: "translate(-129.248 -695.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M417.53,713.047v-.619h.638v.619Z",
    transform: "translate(-364.034 -699.069)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M171.614,708.142v.621h-.624v-.621Z",
    transform: "translate(-162.808 -695.571)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M225.787,709.025h.62v.631h-.62Z",
    transform: "translate(-207.533 -696.291)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M390.853,712v.62h-.624V712Z",
    transform: "translate(-341.751 -698.719)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M143.524,707.672h.632v.631h-.632Z",
    transform: "translate(-140.39 -695.187)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M363.39,712.113h-.625v-.621h.625Z",
    transform: "translate(-319.335 -698.305)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M397.147,705.927V705.3h.633v.626Z",
    transform: "translate(-347.397 -693.252)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M335.437,711.017h.62v.631h-.62Z",
    transform: "translate(-297.03 -697.917)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M198.331,708.633h.628v.622h-.628Z",
    transform: "translate(-185.124 -695.971)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M370.469,704.835v.6h-.6v-.6Z",
    transform: "translate(-325.137 -692.871)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M267.526,710.473h-.6v-.631h.6Z",
    transform: "translate(-241.108 -696.958)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M349,711.959v-.6h.641v.6Z",
    transform: "translate(-308.098 -698.198)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M281.225,710.744h-.615v-.6h.615Z",
    transform: "translate(-252.28 -697.205)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M376.537,711.679h.605v.633h-.605Z",
    transform: "translate(-330.575 -698.458)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M150.324,715.281v-.631h.6v.631Z",
    transform: "translate(-145.94 -700.882)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M322.366,711.445h-.6v-.621h.6Z",
    transform: "translate(-285.875 -697.76)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M212.741,709.5h-.613V708.9h.613Z",
    transform: "translate(-196.385 -696.187)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M363.216,697.817h.571v.6h-.571Z",
    transform: "translate(-319.703 -687.143)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M178,702.109v-.6h.585v.6Z",
    transform: "translate(-168.53 -690.161)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M390.51,698.969v-.579h.584v.579Z",
    transform: "translate(-341.98 -687.611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M260.251,703.49V702.9h.586v.588Z",
    transform: "translate(-235.663 -691.294)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M273.993,703.168h.567v.586h-.567Z",
    transform: "translate(-246.879 -691.511)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M280.874,697.1v-.574h.585v.574Z",
    transform: "translate(-252.495 -686.088)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M315.685,704.492H315.1v-.582h.585Z",
    transform: "translate(-280.431 -692.117)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M253.559,696.564v-.589h.585v.589Z",
    transform: "translate(-230.201 -685.64)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M267.2,696.83v-.576h.6v.576Z",
    transform: "translate(-241.336 -685.868)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M377.449,698.148v.577h-.593v-.577Z",
    transform: "translate(-330.836 -687.414)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M343.059,704.467v.567h-.587v-.567Z",
    transform: "translate(-302.771 -692.571)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M136.958,701.393v-.568h.587v.568Z",
    transform: "translate(-135.031 -689.599)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M219.718,702.245v.591h-.582v-.591Z",
    transform: "translate(-202.105 -690.758)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M404.221,699.2v-.584h.576v.584Z",
    transform: "translate(-353.171 -687.798)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M329.343,704.139v.589h-.586v-.589Z",
    transform: "translate(-291.577 -692.303)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M164.917,701.935h-.578v-.577h.578Z",
    transform: "translate(-157.379 -690.034)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M322.618,697.761h-.587v-.6h.587Z",
    transform: "translate(-286.088 -686.611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M226.057,696.183v-.567h.6v.567Z",
    transform: "translate(-207.754 -685.347)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M206.053,701.995v.58h-.593v-.58Z",
    transform: "translate(-190.942 -690.553)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M384.164,705.147v.567h-.588v-.567Z",
    transform: "translate(-336.321 -693.126)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M336.317,697.465v.576h-.581v-.576Z",
    transform: "translate(-297.274 -686.856)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M151.215,701.694h-.592v-.579h.592Z",
    transform: "translate(-146.184 -689.835)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M350.026,698.27h-.571v-.58h.571Z",
    transform: "translate(-308.471 -687.04)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M356.821,705.258h-.58v-.576h.58Z",
    transform: "translate(-314.01 -692.747)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M417.927,699.413c0-.142,0-.26,0-.378,0-.062.007-.125.012-.2.068-.005.121-.013.174-.014.128,0,.255,0,.4,0v.594Z",
    transform: "translate(-364.358 -687.961)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M191.806,702.289v-.575c.668-.088.637-.084.565.554a.926.926,0,0,1-.127.019C192.107,702.291,191.97,702.289,191.806,702.289Z",
    transform: "translate(-179.798 -690.292)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M233.42,702.559v.573h-.583v-.573Z",
    transform: "translate(-213.287 -691.014)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M295.208,697.4h-.575v-.574h.575Z",
    transform: "translate(-263.725 -686.335)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M287.692,703.455h.567v.577h-.567Z",
    transform: "translate(-258.06 -691.745)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M308.418,696.936h.571v.58h-.571Z",
    transform: "translate(-274.977 -686.424)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M247.209,702.79v.555h-.586v-.555Z",
    transform: "translate(-224.54 -691.202)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M239.8,696.314v-.577h.575v.577Z",
    transform: "translate(-218.971 -685.446)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M301.443,703.731H302c.093.675.076.638-.556.567Z",
    transform: "translate(-269.284 -691.97)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M130.887,694.5h-.528v-.548h.528Z",
    transform: "translate(-129.645 -683.987)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M165.244,688.244h-.534v-.539h.534Z",
    transform: "translate(-157.682 -678.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M199.378,695.689h-.533v-.548h.533Z",
    transform: "translate(-185.543 -684.959)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M220.063,689.218h-.549v-.539h.549Z",
    transform: "translate(-202.413 -679.684)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M261.184,689.921h-.532v-.556h.532Z",
    transform: "translate(-235.99 -680.245)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M192.113,688.13h.536v.556h-.536Z",
    transform: "translate(-180.049 -679.237)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M383.874,691.916c-.054-.6-.025-.63.522-.528v.528Z",
    transform: "translate(-336.548 -681.859)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M329.686,690.633v.542h-.519v-.542Z",
    transform: "translate(-291.912 -681.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M356.528,691.63v-.517h.541v.517Z",
    transform: "translate(-314.244 -681.672)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M205.793,688.986v-.516h.54v.516Z",
    transform: "translate(-191.214 -679.514)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M411.9,692.556h-.537v-.54h.537Z",
    transform: "translate(-358.999 -682.408)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M315.975,690.986h-.528v-.521h.528Z",
    transform: "translate(-280.714 -681.143)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M144.587,694.25v.515h-.539v-.515Z",
    transform: "translate(-140.818 -684.232)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M158.28,694.445v.529h-.526v-.529Z",
    transform: "translate(-152.005 -684.391)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M370.219,691.88v-.535h.541v.535Z",
    transform: "translate(-325.419 -681.861)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M185.7,694.973v.537h-.541v-.537Z",
    transform: "translate(-174.374 -684.822)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M274.331,689.591h.519v.533h-.519Z",
    transform: "translate(-247.155 -680.429)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M247.5,689.264v.511h-.54v-.511Z",
    transform: "translate(-224.814 -680.162)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M288.145,689.853h.51v.529h-.51Z",
    transform: "translate(-258.43 -680.643)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M171.52,694.732h.525v.522h-.525Z",
    transform: "translate(-163.241 -684.625)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M342.919,690.759h.518v.539h-.518Z",
    transform: "translate(-303.136 -681.383)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M233.342,688.9h.513v.537h-.513Z",
    transform: "translate(-213.7 -679.867)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M137.876,687.784h-.529v-.526h.529Z",
    transform: "translate(-135.349 -678.525)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M301.717,690.666v-.535h.541v.535Z",
    transform: "translate(-269.507 -680.87)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M151.538,688H151v-.54h.541Z",
    transform: "translate(-146.49 -678.693)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M397.7,692.324v-.51h.53v.51Z",
    transform: "translate(-347.846 -682.244)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M179.011,688.022v.516h-.525v-.516Z",
    transform: "translate(-168.926 -679.149)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M213.106,695.447v.511h-.53v-.511Z",
    transform: "translate(-196.75 -685.209)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M329.415,677.487V677h.517v.483Z",
    transform: "translate(-292.114 -670.156)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M144.466,680.589h.49v.491h-.49Z",
    transform: "translate(-141.159 -673.082)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M418.986,685.929H418.5v-.494h.484Z",
    transform: "translate(-364.826 -677.037)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M213.375,682.3h-.485v-.5h.485Z",
    transform: "translate(-197.007 -674.074)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M315.793,677.311v-.475h.5v.475Z",
    transform: "translate(-280.996 -670.019)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M322.48,683.773h.49v.474h-.49Z",
    transform: "translate(-286.454 -675.681)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M268.188,683.38h-.49V682.9h.49Z",
    transform: "translate(-241.741 -674.966)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M226.646,682.08h.476v.5h-.476Z",
    transform: "translate(-208.234 -674.299)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M398,678.69V678.2h.493v.487Z",
    transform: "translate(-348.092 -671.134)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M363.67,684.445h.5v.473h-.5Z",
    transform: "translate(-320.073 -676.229)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M199.235,681.656h.49v.475h-.49Z",
    transform: "translate(-185.862 -673.953)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M349.99,684.225h.473v.488h-.473Z",
    transform: "translate(-308.908 -676.05)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M405.264,685.121v.494h-.48v-.494Z",
    transform: "translate(-353.63 -676.781)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M411.716,678.957v-.491h.484v.491Z",
    transform: "translate(-359.288 -671.349)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M384.764,678.514h-.493v-.479h.493Z",
    transform: "translate(-336.888 -670.997)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M371.116,678.265h-.492v-.484h.492Z",
    transform: "translate(-325.749 -670.79)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M281.5,682.987h.471v.493H281.5Z",
    transform: "translate(-253.004 -675.039)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M377.274,685.224v-.474h.494v.474Z",
    transform: "translate(-331.177 -676.478)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M158.212,680.867h.475v.5h-.475Z",
    transform: "translate(-152.379 -673.309)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M308.833,684.02v-.471h.492v.471Z",
    transform: "translate(-275.315 -675.498)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M343.746,677.26v.49h-.484v-.49Z",
    transform: "translate(-303.416 -670.365)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M254.026,683.041v-.473h.493v.473Z",
    transform: "translate(-230.582 -674.696)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M357.419,677.989h-.471v-.481h.471Z",
    transform: "translate(-314.587 -670.567)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M130.69,680.936v-.472h.482v.472Z",
    transform: "translate(-129.915 -672.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M240.38,682.314h.475v.484h-.475Z",
    transform: "translate(-219.444 -674.49)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M186.019,681.846h-.476v-.485h.476Z",
    transform: "translate(-174.686 -673.712)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M295.126,683.736v-.469h.479v.469Z",
    transform: "translate(-264.128 -675.268)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M336.3,684.065h.478v.476H336.3Z",
    transform: "translate(-297.734 -675.919)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M302.581,676.608v.468h-.488v-.468Z",
    transform: "translate(-269.814 -669.833)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M172.31,681.1v.485h-.485V681.1Z",
    transform: "translate(-163.489 -673.501)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M391.584,685.015v.469h-.479v-.469Z",
    transform: "translate(-342.466 -676.694)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M234.216,675.435v.432h-.442v-.432Z",
    transform: "translate(-214.052 -668.875)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M179.407,674.984h-.427v-.445h.427Z",
    transform: "translate(-169.329 -668.144)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M240.722,668.77h.439v.435h-.439Z",
    transform: "translate(-219.723 -663.435)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M295.964,670.143h-.443v-.436h.443Z",
    transform: "translate(-264.45 -664.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M227.431,668.93h-.42v-.436h.42Z",
    transform: "translate(-208.532 -663.21)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M309.346,669.988h.42v.436h-.42Z",
    transform: "translate(-275.734 -664.429)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M350.319,671.2v-.418h.443v.418Z",
    transform: "translate(-309.176 -665.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M364.156,670.9h.42v.435h-.42Z",
    transform: "translate(-320.47 -665.172)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M172.194,667.533h.423v.446h-.423Z",
    transform: "translate(-163.791 -662.425)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M405.144,671.654h.437v.421h-.437Z",
    transform: "translate(-353.924 -665.789)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M418.964,671.789h.42v.438h-.42Z",
    transform: "translate(-365.204 -665.899)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M131.078,667.336v-.417h.443v.417Z",
    transform: "translate(-130.232 -661.924)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M185.893,668.244v-.418h.442v.418Z",
    transform: "translate(-174.972 -662.665)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M288.571,676.51h.442v.417h-.442Z",
    transform: "translate(-258.778 -669.753)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M158.51,667.236h.422v.446h-.422Z",
    transform: "translate(-152.622 -662.183)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M247.5,676.211v-.431h.437v.431Z",
    transform: "translate(-225.254 -669.157)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M220.035,675.751v-.421h.43v.421Z",
    transform: "translate(-202.838 -668.79)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M377.775,671.1h.416v.426h-.416Z",
    transform: "translate(-331.586 -665.333)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M268.161,669.211h.415v.424h-.415Z",
    transform: "translate(-242.119 -663.795)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M192.721,675.163v-.42h.419v.42Z",
    transform: "translate(-180.545 -668.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M391.853,671.841h-.419v-.43h.419Z",
    transform: "translate(-342.734 -665.591)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M261.137,676.41v-.415h.425v.415Z",
    transform: "translate(-236.386 -669.332)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M165.692,674.409v.416h-.425v-.416Z",
    transform: "translate(-158.137 -668.038)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M200.115,668.133v.42h-.43v-.42Z",
    transform: "translate(-186.229 -662.915)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M281.841,669.5h.419v.43h-.419Z",
    transform: "translate(-253.284 -664.027)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M337.08,670.462v.419h-.429v-.419Z",
    transform: "translate(-298.02 -664.816)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M213.29,668.757v-.422h.43v.422Z",
    transform: "translate(-197.333 -663.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M206.784,675.059v.426h-.43v-.426Z",
    transform: "translate(-191.672 -668.568)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M275.3,676.218v.419h-.43v-.419Z",
    transform: "translate(-247.598 -669.514)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M137.931,673.814h.421v.429h-.421Z",
    transform: "translate(-135.825 -667.552)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M145.332,667.131v.419H144.9v-.419Z",
    transform: "translate(-141.517 -662.098)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M254.495,669.41v-.421h.42v.421Z",
    transform: "translate(-230.965 -663.614)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M323.36,670.2v.419h-.429V670.2Z",
    transform: "translate(-286.822 -664.606)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M151.541,674.5v-.428h.428v.428Z",
    transform: "translate(-146.934 -667.765)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M398.477,665.158v-.4h.4v.4Z",
    transform: "translate(-348.483 -660.162)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M392.233,657.851v.38h-.391v-.38Z",
    transform: "translate(-343.067 -654.523)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M330.05,663.622h.384V664h-.384Z",
    transform: "translate(-292.633 -659.233)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M385.255,664.579v.371h-.39v-.371Z",
    transform: "translate(-337.373 -660.015)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M248.223,662.116v.4h-.391v-.4Z",
    transform: "translate(-225.526 -658.004)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M316.335,663.723v-.4h.373v.4Z",
    transform: "translate(-281.439 -658.989)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M138.225,660.174h.376v.409h-.376Z",
    transform: "translate(-136.065 -656.419)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M288.862,663.249v-.381h.4v.381Z",
    transform: "translate(-259.015 -658.618)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M234.483,662v.36h-.4V662Z",
    transform: "translate(-214.305 -657.907)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M179.384,661.3v-.392h.374v.392Z",
    transform: "translate(-169.659 -657.021)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M344.1,663.876v.362h-.4v-.362Z",
    transform: "translate(-303.772 -659.441)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M261.924,662.41v.382h-.366v-.382Z",
    transform: "translate(-236.73 -658.244)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M275.242,662.645h.379v.364h-.379Z",
    transform: "translate(-247.898 -658.436)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M220.408,662.1v-.361h.382v.361Z",
    transform: "translate(-203.143 -657.701)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M378.113,657.95v-.383h.373v.383Z",
    transform: "translate(-331.862 -654.291)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M207.083,661.862h-.374v-.392h.374Z",
    transform: "translate(-191.963 -657.477)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M405.487,658.075h.388v.37h-.388Z",
    transform: "translate(-354.204 -654.706)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M193.434,661.2v.385h-.379V661.2Z",
    transform: "translate(-180.817 -657.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M166.024,660.781v.366h-.383v-.366Z",
    transform: "translate(-158.442 -656.915)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M303.041,663.188v.362h-.385v-.362Z",
    transform: "translate(-270.274 -658.879)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M371.532,664.774h-.366V664.4h.366Z",
    transform: "translate(-326.192 -659.868)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M364.808,657.418v.367h-.39v-.367Z",
    transform: "translate(-320.684 -654.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M419.207,658.7v-.364h.382v.364Z",
    transform: "translate(-365.403 -654.918)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M151.88,660.916v-.363h.378v.363Z",
    transform: "translate(-147.21 -656.728)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M412.231,665.438v-.359h.382v.359Z",
    transform: "translate(-359.709 -660.423)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M357.838,664.489h-.385v-.382h.385Z",
    transform: "translate(-314.999 -659.629)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M296.409,656.643h-.336V656.3h.336Z",
    transform: "translate(-264.901 -653.256)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M159.342,653.758v.354H159v-.339Z",
    transform: "translate(-153.023 -651.182)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M330.714,650.376h-.334v-.343h.334Z",
    transform: "translate(-292.902 -648.142)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M412.984,651.435v.342h-.346v-.342Z",
    transform: "translate(-360.041 -649.286)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M425.443,665.438v-.359h.382v.359Z",
    transform: "translate(-370.492 -660.423)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M424.906,651.435v.342h-.346v-.342Z",
    transform: "translate(-369.772 -649.286)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M214.124,654.88v.337h-.347v-.337Z",
    transform: "translate(-197.731 -652.098)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M268.553,656.121v-.334h.344v.334Z",
    transform: "translate(-242.439 -652.839)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M357.865,650.527h.338v.345l-.338.017Z",
    transform: "translate(-315.335 -648.545)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M221.082,648.451h-.343v-.345h.343Z",
    transform: "translate(-203.413 -646.569)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M262.266,648.822v.338h-.328v-.338Z",
    transform: "translate(-237.04 -647.154)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M207.1,647.878h.328v.341H207.1Z",
    transform: "translate(-192.277 -646.383)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M275.56,649.078h.335v.331h-.335Z",
    transform: "translate(-248.158 -647.363)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M200.113,654.9v-.331h.335v.331Z",
    transform: "translate(-186.578 -651.842)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M350.841,657.6v-.321h.345v.321Z",
    transform: "translate(-309.602 -654.052)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M145.667,653.649v.334h-.332v-.334Z",
    transform: "translate(-141.868 -651.094)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M227.8,655.1v.334h-.333c-.005-.1-.011-.206-.017-.334Z",
    transform: "translate(-208.89 -652.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M398.975,651.205h.321v.345h-.321Z",
    transform: "translate(-348.889 -649.099)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M371.518,651.094v-.324h.336v.324Z",
    transform: "translate(-326.479 -648.744)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M289.324,649.649v-.339h.323v.339Z",
    transform: "translate(-259.392 -647.552)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M248.2,648.606h.341v.325H248.2Z",
    transform: "translate(-225.824 -646.977)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M303.368,649.88h-.344v-.335h.344Z",
    transform: "translate(-270.574 -647.744)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M254.924,655.947v-.32h.335v.32Z",
    transform: "translate(-231.315 -652.708)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M186.805,654.4v.329l-.345.017V654.4Z",
    transform: "translate(-175.435 -651.704)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M282.688,656.084v.318h-.327v-.318Z",
    transform: "translate(-253.709 -653.081)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M344.142,650.574v-.344h.319v.344Z",
    transform: "translate(-304.135 -648.303)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M337.515,657v.339h-.324V657Z",
    transform: "translate(-298.461 -653.825)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M316.739,649.852h.327v.316h-.327Z",
    transform: "translate(-281.768 -647.994)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M241.237,655.357h.344v.318h-.344Z",
    transform: "translate(-220.144 -652.488)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M310.108,656.843h-.319v-.327h.319Z",
    transform: "translate(-276.096 -653.433)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M131.618,653.478h.345v.317h-.345Z",
    transform: "translate(-130.673 -650.954)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M385.521,651.073v.312h-.346v-.312Z",
    transform: "translate(-337.625 -648.991)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M323.358,657.183v-.315h.351v.315Z",
    transform: "translate(-287.171 -653.721)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M234.419,648.393h.346v.318h-.33Z",
    transform: "translate(-214.579 -646.804)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M172.991,654.195v.308h-.334l-.016-.308Z",
    transform: "translate(-164.156 -651.539)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M351.159,643.934v-.287h.305v.287Z",
    transform: "translate(-309.862 -642.93)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M364.807,644.1a.747.747,0,0,1-.017-.111c0-.053.006-.107.01-.175a1.139,1.139,0,0,1,.13-.025,1.54,1.54,0,0,1,.157.006v.3Z",
    transform: "translate(-320.987 -643.042)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M173.084,640.821v-.286h.291v.286Z",
    transform: "translate(-164.517 -640.39)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M255.463,642.365h-.291c-.006-.095-.011-.18-.018-.287h.309Z",
    transform: "translate(-231.503 -641.649)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M166.142,647.591v-.308h.291c.005.1.01.177.016.282Z",
    transform: "translate(-158.851 -645.898)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M296.672,642.932h-.313l-.013-.283.3-.025Z",
    transform: "translate(-265.124 -642.095)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M282.693,642.663v-.308l.292-.016.021.3Z",
    transform: "translate(-253.98 -641.862)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M419.991,645.065h-.309v-.291l.286-.018C419.976,644.86,419.982,644.947,419.991,645.065Z",
    transform: "translate(-365.79 -643.835)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M193.379,647.77h.308l.017.295-.306.014C193.391,647.973,193.386,647.886,193.379,647.77Z",
    transform: "translate(-181.082 -646.295)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M180.161,647.535c0,.1-.009.184-.013.28h-.292v-.28Z",
    transform: "translate(-170.044 -646.103)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M227.887,641.862v-.3h.293v.281Z",
    transform: "translate(-209.247 -641.229)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M241.859,641.963h-.305c-.005-.1-.01-.183-.016-.292l.306-.016Z",
    transform: "translate(-220.389 -641.303)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M310.283,642.842v.3c-.243.067-.362.013-.284-.277Z",
    transform: "translate(-276.248 -642.273)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M186.726,641.124c0-.113.009-.194.013-.288h.293v.288Z",
    transform: "translate(-175.652 -640.636)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M159.6,640.638h-.269c-.006-.092-.012-.178-.02-.288h.289Z",
    transform: "translate(-153.279 -640.239)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M392.327,644.69V644.4h.288v.275Z",
    transform: "translate(-343.463 -643.545)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M378.617,644.462v-.281h.28v.281Z",
    transform: "translate(-332.273 -643.366)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M200.738,641.347h-.307v-.27h.292Z",
    transform: "translate(-186.838 -640.832)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M405.968,644.637a1.108,1.108,0,0,1,.123-.015c.054,0,.107.005.179.01v.278h-.3Z",
    transform: "translate(-354.597 -643.726)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M138.662,646.786h.276v.259C138.633,647.108,138.631,647.106,138.662,646.786Z",
    transform: "translate(-136.411 -645.492)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M132.232,640.043h-.3c-.006-.088-.011-.166-.019-.271l.307-.027C132.223,639.846,132.227,639.932,132.232,640.043Z",
    transform: "translate(-130.912 -639.745)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M145.622,640.346v-.268l.291-.021c.005.1.01.184.015.289Z",
    transform: "translate(-142.103 -640)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M214.2,641.466v-.305l.275-.012v.3Z",
    transform: "translate(-198.076 -640.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M337.755,643.726h-.282q-.006-.132-.012-.256C337.783,643.4,337.786,643.407,337.755,643.726Z",
    transform: "translate(-298.682 -642.758)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M268.948,642.269h.29c0,.09.008.168.013.269h-.289Z",
    transform: "translate(-242.761 -641.805)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M323.837,643.475v-.266h.275v.266Z",
    transform: "translate(-287.562 -642.572)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M152.671,647.424h-.29c0-.091-.009-.169-.014-.269h.29C152.661,647.238,152.665,647.316,152.671,647.424Z",
    transform: "translate(-147.608 -645.793)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(66.466)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M716.547,814.883h-.983v-1.224h.983Z",
    transform: "translate(-661.406 -781.693)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M717,801.448h-.881v-1.113H717Z",
    transform: "translate(-661.859 -770.819)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M717.294,787.766h-.815v-1.058h.815Z",
    transform: "translate(-662.152 -759.696)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M717.581,774.084h-.751v-1h.751Z",
    transform: "translate(-662.439 -748.575)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M718.028,760.649h-.65v-.891h.65Z",
    transform: "translate(-662.886 -737.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M718.366,747.022l-.574-.026v-.837l.574-.028Z",
    transform: "translate(-663.224 -726.577)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M718.766,733.531h-.483v-.724h.483Z",
    transform: "translate(-663.625 -715.702)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M719.063,719.9l-.417-.032v-.691h.417Z",
    transform: "translate(-663.921 -704.581)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M719.313,706.222h-.361v-.634l.361-.034Z",
    transform: "translate(-664.171 -693.458)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M719.772,692.786l-.257-.017v-.525l.257-.015Z",
    transform: "translate(-664.63 -682.582)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M719.983,679.1c-.159.038-.22-.028-.208-.187s-.053-.335.208-.314Z",
    transform: "translate(-664.841 -671.454)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M694.555,821.347c0-.351.016-.7.008-1.053,0-.171.056-.227.224-.222.339.01.679,0,1.043,0v1.271l.008-.009h-1.289Z",
    transform: "translate(-644.252 -786.928)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M680.916,821.185v-1.249h1.244v1.24h-1.253Z",
    transform: "translate(-633.119 -786.817)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M709.724,821.7l-1.2-.055v-1.229h1.2q0,.645,0,1.289Z",
    transform: "translate(-655.66 -787.207)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M598.961,819.839v-1.176h1.19v1.176Z",
    transform: "translate(-566.234 -785.778)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M551.082,812.155v-1.182h1.2v1.182Z",
    transform: "translate(-527.155 -779.501)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M669.2,820.4h-1.214v-1.208H669.2Z",
    transform: "translate(-622.572 -786.21)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M605.9,813.122v-1.176h1.2v1.176Z",
    transform: "translate(-571.896 -780.295)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M661.929,814.067h-1.187v-1.189h1.187Z",
    transform: "translate(-616.66 -781.056)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M475.718,816.447h1.173v1.2h-1.173Z",
    transform: "translate(-465.643 -783.969)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M490.58,818h-1.208V816.8h1.2v1.217Z",
    transform: "translate(-476.788 -784.254)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M653.755,820.781V819.61h1.2v1.171Z",
    transform: "translate(-610.957 -786.551)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M545.365,817.7v1.177h-1.19V817.7Z",
    transform: "translate(-521.518 -784.989)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M612.665,820.059v-1.17h1.18v1.17Z",
    transform: "translate(-577.419 -785.962)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M531.738,817.5v1.164h-1.174V817.5Z",
    transform: "translate(-510.409 -784.827)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M648.323,812.619V813.8h-1.17v-1.179Z",
    transform: "translate(-605.569 -780.845)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M701.877,814.736V813.55h1.18v1.186Z",
    transform: "translate(-650.234 -781.605)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M675.652,813.162v1.17h-1.179v-1.17Z",
    transform: "translate(-627.867 -781.288)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M620.84,813.351h-1.174v-1.2h1.174Z",
    transform: "translate(-583.134 -780.465)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M420.905,815.547h1.178v1.179h-1.178Z",
    transform: "translate(-420.905 -783.234)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M559.049,817.944v1.185h-1.18v-1.185Z",
    transform: "translate(-532.695 -785.191)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M510.021,810.17h1.172v1.2h-1.172Z",
    transform: "translate(-493.642 -778.846)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M585.311,819.562V818.4h1.177v1.167Z",
    transform: "translate(-555.093 -785.559)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M592.3,811.708h1.178v1.177H592.3Z",
    transform: "translate(-560.799 -780.101)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M538.7,810.738v1.169h-1.178v-1.169Z",
    transform: "translate(-516.085 -779.309)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M564.855,811.252h1.174v1.158h-1.174Z",
    transform: "translate(-538.397 -779.729)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M462.042,816.246h1.16v1.18h-1.16Z",
    transform: "translate(-454.481 -783.805)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M503.062,816.984h1.171v1.166h-1.171Z",
    transform: "translate(-487.961 -784.407)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M640.17,819.41h1.173v1.16H640.17Z",
    transform: "translate(-599.869 -786.387)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M626.47,819.11h1.157V820.3H626.47Z",
    transform: "translate(-588.687 -786.143)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M524.954,811.671h-1.16v-1.179h1.16Z",
    transform: "translate(-504.883 -779.109)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M579.787,812.6h-1.162v-1.177h1.162Z",
    transform: "translate(-549.636 -779.865)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M448.277,816.1h1.172v1.156h-1.172Z",
    transform: "translate(-443.246 -783.688)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M516.842,817.145H518v1.187h-1.16Z",
    transform: "translate(-499.209 -784.539)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M435.75,815.792v1.165h-1.191v-1.165Z",
    transform: "translate(-432.049 -783.435)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M633.423,812.444h1.16v1.16h-1.16Z",
    transform: "translate(-594.362 -780.702)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M489.732,803.136h1.135v1.134h-1.135Z",
    transform: "translate(-477.082 -773.105)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M476.056,802.908h1.13v1.125h-1.13Z",
    transform: "translate(-465.919 -772.919)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M689.391,814.563h-1.162V813.4h1.162Z",
    transform: "translate(-639.095 -781.484)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M530.827,804.979V803.85h1.139v1.129Z",
    transform: "translate(-510.623 -773.687)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M695.226,807.92V806.8h1.144v1.12Z",
    transform: "translate(-644.806 -776.095)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M422.347,803.071h-1.13v-1.142h1.13Z",
    transform: "translate(-421.16 -772.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M429.1,810.033h-1.13v-1.14h1.13Z",
    transform: "translate(-426.671 -777.804)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M626.784,806.737v-1.126h1.131v1.126Z",
    transform: "translate(-588.943 -775.125)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M681.617,807.609v-1.131h1.125v1.131Z",
    transform: "translate(-633.698 -775.832)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M640.435,805.8h1.143v1.134h-1.143Z",
    transform: "translate(-600.085 -775.277)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M571.63,819.389v-1.158h1.158v1.158Z",
    transform: "translate(-543.927 -785.425)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M483.934,809.9v1.133H482.8V809.9Z",
    transform: "translate(-471.425 -778.624)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M517.2,804.822V803.7h1.119v1.122Z",
    transform: "translate(-499.5 -773.565)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M573.156,805.722h-1.119V804.58h1.119Z",
    transform: "translate(-544.259 -774.283)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M599.343,806.182v-1.135h1.131v1.135Z",
    transform: "translate(-566.546 -774.664)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M544.55,804.1h1.125v1.122H544.55Z",
    transform: "translate(-521.824 -773.894)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M462.382,802.6H463.5v1.131h-1.121Z",
    transform: "translate(-454.759 -772.667)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M455.442,809.435h1.122v1.133h-1.122Z",
    transform: "translate(-449.094 -778.246)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M448.713,802.455h1.131v1.13h-1.131Z",
    transform: "translate(-443.602 -772.549)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M710.115,808.139h-1.129V807h1.129Z",
    transform: "translate(-656.037 -776.259)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M436.09,803.4h-1.124v-1.119h1.124Z",
    transform: "translate(-432.382 -772.41)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M558.328,804.346h1.1v1.142h-1.1Z",
    transform: "translate(-533.07 -774.092)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M613.14,805.315h1.1v1.122h-1.1Z",
    transform: "translate(-577.807 -774.883)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M669.049,807.423h-1.1v-1.132h1.1Z",
    transform: "translate(-622.538 -775.68)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M496.565,810.111h1.1v1.137h-1.1Z",
    transform: "translate(-482.659 -778.798)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M470.2,810.877h-1.136v-1.106H470.2Z",
    transform: "translate(-460.211 -778.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M586.774,806.013h-1.14v-1.106h1.14Z",
    transform: "translate(-555.357 -774.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M504.618,804.58h-1.1v-1.123h1.1Z",
    transform: "translate(-488.335 -773.367)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M654.149,807.212V806.1h1.133v1.108Z",
    transform: "translate(-611.279 -775.527)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M441.771,809.185h1.1v1.124h-1.1Z",
    transform: "translate(-437.936 -778.042)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M696.736,794.242h-1.071v-1.088h1.071Z",
    transform: "translate(-645.164 -764.957)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M676.076,800.821h-1.071v-1.08h1.071Z",
    transform: "translate(-628.301 -770.334)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M456.814,796.957h-1.075v-1.086h1.075Z",
    transform: "translate(-449.337 -767.175)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M510.566,796.774h1.078v1.077h-1.078Z",
    transform: "translate(-494.086 -767.912)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M628.205,791.974v1.075h-1.087v-1.075Z",
    transform: "translate(-589.216 -763.994)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M683.034,794.023h-1.07v-1.089h1.07Z",
    transform: "translate(-633.981 -764.778)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M566.44,797.795v1.072h-1.088v-1.072Z",
    transform: "translate(-538.803 -768.745)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M621.256,799.763h-1.072v-1.081h1.072Z",
    transform: "translate(-583.557 -769.469)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M443.216,795.594v1.08h-1.077v-1.08Z",
    transform: "translate(-438.236 -766.949)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M702.447,801.212v-1.073h1.083v1.073Z",
    transform: "translate(-650.7 -770.659)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M709.409,794.547v-1.075h1.074v1.075Z",
    transform: "translate(-656.382 -765.217)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M580.148,799.074h-1.074V797.99h1.074Z",
    transform: "translate(-550.003 -768.904)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M641.931,792.243v1.082h-1.078v-1.082Z",
    transform: "translate(-600.426 -764.214)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M524.243,798.189v-1.073h1.083v1.073Z",
    transform: "translate(-505.249 -768.191)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M647.6,800.309V799.24h1.088v1.069Z",
    transform: "translate(-605.932 -769.925)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M573.4,791.072v1.072h-1.087v-1.072Z",
    transform: "translate(-544.485 -763.258)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M469.413,797.208v-1.069H470.5v1.069Z",
    transform: "translate(-460.497 -767.394)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M668.236,793.873V792.8h1.081v1.07Z",
    transform: "translate(-622.777 -764.671)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M592.866,798.225h1.071V799.3h-1.071Z",
    transform: "translate(-561.26 -769.096)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M483.215,796.262H484.3v1.075h-1.081Z",
    transform: "translate(-471.762 -767.494)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M428.372,796.461V795.4h1.084v1.064Z",
    transform: "translate(-427 -766.788)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M662.372,799.478v1.065h-1.083v-1.065Z",
    transform: "translate(-617.106 -770.119)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M688.7,799.893h1.073v1.072H688.7Z",
    transform: "translate(-639.477 -770.458)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M586.024,791.259H587.1v1.077h-1.081Z",
    transform: "translate(-555.675 -763.411)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M634.945,799.013v1.071h-1.082v-1.071Z",
    transform: "translate(-594.721 -769.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M607.565,799.61H606.5v-1.079h1.069Z",
    transform: "translate(-572.384 -769.346)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M496.829,797.65v-1.076H497.9v1.076Z",
    transform: "translate(-482.874 -767.749)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M551.689,797.473h1.071v1.076h-1.071Z",
    transform: "translate(-527.651 -768.482)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M538.037,797.3h1.077v1.077h-1.077Z",
    transform: "translate(-516.508 -768.342)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M614.514,791.747v1.069h-1.086v-1.069Z",
    transform: "translate(-578.042 -763.809)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M654.609,792.473h1.081v1.076h-1.081Z",
    transform: "translate(-611.654 -764.402)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M600.875,792.661h-1.083v-1.076h1.083Z",
    transform: "translate(-566.913 -763.677)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M538.415,783.713h1.017v1.031h-1.017Z",
    transform: "translate(-516.817 -757.252)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M421.855,788.488h1.013v1.033h-1.013Z",
    transform: "translate(-421.68 -761.149)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M435.438,789.873v-1.019h1.029v1.019Z",
    transform: "translate(-432.767 -761.448)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M606.844,784.959h1.024v1.023h-1.024Z",
    transform: "translate(-572.668 -758.269)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M703.864,787.632h-1.021v-1.021h1.021Z",
    transform: "translate(-651.023 -759.617)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M484.643,783.81h-1.014v-1.023h1.014Z",
    transform: "translate(-472.1 -756.496)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M429.818,781.9v1.015h-1.033V781.9Z",
    transform: "translate(-427.337 -755.775)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M532.473,790.424v1.022h-1.028v-1.022Z",
    transform: "translate(-511.128 -762.729)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M546.087,790.762v1.019h-1.031v-1.019Z",
    transform: "translate(-522.237 -763.005)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M443.435,783.075h-1.026v-1.024h1.026Z",
    transform: "translate(-438.457 -755.895)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M649.063,786.7h-1.014v-1.033h1.014Z",
    transform: "translate(-606.3 -758.846)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M476.636,789.514h1.018v1.023h-1.018Z",
    transform: "translate(-466.393 -761.987)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M662.676,786.914h-1.017v-1.031h1.017Z",
    transform: "translate(-617.408 -759.023)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M490.283,789.7H491.3v1.032h-1.014Z",
    transform: "translate(-477.531 -762.137)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M552.05,783.983h1.019v1.028H552.05Z",
    transform: "translate(-527.946 -757.472)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M456.115,783.3v-1.016h1.025V783.3Z",
    transform: "translate(-449.643 -756.085)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M470.923,783.614H469.9v-1.022h1.021Z",
    transform: "translate(-460.896 -756.337)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M497.253,783.038h1.014v1.033h-1.014Z",
    transform: "translate(-483.22 -756.701)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M524.729,783.429h1.015v1.032h-1.015Z",
    transform: "translate(-505.646 -757.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M593.188,785.7v-1.018h1.032V785.7Z",
    transform: "translate(-561.522 -758.042)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M450.183,790.058h-1.019V789.04h1.019Z",
    transform: "translate(-443.97 -761.6)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M580.533,784.471v1.016h-1.026v-1.016Z",
    transform: "translate(-550.356 -757.87)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M676.406,786.118v1.024h-1.02v-1.024Z",
    transform: "translate(-628.612 -759.214)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M510.9,784.3v-1.008h1.026V784.3Z",
    transform: "translate(-494.357 -756.906)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M558.8,790.963h1.013v1.023H558.8Z",
    transform: "translate(-533.458 -763.169)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M463.958,789.326v1.013h-1.03v-1.013Z",
    transform: "translate(-455.204 -761.833)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M635.384,786.306h-1.035v-1.04c.3,0,.593-.007.885.007a.207.207,0,0,1,.144.141C635.391,785.706,635.384,786,635.384,786.306Z",
    transform: "translate(-595.118 -758.517)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M566.768,785.215H565.75V784.2h1.018Z",
    transform: "translate(-539.127 -757.647)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M689.16,786.415h1.016v1.016H689.16Z",
    transform: "translate(-639.854 -759.457)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M620.572,785.205h1.015v1.025h-1.015Z",
    transform: "translate(-583.873 -758.469)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M504.974,791.1h-1.016v-1.02h1.016Z",
    transform: "translate(-488.693 -762.446)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M518.775,791.228h-1.017V790.2h1.017Z",
    transform: "translate(-499.956 -762.547)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M649.317,772.077v.987h-.983v-.987Z",
    transform: "translate(-606.533 -747.754)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M586.5,778.811v-.989h.984v.989Z",
    transform: "translate(-556.067 -752.443)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M655.068,780v-.986h.963V780Z",
    transform: "translate(-612.029 -753.42)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M573.84,777.661v.965h-.985v-.965Z",
    transform: "translate(-544.927 -752.312)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M703.088,774.09v-.961h.984v.961Z",
    transform: "translate(-651.223 -748.613)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M463.268,776.677v-.964h.974v.964Z",
    transform: "translate(-455.482 -750.722)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M689.459,772.763h.976v.985h-.976Z",
    transform: "translate(-640.099 -748.314)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M477.926,775.907v.978h-.986v-.978Z",
    transform: "translate(-466.641 -750.88)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M676.8,773.545h-.957v-.976h.957Z",
    transform: "translate(-628.984 -748.156)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M545.42,778.1v-.97h.975v.97Z",
    transform: "translate(-522.534 -751.876)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M504.41,777.405v-.978h.965v.978Z",
    transform: "translate(-489.062 -751.305)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M435.808,776.231v-.975h.971v.975Z",
    transform: "translate(-433.069 -750.349)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M628.673,779.6H627.7v-.974h.977Z",
    transform: "translate(-589.687 -753.095)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M518.056,776.707h.975v.971h-.975Z",
    transform: "translate(-500.2 -751.533)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M423.122,774.98v.967h-.98v-.967Z",
    transform: "translate(-421.915 -750.124)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M531.7,777.874v-.963h.984v.963Z",
    transform: "translate(-511.333 -751.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M696.174,779.742h.981v.985h-.981Z",
    transform: "translate(-645.58 -754.011)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M614.013,779.324v-.975h.971v.975Z",
    transform: "translate(-578.52 -752.874)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M642.351,778.883v.961h-.985v-.961Z",
    transform: "translate(-600.845 -753.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M491.63,777.187h-.954v-.973h.954Z",
    transform: "translate(-477.852 -751.131)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M683.447,780.513h-.981v-.968h.981Z",
    transform: "translate(-634.391 -753.85)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M559.216,778.389v-.962h.972v.962Z",
    transform: "translate(-533.794 -752.121)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M601.249,778.147v.95h-.971v-.95Z",
    transform: "translate(-567.309 -752.709)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M449.616,775.5h.966v.964h-.966Z",
    transform: "translate(-444.339 -750.548)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M709.9,780.057h.959v.969H709.9Z",
    transform: "translate(-656.784 -754.268)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M669.858,780.2h-.978v-.981c.284,0,.567-.006.849.006a.188.188,0,0,1,.123.135C669.864,779.635,669.858,779.909,669.858,780.2Z",
    transform: "translate(-623.302 -753.583)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M662.032,772.331H663v.965h-.968Z",
    transform: "translate(-617.713 -747.962)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M587.876,764.308v.925h-.946v-.925Z",
    transform: "translate(-556.415 -741.413)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M580.922,771.041v.917h-.938v-.917Z",
    transform: "translate(-550.744 -746.909)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M621.109,771.717h.918v.937h-.918Z",
    transform: "translate(-584.311 -747.461)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M634.779,772.869v-.926h.938v.926Z",
    transform: "translate(-595.469 -747.645)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M697.5,766.226v.924h-.939v-.924Z",
    transform: "translate(-645.899 -742.979)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M641.726,766.155v-.917h.937v.917Z",
    transform: "translate(-601.139 -742.172)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M525.131,771.022V770.1h.946v.922Z",
    transform: "translate(-505.974 -746.141)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M669.115,766.65v-.931h.937v.931Z",
    transform: "translate(-623.494 -742.565)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M607.369,772.383v-.939h.925v.939Z",
    transform: "translate(-573.097 -747.238)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M552.557,771.467v-.931h.926v.931Z",
    transform: "translate(-528.359 -746.497)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M484.135,769.283h.9v.936h-.9Z",
    transform: "translate(-472.513 -745.474)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M533.084,763.451v.9h-.944v-.9Z",
    transform: "translate(-511.695 -740.714)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M546.808,764.506H545.9v-.94h.908Z",
    transform: "translate(-522.926 -740.808)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M471.314,769.152v.905h-.942v-.905Z",
    transform: "translate(-461.28 -745.367)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M601.615,765.408H600.7v-.94h.911Z",
    transform: "translate(-567.657 -741.544)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M518.386,764.05v-.918h.928v.918Z",
    transform: "translate(-500.469 -740.454)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M711.255,766.452v.926h-.91v-.926Z",
    transform: "translate(-657.146 -743.163)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M593.745,772.2v-.922h.908v.922Z",
    transform: "translate(-561.977 -747.105)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M567.221,771.707H566.3v-.923h.924Z",
    transform: "translate(-539.574 -746.699)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M443.9,768.656v.916h-.926v-.916Z",
    transform: "translate(-438.92 -744.962)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M504.717,763.793v-.93h.92v.93Z",
    transform: "translate(-489.312 -740.234)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M573.209,765v-.9h.928v.9Z",
    transform: "translate(-545.215 -741.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M498.684,769.531v.929h-.93v-.929Z",
    transform: "translate(-483.629 -745.676)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M560.454,764.7h-.93v-.93h.93Z",
    transform: "translate(-534.046 -740.978)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M456.685,768.853h.92v.93h-.92Z",
    transform: "translate(-450.109 -745.123)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M655.5,766.457v-.917h.91v.917Z",
    transform: "translate(-612.381 -742.419)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M628.966,765.933h-.925V765h.925Z",
    transform: "translate(-589.969 -741.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M682.876,765.965h.919v.91h-.919Z",
    transform: "translate(-634.726 -742.766)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M614.329,765.685v-.9h.927v.9Z",
    transform: "translate(-578.778 -741.799)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M492.01,762.572v.921h-.917v-.921Z",
    transform: "translate(-478.192 -739.996)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M511.431,770.786v-.915h.925v.915Z",
    transform: "translate(-494.792 -745.954)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M430.255,768.406v.912h-.909v-.912Z",
    transform: "translate(-427.795 -744.758)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M538.946,770.352h.91v.909h-.91Z",
    transform: "translate(-517.25 -746.346)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M511.843,756.168h.878v.9h-.878Z",
    transform: "translate(-495.129 -734.769)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M690.821,760.213h-.893v-.888h.893Z",
    transform: "translate(-640.481 -737.346)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M635.048,759.33v-.874h.908v.874Z",
    transform: "translate(-595.689 -736.637)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M566.622,758.119v-.873h.888v.873Z",
    transform: "translate(-539.839 -735.649)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M622.352,759.032h-.877v-.877h.877Z",
    transform: "translate(-584.609 -736.391)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M450.974,762.085v.875h-.883v-.875Z",
    transform: "translate(-444.727 -739.599)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M457.907,756.167h-.883v-.873h.883Z",
    transform: "translate(-450.385 -734.056)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M498.117,755.963h.869v.89h-.869Z",
    transform: "translate(-483.925 -734.602)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M704.54,760.527h-.866v-.881h.866Z",
    transform: "translate(-651.701 -737.608)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M437.244,762.627h-.867v-.89h.867Z",
    transform: "translate(-433.533 -739.314)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M429.634,754.783h.873v.883h-.873Z",
    transform: "translate(-428.03 -733.639)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M443.3,755.973v-.883h.871v.883Z",
    transform: "translate(-439.185 -733.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M677.172,760.08h-.879v-.872h.879Z",
    transform: "translate(-629.353 -737.251)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M649.736,758.635v.871h-.874v-.871Z",
    transform: "translate(-606.964 -736.783)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M422.647,762.5v-.864h.875v.864Z",
    transform: "translate(-422.327 -739.232)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M553.835,757.076v.862h-.871v-.862Z",
    transform: "translate(-528.691 -735.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M594.054,757.708h.871v.875h-.871Z",
    transform: "translate(-562.229 -736.026)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M464.709,762.313v.865h-.875v-.865Z",
    transform: "translate(-455.944 -739.785)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M710.606,753.758v-.867h.875v.867Z",
    transform: "translate(-657.359 -732.094)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M540.127,757.638h-.865v-.874h.865Z",
    transform: "translate(-517.508 -735.256)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M608.638,758.856h-.86v-.87h.86Z",
    transform: "translate(-573.431 -736.253)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M478.363,763.4H477.5v-.869h.859Z",
    transform: "translate(-467.101 -739.966)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M662.556,758.835h.866v.89h-.866Z",
    transform: "translate(-618.141 -736.946)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M581.293,757.413v.874h-.874v-.874Z",
    transform: "translate(-551.1 -735.786)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M484.468,755.818h.86v.869h-.86Z",
    transform: "translate(-472.785 -734.484)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M471.675,755.528v.873H470.8v-.873Z",
    transform: "translate(-461.63 -734.247)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M526.5,757.41h-.863v-.874h.863Z",
    transform: "translate(-506.39 -735.07)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M451.234,748.445v.834h-.846v-.834Z",
    transform: "translate(-444.969 -728.466)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M567.82,743.6v.834h-.846V743.6Z",
    transform: "translate(-540.126 -724.514)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M669.6,752.27h.845v.845H669.6Z",
    transform: "translate(-623.892 -731.588)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M663.771,745.3v.84h-.835v-.84Z",
    transform: "translate(-618.451 -725.901)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M602.008,751.077v.833h-.83v-.833Z",
    transform: "translate(-568.044 -730.614)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M656.815,752.074v.816h-.831v-.816Z",
    transform: "translate(-612.777 -731.428)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M546.356,750.958v-.814h.827v.814Z",
    transform: "translate(-523.298 -729.852)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M588.293,750.834v.827h-.812v-.827Z",
    transform: "translate(-556.864 -730.416)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M608.976,744.427v.811h-.827v-.811Z",
    transform: "translate(-573.734 -725.187)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M677.416,746.413h-.835v-.826h.835Z",
    transform: "translate(-629.588 -726.133)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M614.769,752.193v-.81h.846v.81Z",
    transform: "translate(-579.137 -730.864)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M532.632,750.729v-.837h.819v.837Z",
    transform: "translate(-512.096 -729.647)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M436.756,748.265h.827v.817h-.827Z",
    transform: "translate(-433.843 -728.319)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M559.973,751.215v-.823h.846v.823Z",
    transform: "translate(-534.412 -730.055)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M580.687,744.735v-.818h.836v.818Z",
    transform: "translate(-551.319 -724.77)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M643.1,751.759v.84h-.819v-.84Z",
    transform: "translate(-601.59 -731.171)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M635.531,745.623v-.841h.825v.841Z",
    transform: "translate(-596.083 -725.476)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M650.068,745.917h-.813v-.835h.813Z",
    transform: "translate(-607.284 -725.721)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M704.041,746h.815v.844h-.815Z",
    transform: "translate(-652.001 -726.467)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M553.288,744.273v-.816h.835v.816Z",
    transform: "translate(-528.956 -724.395)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M492.373,750.029h-.83V749.2h.83Z",
    transform: "translate(-478.56 -729.085)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M518.93,750.506v-.836h.831v.836Z",
    transform: "translate(-500.913 -729.466)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M506.016,750.292h-.846v-.818h.846Z",
    transform: "translate(-489.681 -729.305)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M464.974,748.729v.82h-.835v-.82Z",
    transform: "translate(-456.193 -728.698)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M621.743,745.474v-.8h.842v.8Z",
    transform: "translate(-584.829 -725.386)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M595.241,744.943h-.814V744.1h.814Z",
    transform: "translate(-562.534 -724.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M573.794,750.672h.822v.818h-.822Z",
    transform: "translate(-545.693 -730.284)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M697.922,752.842v.8h-.815v-.8Z",
    transform: "translate(-646.341 -732.055)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M691.176,745.842v.812h-.836v-.812Z",
    transform: "translate(-640.818 -726.341)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M478.656,749.772h-.814v-.82h.814Z",
    transform: "translate(-467.378 -728.88)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M629.406,751.6v.81h-.832v-.81Z",
    transform: "translate(-590.404 -731.043)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M683.382,752.493h.829v.826h-.829Z",
    transform: "translate(-635.139 -731.77)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M423.842,747.984v.826h-.819v-.826Z",
    transform: "translate(-422.634 -728.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M547.456,737.321h-.786v-.79h.786Z",
    transform: "translate(-523.554 -718.742)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M465.306,735.891h-.786V735.1h.786Z",
    transform: "translate(-456.504 -717.574)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M539.677,744.083v-.775h.785v.775Z",
    transform: "translate(-517.847 -724.273)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M430.054,742.172v-.783h.79v.783Z",
    transform: "translate(-428.372 -722.707)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M492.665,735.642v.78h-.79v-.78Z",
    transform: "translate(-478.831 -718.016)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M684.537,738.946v.788h-.789v-.788Z",
    transform: "translate(-635.437 -720.713)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M602.27,738.333h-.781v-.79h.781Z",
    transform: "translate(-568.298 -719.568)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M656.251,739.231v-.78h.79v.78Z",
    transform: "translate(-612.994 -720.309)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M485.678,743.167H484.9V742.4h.779Z",
    transform: "translate(-473.137 -723.53)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M533.024,737.132v-.774h.771v.774Z",
    transform: "translate(-512.416 -718.601)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M587.824,738.006v-.778h.77v.778Z",
    transform: "translate(-557.144 -719.311)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M471.276,742.061h.771v.789h-.771Z",
    transform: "translate(-462.018 -723.255)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M423.412,735.184V734.4h.771v.786Z",
    transform: "translate(-422.951 -717.001)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M478.271,735.374h.76v.77h-.76Z",
    transform: "translate(-467.727 -717.797)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M498.667,743.366v-.781h.767v.781Z",
    transform: "translate(-484.374 -723.683)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M670.052,739.511v-.786h.77v.786Z",
    transform: "translate(-624.259 -720.532)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M458.346,741.944v.765h-.79v-.765Z",
    transform: "translate(-450.82 -723.16)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M698.224,739.2v.769h-.78V739.2Z",
    transform: "translate(-646.616 -720.916)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M437.028,735.413v-.766h.791v.766Z",
    transform: "translate(-434.065 -717.203)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M642.644,738.272h.776v.769h-.776Z",
    transform: "translate(-601.888 -720.163)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M711.879,740.3H711.1v-.771h.781Z",
    transform: "translate(-657.76 -721.185)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M519.293,736.931v-.75h.789v.75Z",
    transform: "translate(-501.209 -718.455)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M628.939,738.027h.789v.763h-.789Z",
    transform: "translate(-590.702 -719.963)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M526.051,743.883v-.751h.771v.751Z",
    transform: "translate(-506.725 -724.13)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M615.252,737.7h.767v.789h-.767Z",
    transform: "translate(-579.531 -719.693)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M574.911,737.854h-.785v-.77h.785Z",
    transform: "translate(-545.964 -719.193)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M560.435,737.606v-.787h.771v.787Z",
    transform: "translate(-534.789 -718.977)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M512.344,743.6v-.772h.788v.772Z",
    transform: "translate(-495.537 -723.884)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M443.818,742.386v-.761h.781v.761Z",
    transform: "translate(-439.607 -722.899)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M451.628,734.957v.768h-.768v-.768Z",
    transform: "translate(-445.354 -717.457)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M505.616,736.634v-.768h.768v.768Z",
    transform: "translate(-490.046 -718.199)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M698.527,725.649v.725h-.734v-.725Z",
    transform: "translate(-646.901 -709.86)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M499.763,729.772h-.735v-.734h.735Z",
    transform: "translate(-484.669 -712.626)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M643.606,724.736v.746c-.208,0-.409.011-.607-.007a.21.21,0,0,1-.142-.144c-.018-.19-.007-.384-.007-.595Z",
    transform: "translate(-602.054 -709.115)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M636.738,732.133h-.725V731.4h.725Z",
    transform: "translate(-596.476 -714.553)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M444.206,728.784v-.729h.735v.729Z",
    transform: "translate(-439.923 -711.824)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M553.854,729.928h.728v.733h-.728Z",
    transform: "translate(-529.418 -713.352)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M671.159,725.1v.734h-.735V725.1Z",
    transform: "translate(-624.562 -709.41)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M616.349,724.927h-.734v-.734h.734Z",
    transform: "translate(-579.827 -708.671)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M581.922,731.212h-.73v-.734h.73Z",
    transform: "translate(-551.731 -713.801)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M690.786,733.111v-.729h.734v.729Z",
    transform: "translate(-641.182 -715.355)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M513.456,729.993h-.715v-.734h.715Z",
    transform: "translate(-495.862 -712.806)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M623.089,731.176v.731h-.716v-.731Z",
    transform: "translate(-585.343 -714.371)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M684.87,725.43v.729h-.716v-.729Z",
    transform: "translate(-635.769 -709.681)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M630.049,724.411v.728h-.724v-.728Z",
    transform: "translate(-591.018 -708.849)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M567.55,730.968v-.709h.714v.709Z",
    transform: "translate(-540.596 -713.623)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M677.186,732.221h.716v.706h-.716Z",
    transform: "translate(-630.081 -715.224)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M705.289,733.321h-.714v-.734h.714Z",
    transform: "translate(-652.436 -715.523)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M527.1,730.242h-.726v-.715h.726Z",
    transform: "translate(-506.99 -713.025)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M608.636,731.714v-.7h.736v.7Z",
    transform: "translate(-574.131 -714.236)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M457.914,729.074v-.7h.732v.7Z",
    transform: "translate(-451.112 -712.088)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M650.521,731.715v.725h-.715v-.725Z",
    transform: "translate(-607.734 -714.811)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M431.28,728.558h-.706v-.741h.706Z",
    transform: "translate(-428.797 -711.629)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M472.289,728.6v.709h-.743V728.6Z",
    transform: "translate(-462.238 -712.264)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M486.06,728.75v.726h-.726v-.726Z",
    transform: "translate(-473.492 -712.391)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M663.422,732.66v-.709h.743v.709Z",
    transform: "translate(-618.847 -715.004)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M712.256,726.635h-.713v-.707h.713Z",
    transform: "translate(-658.124 -710.088)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M540.139,730.511v-.719h.715v.719Z",
    transform: "translate(-518.224 -713.241)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M595.673,730.724v.71h-.72v-.71Z",
    transform: "translate(-562.963 -714.002)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M650.853,718.067v.681h-.677v-.681Z",
    transform: "translate(-608.036 -703.672)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M656.723,725.668v-.718h.715v.718Z",
    transform: "translate(-613.38 -709.289)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M547.957,723.168v.682h-.678v-.682Z",
    transform: "translate(-524.051 -707.835)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M588.38,723.867h.671v.678h-.671Z",
    transform: "translate(-557.598 -708.405)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M567.831,717.307v-.666h.686v.666Z",
    transform: "translate(-540.826 -702.507)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M534.257,722.92v.669h-.678v-.669Z",
    transform: "translate(-512.87 -707.633)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M595.312,717.149h.683v.669h-.683Z",
    transform: "translate(-563.256 -702.922)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M458.21,715.424v-.671h.7v.671Z",
    transform: "translate(-451.353 -700.967)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M438.321,721.89h-.669V721.2h.669Z",
    transform: "translate(-434.574 -706.23)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M705.626,719.727h-.675v-.68h.675Z",
    transform: "translate(-652.743 -704.471)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M478.72,722.673V722h.68v.67Z",
    transform: "translate(-468.094 -706.884)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M499.417,716.134v-.668h.679v.668Z",
    transform: "translate(-484.987 -701.549)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M451.308,721.453h.664v.674h-.664Z",
    transform: "translate(-445.72 -706.435)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M602.061,724.787v-.677h.68v.677Z",
    transform: "translate(-568.764 -708.604)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M513.04,716.432v-.664h.687v.664Z",
    transform: "translate(-496.106 -701.795)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M664.559,719.074H663.9V718.4h.661Z",
    transform: "translate(-619.236 -703.946)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M506.053,723.1v-.679h.685v.679Z",
    transform: "translate(-490.403 -707.225)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M541.2,716.2v.682h-.679V716.2Z",
    transform: "translate(-518.54 -702.147)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M637.113,717.852v.67h-.67v-.67Z",
    transform: "translate(-596.827 -703.496)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M623.371,718.352H622.7v-.667h.672Z",
    transform: "translate(-585.609 -703.36)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M609.73,717.423v.652h-.678v-.652Z",
    transform: "translate(-574.471 -703.146)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M582.314,716.881v.678h-.67v-.678Z",
    transform: "translate(-552.1 -702.703)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M575.332,724.278h-.652V723.6h.652Z",
    transform: "translate(-546.416 -708.188)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M560.861,724.119v-.658h.68v.658Z",
    transform: "translate(-535.137 -708.074)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M554.194,717.165v-.653h.678v.653Z",
    transform: "translate(-529.695 -702.402)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M465.718,721.685v.673h-.669v-.673Z",
    transform: "translate(-456.935 -706.625)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M526.829,715.9h.656v.678h-.656Z",
    transform: "translate(-507.36 -701.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M472.054,715.009h.654v.679h-.654Z",
    transform: "translate(-462.653 -701.176)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M520.536,722.691v.668h-.663v-.668Z",
    transform: "translate(-501.683 -707.446)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M493.168,722.227v.656h-.679v-.656Z",
    transform: "translate(-479.332 -707.067)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M485.749,715.228h.667v.659h-.667Z",
    transform: "translate(-473.831 -701.354)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M691.262,718.729h.659v.687h-.659Z",
    transform: "translate(-641.57 -704.212)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M677.469,719.269v-.66h.677v.66Z",
    transform: "translate(-630.312 -704.114)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M423.922,720.981h.677v.66h-.677Z",
    transform: "translate(-423.368 -706.05)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M589.314,710.285v.626h-.643v-.626Z",
    transform: "translate(-557.836 -697.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M533.883,709.342h.633v.625h-.633Z",
    transform: "translate(-513.118 -696.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M705.905,706.052h-.626v-.635h.626Z",
    transform: "translate(-653.011 -693.346)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M547.559,710.213v-.636h.632v.636Z",
    transform: "translate(-524.28 -696.742)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M698.915,712.871h-.642v-.633h.642Z",
    transform: "translate(-647.293 -698.914)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M479.758,709h-.612v-.644h.612Z",
    transform: "translate(-468.441 -695.744)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M602.37,710.483h.638v.633h-.638Z",
    transform: "translate(-569.017 -697.481)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M451.763,707.809h.62v.637h-.62Z",
    transform: "translate(-446.091 -695.299)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M431.648,714.451v.615h-.631v-.615Z",
    transform: "translate(-429.158 -700.72)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M424.3,708.085v-.618h.624v.618Z",
    transform: "translate(-423.679 -695.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M711.962,713.047v-.619h.638v.619Z",
    transform: "translate(-658.466 -699.069)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M466.045,708.142v.621h-.624v-.621Z",
    transform: "translate(-457.239 -695.571)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M520.218,709.025h.621v.631h-.621Z",
    transform: "translate(-501.964 -696.291)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M685.285,712v.62h-.624V712Z",
    transform: "translate(-636.183 -698.719)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M437.956,707.672h.632v.631h-.632Z",
    transform: "translate(-434.822 -695.187)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M657.822,712.113H657.2v-.621h.625Z",
    transform: "translate(-613.766 -698.305)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M691.579,705.927V705.3h.633v.626Z",
    transform: "translate(-641.829 -693.252)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M629.869,711.017h.62v.631h-.62Z",
    transform: "translate(-591.461 -697.917)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M492.763,708.633h.628v.622h-.628Z",
    transform: "translate(-479.556 -695.971)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M664.9,704.835v.6h-.6v-.6Z",
    transform: "translate(-619.569 -692.871)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M561.957,710.473h-.6v-.631h.6Z",
    transform: "translate(-535.539 -696.958)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M643.431,711.959v-.6h.641v.6Z",
    transform: "translate(-602.531 -698.198)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M575.657,710.744h-.615v-.6h.615Z",
    transform: "translate(-546.712 -697.205)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M670.969,711.679h.6v.633h-.6Z",
    transform: "translate(-625.007 -698.458)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M444.755,715.281v-.631h.6v.631Z",
    transform: "translate(-440.371 -700.882)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M616.8,711.445h-.6v-.621h.6Z",
    transform: "translate(-580.306 -697.76)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M507.173,709.5h-.613V708.9h.613Z",
    transform: "translate(-490.817 -696.187)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M657.647,697.817h.571v.6h-.571Z",
    transform: "translate(-614.134 -687.143)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M472.432,702.109v-.6h.584v.6Z",
    transform: "translate(-462.961 -690.161)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M684.941,698.969v-.579h.584v.579Z",
    transform: "translate(-636.411 -687.611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M554.683,703.49V702.9h.586v.588Z",
    transform: "translate(-530.095 -691.294)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M568.424,703.168h.567v.586h-.567Z",
    transform: "translate(-541.31 -691.511)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M575.306,697.1v-.574h.585v.574Z",
    transform: "translate(-546.927 -686.088)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M610.117,704.492h-.585v-.582h.585Z",
    transform: "translate(-574.862 -692.117)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M547.99,696.564v-.589h.585v.589Z",
    transform: "translate(-524.632 -685.64)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M561.633,696.83v-.576h.6v.576Z",
    transform: "translate(-535.767 -685.868)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M671.881,698.148v.577h-.593v-.577Z",
    transform: "translate(-625.267 -687.414)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M637.491,704.467v.567H636.9v-.567Z",
    transform: "translate(-597.203 -692.571)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M431.391,701.393v-.568h.587v.568Z",
    transform: "translate(-429.464 -689.599)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M514.15,702.245v.591h-.582v-.591Z",
    transform: "translate(-496.537 -690.758)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M698.652,699.2v-.584h.576v.584Z",
    transform: "translate(-647.602 -687.798)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M623.775,704.139v.589h-.586v-.589Z",
    transform: "translate(-586.009 -692.303)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M459.348,701.935h-.578v-.577h.578Z",
    transform: "translate(-451.81 -690.034)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M617.049,697.761h-.587v-.6h.587Z",
    transform: "translate(-580.519 -686.611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M520.488,696.183v-.567h.6v.567Z",
    transform: "translate(-502.185 -685.347)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M500.485,701.995v.58h-.593v-.58Z",
    transform: "translate(-485.374 -690.553)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M678.6,705.147v.567h-.588v-.567Z",
    transform: "translate(-630.752 -693.126)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M630.749,697.465v.576h-.581v-.576Z",
    transform: "translate(-591.705 -686.856)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M445.648,701.694h-.592v-.579h.592Z",
    transform: "translate(-440.617 -689.835)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M644.457,698.27h-.57v-.58h.57Z",
    transform: "translate(-602.903 -687.04)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M651.253,705.258h-.58v-.576h.58Z",
    transform: "translate(-608.442 -692.747)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M712.359,699.413c0-.142,0-.26,0-.378,0-.062.007-.125.012-.2.068-.005.121-.013.174-.014.128,0,.256,0,.4,0v.594Z",
    transform: "translate(-658.789 -687.961)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M486.238,702.289v-.575c.668-.088.637-.084.565.554a.923.923,0,0,1-.127.019C486.539,702.291,486.4,702.289,486.238,702.289Z",
    transform: "translate(-474.23 -690.292)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M527.852,702.559v.573h-.583v-.573Z",
    transform: "translate(-507.719 -691.014)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M589.64,697.4h-.575v-.574h.575Z",
    transform: "translate(-558.157 -686.335)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M582.124,703.455h.567v.577h-.567Z",
    transform: "translate(-552.492 -691.745)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M602.85,696.936h.571v.58h-.571Z",
    transform: "translate(-569.408 -686.424)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M541.641,702.79v.555h-.586v-.555Z",
    transform: "translate(-518.971 -691.202)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M534.231,696.314v-.577h.575v.577Z",
    transform: "translate(-513.402 -685.446)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M595.875,703.731h.556c.093.675.076.638-.556.567Z",
    transform: "translate(-563.715 -691.97)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M425.319,694.5h-.528v-.548h.528Z",
    transform: "translate(-424.077 -683.987)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M459.676,688.244h-.534v-.539h.534Z",
    transform: "translate(-452.114 -678.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M493.809,695.689h-.533v-.548h.533Z",
    transform: "translate(-479.974 -684.959)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M514.495,689.218h-.549v-.539h.549Z",
    transform: "translate(-496.844 -679.684)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M555.615,689.921h-.532v-.556h.532Z",
    transform: "translate(-530.421 -680.245)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M486.545,688.13h.535v.556h-.535Z",
    transform: "translate(-474.48 -679.237)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M678.305,691.916c-.054-.6-.025-.63.522-.528v.528Z",
    transform: "translate(-630.98 -681.859)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M624.118,690.633v.542H623.6v-.542Z",
    transform: "translate(-586.344 -681.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M650.96,691.63v-.517h.541v.517Z",
    transform: "translate(-608.676 -681.672)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M500.225,688.986v-.516h.54v.516Z",
    transform: "translate(-485.646 -679.514)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M706.33,692.556h-.537v-.54h.537Z",
    transform: "translate(-653.431 -682.408)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M610.407,690.986h-.528v-.521h.528Z",
    transform: "translate(-575.146 -681.143)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M439.019,694.25v.515h-.539v-.515Z",
    transform: "translate(-435.25 -684.232)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M452.712,694.445v.529h-.526v-.529Z",
    transform: "translate(-446.437 -684.391)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M664.651,691.88v-.535h.541v.535Z",
    transform: "translate(-619.851 -681.861)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M480.132,694.973v.537h-.541v-.537Z",
    transform: "translate(-468.805 -684.822)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M568.763,689.591h.519v.533h-.519Z",
    transform: "translate(-541.587 -680.429)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M541.931,689.264v.511h-.54v-.511Z",
    transform: "translate(-519.246 -680.162)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M582.577,689.853h.51v.529h-.51Z",
    transform: "translate(-552.862 -680.643)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M465.952,694.732h.525v.522h-.525Z",
    transform: "translate(-457.672 -684.625)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M637.351,690.759h.518v.539h-.518Z",
    transform: "translate(-597.568 -681.383)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M527.774,688.9h.513v.537h-.513Z",
    transform: "translate(-508.131 -679.867)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M432.308,687.784h-.529v-.526h.529Z",
    transform: "translate(-429.78 -678.525)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M596.149,690.666v-.535h.541v.535Z",
    transform: "translate(-563.939 -680.87)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M445.97,688h-.541v-.54h.541Z",
    transform: "translate(-440.921 -678.693)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M692.129,692.324v-.51h.529v.51Z",
    transform: "translate(-642.278 -682.244)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M473.442,688.022v.516h-.525v-.516Z",
    transform: "translate(-463.357 -679.149)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M507.538,695.447v.511h-.53v-.511Z",
    transform: "translate(-491.182 -685.209)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M623.848,677.487V677h.517v.483Z",
    transform: "translate(-586.547 -670.156)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M438.9,680.589h.49v.491h-.49Z",
    transform: "translate(-435.591 -673.082)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M713.418,685.929h-.484v-.494h.484Z",
    transform: "translate(-659.258 -677.037)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M507.806,682.3h-.485v-.5h.485Z",
    transform: "translate(-491.438 -674.074)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M610.225,677.311v-.475h.5v.475Z",
    transform: "translate(-575.428 -670.019)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M616.913,683.773h.489v.474h-.489Z",
    transform: "translate(-580.887 -675.681)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M562.62,683.38h-.49V682.9h.49Z",
    transform: "translate(-536.173 -674.966)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M521.078,682.08h.475v.5h-.475Z",
    transform: "translate(-502.666 -674.299)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M692.43,678.69V678.2h.493v.487Z",
    transform: "translate(-642.524 -671.134)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M658.1,684.445h.5v.473h-.5Z",
    transform: "translate(-614.505 -676.229)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M493.666,681.656h.49v.475h-.49Z",
    transform: "translate(-480.292 -673.953)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M644.422,684.225h.473v.488h-.473Z",
    transform: "translate(-603.34 -676.05)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M699.7,685.121v.494h-.48v-.494Z",
    transform: "translate(-648.062 -676.781)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M706.147,678.957v-.491h.484v.491Z",
    transform: "translate(-653.719 -671.349)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M679.2,678.514H678.7v-.479h.493Z",
    transform: "translate(-631.32 -670.997)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M665.548,678.265h-.492v-.484h.492Z",
    transform: "translate(-620.181 -670.79)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M575.929,682.987h.471v.493h-.471Z",
    transform: "translate(-547.436 -675.039)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M671.706,685.224v-.474h.494v.474Z",
    transform: "translate(-625.609 -676.478)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M452.644,680.867h.475v.5h-.475Z",
    transform: "translate(-446.81 -673.309)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M603.265,684.02v-.471h.492v.471Z",
    transform: "translate(-569.747 -675.498)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M638.178,677.26v.49h-.484v-.49Z",
    transform: "translate(-597.848 -670.365)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M548.458,683.041v-.473h.493v.473Z",
    transform: "translate(-525.014 -674.696)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M651.851,677.989h-.471v-.481h.471Z",
    transform: "translate(-609.019 -670.567)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M425.122,680.936v-.472h.482v.472Z",
    transform: "translate(-424.347 -672.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M534.811,682.314h.475v.484h-.475Z",
    transform: "translate(-513.875 -674.49)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M480.451,681.846h-.476v-.485h.476Z",
    transform: "translate(-469.118 -673.712)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M589.558,683.736v-.469h.479v.469Z",
    transform: "translate(-558.56 -675.268)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M630.732,684.065h.478v.476h-.478Z",
    transform: "translate(-592.166 -675.919)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M597.013,676.608v.468h-.488v-.468Z",
    transform: "translate(-564.246 -669.833)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M466.741,681.1v.485h-.485V681.1Z",
    transform: "translate(-457.92 -673.501)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M686.016,685.015v.469h-.479v-.469Z",
    transform: "translate(-636.898 -676.694)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M528.648,675.435v.432h-.442v-.432Z",
    transform: "translate(-508.484 -668.875)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M473.839,674.984h-.428v-.445h.428Z",
    transform: "translate(-463.76 -668.144)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M535.154,668.77h.439v.435h-.439Z",
    transform: "translate(-514.155 -663.435)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M590.4,670.143h-.443v-.436h.443Z",
    transform: "translate(-558.882 -664.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M521.862,668.93h-.42v-.436h.42Z",
    transform: "translate(-502.963 -663.21)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M603.777,669.988h.42v.436h-.42Z",
    transform: "translate(-570.165 -664.429)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M644.751,671.2v-.418h.443v.418Z",
    transform: "translate(-603.608 -665.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M658.588,670.9h.42v.435h-.42Z",
    transform: "translate(-614.902 -665.172)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M466.625,667.533h.423v.446h-.423Z",
    transform: "translate(-458.222 -662.425)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M699.576,671.654h.437v.421h-.437Z",
    transform: "translate(-648.356 -665.789)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M713.4,671.789h.42v.438h-.42Z",
    transform: "translate(-659.635 -665.899)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M425.51,667.336v-.417h.443v.417Z",
    transform: "translate(-424.664 -661.924)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M480.324,668.244v-.418h.442v.418Z",
    transform: "translate(-469.403 -662.665)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M583,676.51h.442v.417H583Z",
    transform: "translate(-553.209 -669.753)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M452.942,667.236h.422v.446h-.422Z",
    transform: "translate(-447.054 -662.183)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M541.929,676.211v-.431h.438v.431Z",
    transform: "translate(-519.685 -669.157)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M514.467,675.751v-.421h.43v.421Z",
    transform: "translate(-497.27 -668.79)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M672.206,671.1h.416v.426h-.416Z",
    transform: "translate(-626.017 -665.333)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M562.592,669.211h.415v.424h-.415Z",
    transform: "translate(-536.55 -663.795)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M487.153,675.163v-.42h.419v.42Z",
    transform: "translate(-474.977 -668.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M686.285,671.841h-.419v-.43h.419Z",
    transform: "translate(-637.166 -665.591)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M555.569,676.41v-.415h.425v.415Z",
    transform: "translate(-530.818 -669.332)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M460.124,674.409v.416H459.7v-.416Z",
    transform: "translate(-452.569 -668.038)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M494.547,668.133v.42h-.43v-.42Z",
    transform: "translate(-480.661 -662.915)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M576.273,669.5h.419v.43h-.419Z",
    transform: "translate(-547.716 -664.027)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M631.511,670.462v.419h-.429v-.419Z",
    transform: "translate(-592.451 -664.816)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M507.722,668.757v-.422h.43v.422Z",
    transform: "translate(-491.765 -663.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M501.216,675.059v.426h-.43v-.426Z",
    transform: "translate(-486.104 -668.568)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M569.736,676.218v.419h-.43v-.419Z",
    transform: "translate(-542.03 -669.514)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M432.363,673.814h.421v.429h-.421Z",
    transform: "translate(-430.257 -667.552)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M439.763,667.131v.419h-.428v-.419Z",
    transform: "translate(-435.948 -662.098)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M548.926,669.41v-.421h.42v.421Z",
    transform: "translate(-525.396 -663.614)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M617.792,670.2v.419h-.429V670.2Z",
    transform: "translate(-581.254 -664.606)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M445.973,674.5v-.428h.428v.428Z",
    transform: "translate(-441.366 -667.765)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M692.908,665.158v-.4h.4v.4Z",
    transform: "translate(-642.914 -660.162)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M686.664,657.851v.38h-.391v-.38Z",
    transform: "translate(-637.498 -654.523)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M624.481,663.622h.384V664h-.384Z",
    transform: "translate(-587.064 -659.233)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M679.686,664.579v.371h-.39v-.371Z",
    transform: "translate(-631.804 -660.015)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M542.655,662.116v.4h-.391v-.4Z",
    transform: "translate(-519.958 -658.004)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M610.767,663.723v-.4h.374v.4Z",
    transform: "translate(-575.87 -658.989)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M432.656,660.174h.376v.409h-.376Z",
    transform: "translate(-430.496 -656.419)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M583.293,663.249v-.381h.4v.381Z",
    transform: "translate(-553.446 -658.618)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M528.915,662v.36h-.4V662Z",
    transform: "translate(-508.737 -657.907)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M473.816,661.3v-.392h.373v.392Z",
    transform: "translate(-464.091 -657.021)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M638.531,663.876v.362h-.4v-.362Z",
    transform: "translate(-598.204 -659.441)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M556.355,662.41v.382h-.366v-.382Z",
    transform: "translate(-531.161 -658.244)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M569.673,662.645h.379v.364h-.379Z",
    transform: "translate(-542.329 -658.436)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M514.84,662.1v-.361h.381v.361Z",
    transform: "translate(-497.575 -657.701)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M672.544,657.95v-.383h.373v.383Z",
    transform: "translate(-626.293 -654.291)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M501.516,661.862h-.374v-.392h.374Z",
    transform: "translate(-486.394 -657.477)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M699.918,658.075h.388v.37h-.388Z",
    transform: "translate(-648.635 -654.706)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M487.866,661.2v.385h-.379V661.2Z",
    transform: "translate(-475.249 -657.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M460.455,660.781v.366h-.383v-.366Z",
    transform: "translate(-452.873 -656.915)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M597.473,663.188v.362h-.385v-.362Z",
    transform: "translate(-564.706 -658.879)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M665.964,664.774H665.6V664.4h.366Z",
    transform: "translate(-620.623 -659.868)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M659.24,657.418v.367h-.39v-.367Z",
    transform: "translate(-615.116 -654.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M713.639,658.7v-.364h.382v.364Z",
    transform: "translate(-659.834 -654.918)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M446.312,660.916v-.363h.378v.363Z",
    transform: "translate(-441.642 -656.728)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M706.663,665.438v-.359h.382v.359Z",
    transform: "translate(-654.141 -660.423)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M652.27,664.489h-.385v-.382h.385Z",
    transform: "translate(-609.431 -659.629)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M590.84,656.643H590.5V656.3h.336Z",
    transform: "translate(-559.332 -653.256)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M453.774,653.758v.354h-.34v-.339Z",
    transform: "translate(-447.455 -651.182)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M625.146,650.376h-.334v-.343h.334Z",
    transform: "translate(-587.334 -648.142)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M707.415,651.435v.342h-.346v-.342Z",
    transform: "translate(-654.472 -649.286)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M719.875,665.438v-.359h.382v.359Z",
    transform: "translate(-664.924 -660.423)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M719.338,651.435v.342h-.346v-.342Z",
    transform: "translate(-664.203 -649.286)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M508.556,654.88v.337h-.347v-.337Z",
    transform: "translate(-492.162 -652.098)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M562.984,656.121v-.334h.344v.334Z",
    transform: "translate(-536.87 -652.839)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M652.3,650.527h.338v.345l-.338.017Z",
    transform: "translate(-609.767 -648.545)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M515.514,648.451h-.343v-.345h.343Z",
    transform: "translate(-497.845 -646.569)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M556.7,648.822v.338h-.327v-.338Z",
    transform: "translate(-531.471 -647.154)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M501.526,647.878h.328v.341h-.328Z",
    transform: "translate(-486.708 -646.383)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M569.991,649.078h.335v.331h-.335Z",
    transform: "translate(-542.589 -647.363)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M494.545,654.9v-.331h.335v.331Z",
    transform: "translate(-481.01 -651.842)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M645.273,657.6v-.321h.345v.321Z",
    transform: "translate(-604.034 -654.052)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M440.1,653.649v.334h-.332v-.334Z",
    transform: "translate(-436.3 -651.094)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M522.232,655.1v.334H521.9l-.017-.334Z",
    transform: "translate(-503.322 -652.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M693.407,651.205h.321v.345h-.321Z",
    transform: "translate(-643.321 -649.099)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M665.95,651.094v-.324h.336v.324Z",
    transform: "translate(-620.911 -648.744)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M583.755,649.649v-.339h.324v.339Z",
    transform: "translate(-553.823 -647.552)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M542.628,648.606h.341v.325h-.341Z",
    transform: "translate(-520.255 -646.977)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M597.8,649.88h-.344v-.335h.344Z",
    transform: "translate(-565.006 -647.744)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M549.356,655.947v-.32h.335v.32Z",
    transform: "translate(-525.747 -652.708)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M481.238,654.4v.329l-.345.017V654.4Z",
    transform: "translate(-469.867 -651.704)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M577.12,656.084v.318h-.327v-.318Z",
    transform: "translate(-548.141 -653.081)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M638.574,650.574v-.344h.319v.344Z",
    transform: "translate(-598.566 -648.303)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M631.947,657v.339h-.324V657Z",
    transform: "translate(-592.893 -653.825)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M611.171,649.852h.327v.316h-.327Z",
    transform: "translate(-576.2 -647.994)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M535.669,655.357h.344v.318h-.344Z",
    transform: "translate(-514.575 -652.488)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M604.54,656.843h-.319v-.327h.319Z",
    transform: "translate(-570.527 -653.433)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M426.049,653.478h.345v.317h-.345Z",
    transform: "translate(-425.104 -650.954)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M679.952,651.073v.312H679.6v-.312Z",
    transform: "translate(-632.056 -648.991)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M617.79,657.183v-.315h.351v.315Z",
    transform: "translate(-581.603 -653.721)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M528.851,648.393h.346v.318h-.33C528.862,648.614,528.857,648.518,528.851,648.393Z",
    transform: "translate(-509.011 -646.804)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M467.423,654.195v.308h-.334c0-.094-.01-.19-.016-.308Z",
    transform: "translate(-458.587 -651.539)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M645.59,643.934v-.287h.305v.287Z",
    transform: "translate(-604.293 -642.93)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M659.238,644.1a.837.837,0,0,1-.017-.111c0-.053.005-.107.01-.175a1.13,1.13,0,0,1,.13-.025,1.538,1.538,0,0,1,.157.006v.3Z",
    transform: "translate(-615.418 -643.042)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M467.516,640.821v-.286h.291v.286Z",
    transform: "translate(-458.949 -640.39)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M549.894,642.365H549.6c-.006-.095-.011-.18-.018-.287h.309Z",
    transform: "translate(-525.934 -641.649)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M460.573,647.591v-.308h.291l.016.282Z",
    transform: "translate(-453.282 -645.898)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M591.1,642.932h-.313c0-.095-.008-.175-.013-.283l.3-.025Z",
    transform: "translate(-559.555 -642.095)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M577.125,642.663v-.308l.292-.016.021.3Z",
    transform: "translate(-548.412 -641.862)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M714.422,645.065h-.309v-.291l.286-.018C714.407,644.86,714.413,644.947,714.422,645.065Z",
    transform: "translate(-660.221 -643.835)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M487.811,647.77h.307l.017.295-.306.014C487.823,647.973,487.818,647.886,487.811,647.77Z",
    transform: "translate(-475.514 -646.295)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M474.592,647.535c0,.1-.008.184-.013.28h-.292v-.28Z",
    transform: "translate(-464.476 -646.103)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M522.319,641.862v-.3h.293v.281Z",
    transform: "translate(-503.679 -641.229)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M536.291,641.963h-.305l-.015-.292.306-.016C536.281,641.761,536.285,641.848,536.291,641.963Z",
    transform: "translate(-514.821 -641.303)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M604.715,642.842v.3c-.243.067-.362.013-.284-.277Z",
    transform: "translate(-570.68 -642.273)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M481.158,641.124c.005-.113.009-.194.013-.288h.293v.288Z",
    transform: "translate(-470.083 -640.636)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M454.037,640.638h-.269l-.02-.288h.289Z",
    transform: "translate(-447.711 -640.239)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M686.758,644.69V644.4h.289v.275Z",
    transform: "translate(-637.894 -643.545)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M673.049,644.462v-.281h.28v.281Z",
    transform: "translate(-626.705 -643.366)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M495.17,641.347h-.307v-.27h.292C495.16,641.16,495.164,641.24,495.17,641.347Z",
    transform: "translate(-481.27 -640.832)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M700.4,644.637a1.117,1.117,0,0,1,.122-.015c.054,0,.107.005.179.01v.278h-.3Z",
    transform: "translate(-649.029 -643.726)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M433.093,646.786h.275v.259C433.065,647.108,433.063,647.106,433.093,646.786Z",
    transform: "translate(-430.843 -645.492)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M426.664,640.043h-.3c-.006-.088-.012-.166-.019-.271l.307-.027C426.655,639.846,426.659,639.932,426.664,640.043Z",
    transform: "translate(-425.344 -639.745)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M440.054,640.346v-.268l.291-.021c.005.1.01.184.015.289Z",
    transform: "translate(-436.534 -640)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M508.631,641.466v-.305l.276-.012v.3Z",
    transform: "translate(-492.507 -640.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M632.187,643.726H631.9q-.006-.132-.011-.256C632.215,643.4,632.218,643.407,632.187,643.726Z",
    transform: "translate(-593.113 -642.758)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M563.38,642.269h.29l.013.269h-.289Z",
    transform: "translate(-537.193 -641.805)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M618.269,643.475v-.266h.275v.266Z",
    transform: "translate(-581.993 -642.572)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M447.1,647.424h-.29c0-.091-.009-.169-.014-.269h.29C447.092,647.238,447.1,647.316,447.1,647.424Z",
    transform: "translate(-442.039 -645.793)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(132.933)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1010.979,814.883H1010v-1.224h.983Z",
    transform: "translate(-955.838 -781.693)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1011.432,801.448h-.881v-1.113h.881Z",
    transform: "translate(-956.291 -770.819)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1011.726,787.766h-.815v-1.058h.815Z",
    transform: "translate(-956.584 -759.696)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1012.013,774.084h-.751v-1h.751Z",
    transform: "translate(-956.871 -748.575)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1012.46,760.649h-.65v-.891h.65Z",
    transform: "translate(-957.318 -737.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1012.8,747.022l-.574-.026v-.837l.574-.028Z",
    transform: "translate(-957.656 -726.577)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1013.2,733.531h-.483v-.724h.483Z",
    transform: "translate(-958.058 -715.702)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1013.495,719.9l-.417-.032v-.691h.417Z",
    transform: "translate(-958.353 -704.581)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1013.745,706.222h-.361v-.634l.361-.034Z",
    transform: "translate(-958.603 -693.458)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1014.2,692.786l-.257-.017v-.525l.257-.015Z",
    transform: "translate(-959.062 -682.582)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1014.415,679.1c-.159.038-.22-.028-.208-.187s-.053-.335.208-.314Z",
    transform: "translate(-959.274 -671.454)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M988.987,821.347c0-.351.015-.7.007-1.053,0-.171.056-.227.224-.222.339.01.679,0,1.043,0v1.271l.008-.009H988.98Z",
    transform: "translate(-938.685 -786.928)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M975.348,821.185v-1.249h1.244v1.24h-1.253Z",
    transform: "translate(-927.551 -786.817)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1004.156,821.7l-1.2-.055v-1.229h1.2q0,.645,0,1.289Z",
    transform: "translate(-950.092 -787.207)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M893.393,819.839v-1.176h1.19v1.176Z",
    transform: "translate(-860.666 -785.778)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M845.514,812.155v-1.182h1.2v1.182Z",
    transform: "translate(-821.588 -779.501)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M963.632,820.4h-1.214v-1.208h1.214Z",
    transform: "translate(-917.005 -786.21)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M900.328,813.122v-1.176h1.2v1.176Z",
    transform: "translate(-866.327 -780.295)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M956.361,814.067h-1.187v-1.189h1.187Z",
    transform: "translate(-911.092 -781.056)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M770.149,816.447h1.173v1.2h-1.173Z",
    transform: "translate(-760.075 -783.969)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M785.011,818H783.8V816.8H785c0,.409,0,.813,0,1.217Z",
    transform: "translate(-771.219 -784.254)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M948.187,820.781V819.61h1.2v1.171Z",
    transform: "translate(-905.389 -786.551)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M839.8,817.7v1.177h-1.19V817.7Z",
    transform: "translate(-815.95 -784.989)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M907.1,820.059v-1.17h1.18v1.17Z",
    transform: "translate(-871.851 -785.962)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M826.169,817.5v1.164H825V817.5Z",
    transform: "translate(-804.841 -784.827)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M942.755,812.619V813.8h-1.17v-1.179Z",
    transform: "translate(-900.001 -780.845)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M996.309,814.736V813.55h1.18v1.186Z",
    transform: "translate(-944.666 -781.605)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M970.084,813.162v1.17h-1.179v-1.17Z",
    transform: "translate(-922.299 -781.288)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M915.272,813.351H914.1v-1.2h1.174Z",
    transform: "translate(-877.566 -780.465)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M715.337,815.547h1.179v1.179h-1.179Z",
    transform: "translate(-715.337 -783.234)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M853.481,817.944v1.185H852.3v-1.185Z",
    transform: "translate(-827.127 -785.191)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M804.453,810.17h1.172v1.2h-1.172Z",
    transform: "translate(-788.073 -778.846)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M879.743,819.562V818.4h1.177v1.167Z",
    transform: "translate(-849.525 -785.559)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M886.733,811.708h1.178v1.177h-1.178Z",
    transform: "translate(-855.23 -780.101)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M833.127,810.738v1.169h-1.178v-1.169Z",
    transform: "translate(-810.516 -779.309)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M859.287,811.252h1.174v1.158h-1.174Z",
    transform: "translate(-832.829 -779.729)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M756.474,816.246h1.16v1.18h-1.16Z",
    transform: "translate(-748.913 -783.805)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M797.494,816.984h1.171v1.166h-1.171Z",
    transform: "translate(-782.394 -784.407)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M934.6,819.41h1.173v1.16H934.6Z",
    transform: "translate(-894.301 -786.387)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M920.9,819.11h1.157V820.3H920.9Z",
    transform: "translate(-883.118 -786.143)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M819.386,811.671h-1.159v-1.179h1.159Z",
    transform: "translate(-799.316 -779.109)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M874.219,812.6h-1.162v-1.177h1.162Z",
    transform: "translate(-844.068 -779.865)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M742.709,816.1h1.172v1.156h-1.172Z",
    transform: "translate(-737.678 -783.688)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M811.274,817.145h1.16v1.187h-1.16Z",
    transform: "translate(-793.641 -784.539)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M730.181,815.792v1.165H728.99v-1.165Z",
    transform: "translate(-726.481 -783.435)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M927.854,812.444h1.16v1.16h-1.16Z",
    transform: "translate(-888.793 -780.702)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M784.164,803.136H785.3v1.134h-1.135Z",
    transform: "translate(-771.514 -773.105)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M770.487,802.908h1.13v1.125h-1.13Z",
    transform: "translate(-760.35 -772.919)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M983.823,814.563h-1.162V813.4h1.162Z",
    transform: "translate(-933.527 -781.484)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M825.259,804.979V803.85H826.4v1.129Z",
    transform: "translate(-805.055 -773.687)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M989.658,807.92V806.8H990.8v1.12Z",
    transform: "translate(-939.238 -776.095)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M716.779,803.071h-1.13v-1.142h1.13Z",
    transform: "translate(-715.592 -772.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M723.531,810.033H722.4v-1.14h1.13Z",
    transform: "translate(-721.103 -777.804)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M921.216,806.737v-1.126h1.131v1.126Z",
    transform: "translate(-883.375 -775.125)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M976.049,807.609v-1.131h1.125v1.131Z",
    transform: "translate(-928.13 -775.832)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M934.867,805.8h1.143v1.134h-1.143Z",
    transform: "translate(-894.517 -775.277)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M866.062,819.389v-1.158h1.157v1.158Z",
    transform: "translate(-838.359 -785.425)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M778.366,809.9v1.133h-1.132V809.9Z",
    transform: "translate(-765.857 -778.624)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M811.631,804.822V803.7h1.119v1.122Z",
    transform: "translate(-793.932 -773.565)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M867.588,805.722h-1.119V804.58h1.119Z",
    transform: "translate(-838.691 -774.283)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M893.775,806.182v-1.135h1.131v1.135Z",
    transform: "translate(-860.978 -774.664)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M838.981,804.1h1.125v1.122h-1.125Z",
    transform: "translate(-816.255 -773.894)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M756.813,802.6h1.121v1.131h-1.121Z",
    transform: "translate(-749.19 -772.667)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M749.874,809.435H751v1.133h-1.122Z",
    transform: "translate(-743.526 -778.246)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M743.144,802.455h1.131v1.13h-1.131Z",
    transform: "translate(-738.033 -772.549)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1004.547,808.139h-1.129V807h1.129Z",
    transform: "translate(-950.469 -776.259)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M730.521,803.4H729.4v-1.119h1.125Z",
    transform: "translate(-726.813 -772.41)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M852.76,804.346h1.1v1.142h-1.1Z",
    transform: "translate(-827.502 -774.092)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M907.571,805.315h1.1v1.122h-1.1Z",
    transform: "translate(-872.238 -774.883)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M963.481,807.423h-1.1v-1.132h1.1Z",
    transform: "translate(-916.97 -775.68)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M791,810.111h1.1v1.137H791Z",
    transform: "translate(-777.091 -778.798)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M764.629,810.877h-1.135v-1.106h1.135Z",
    transform: "translate(-754.643 -778.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M881.205,806.013h-1.14v-1.106h1.14Z",
    transform: "translate(-849.788 -774.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M799.05,804.58h-1.1v-1.123h1.1Z",
    transform: "translate(-782.767 -773.367)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M948.581,807.212V806.1h1.132v1.108Z",
    transform: "translate(-905.711 -775.527)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M736.2,809.185h1.1v1.124h-1.1Z",
    transform: "translate(-732.368 -778.042)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M991.168,794.242H990.1v-1.088h1.071Z",
    transform: "translate(-939.596 -764.957)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M970.507,800.821h-1.071v-1.08h1.071Z",
    transform: "translate(-922.733 -770.334)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M751.246,796.957h-1.075v-1.086h1.075Z",
    transform: "translate(-743.768 -767.175)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M805,796.774h1.078v1.077H805Z",
    transform: "translate(-788.518 -767.912)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M922.637,791.974v1.075H921.55v-1.075Z",
    transform: "translate(-883.648 -763.994)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M977.466,794.023H976.4v-1.089h1.07Z",
    transform: "translate(-928.413 -764.778)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M860.872,797.795v1.072h-1.088v-1.072Z",
    transform: "translate(-833.235 -768.745)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M915.687,799.763h-1.072v-1.081h1.072Z",
    transform: "translate(-877.988 -769.469)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M737.647,795.594v1.08H736.57v-1.08Z",
    transform: "translate(-732.667 -766.949)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M996.879,801.212v-1.073h1.083v1.073Z",
    transform: "translate(-945.132 -770.659)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1003.841,794.547v-1.075h1.074v1.075Z",
    transform: "translate(-950.814 -765.217)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M874.58,799.074h-1.074V797.99h1.074Z",
    transform: "translate(-844.434 -768.904)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M936.363,792.243v1.082h-1.078v-1.082Z",
    transform: "translate(-894.858 -764.214)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M818.675,798.189v-1.073h1.083v1.073Z",
    transform: "translate(-799.681 -768.191)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M942.03,800.309V799.24h1.088v1.069Z",
    transform: "translate(-900.364 -769.925)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M867.833,791.072v1.072h-1.087v-1.072Z",
    transform: "translate(-838.917 -763.258)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M763.845,797.208v-1.069h1.085v1.069Z",
    transform: "translate(-754.929 -767.394)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M962.668,793.873V792.8h1.081v1.07Z",
    transform: "translate(-917.208 -764.671)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M887.3,798.225h1.071V799.3H887.3Z",
    transform: "translate(-855.691 -769.096)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M777.646,796.262h1.081v1.075h-1.081Z",
    transform: "translate(-766.194 -767.494)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M722.8,796.461V795.4h1.084v1.064Z",
    transform: "translate(-721.432 -766.788)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M956.8,799.478v1.065h-1.083v-1.065Z",
    transform: "translate(-911.539 -770.119)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M983.129,799.893H984.2v1.072h-1.073Z",
    transform: "translate(-933.909 -770.458)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M880.456,791.259h1.081v1.077h-1.081Z",
    transform: "translate(-850.107 -763.411)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M929.377,799.013v1.071h-1.082v-1.071Z",
    transform: "translate(-889.153 -769.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M902,799.61h-1.069v-1.079H902Z",
    transform: "translate(-866.816 -769.346)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M791.261,797.65v-1.076h1.076v1.076Z",
    transform: "translate(-777.306 -767.749)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M846.121,797.473h1.071v1.076h-1.071Z",
    transform: "translate(-822.083 -768.482)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M832.469,797.3h1.077v1.077h-1.077Z",
    transform: "translate(-810.94 -768.342)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M908.946,791.747v1.069H907.86v-1.069Z",
    transform: "translate(-872.474 -763.809)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M949.04,792.473h1.082v1.076H949.04Z",
    transform: "translate(-906.085 -764.402)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M895.307,792.661h-1.083v-1.076h1.083Z",
    transform: "translate(-861.344 -763.677)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M832.847,783.713h1.017v1.031h-1.017Z",
    transform: "translate(-811.249 -757.252)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M716.287,788.488H717.3v1.033h-1.013Z",
    transform: "translate(-716.112 -761.149)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M729.87,789.873v-1.019H730.9v1.019Z",
    transform: "translate(-727.199 -761.448)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M901.275,784.959H902.3v1.023h-1.024Z",
    transform: "translate(-867.099 -758.269)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M998.3,787.632h-1.021v-1.021H998.3Z",
    transform: "translate(-945.454 -759.617)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M779.074,783.81H778.06v-1.023h1.014Z",
    transform: "translate(-766.531 -756.496)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M724.25,781.9v1.015h-1.033V781.9Z",
    transform: "translate(-721.769 -755.775)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M826.905,790.424v1.022h-1.028v-1.022Z",
    transform: "translate(-805.56 -762.729)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M840.519,790.762v1.019h-1.031v-1.019Z",
    transform: "translate(-816.669 -763.005)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M737.867,783.075h-1.026v-1.024h1.026Z",
    transform: "translate(-732.889 -755.895)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M943.494,786.7H942.48v-1.033h1.014Z",
    transform: "translate(-900.731 -758.846)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M771.067,789.514h1.018v1.023h-1.018Z",
    transform: "translate(-760.824 -761.987)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M957.108,786.914h-1.017v-1.031h1.017Z",
    transform: "translate(-911.84 -759.023)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M784.715,789.7h1.014v1.032h-1.014Z",
    transform: "translate(-771.963 -762.137)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M846.482,783.983H847.5v1.028h-1.019Z",
    transform: "translate(-822.378 -757.472)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M750.547,783.3v-1.016h1.025V783.3Z",
    transform: "translate(-744.076 -756.085)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M765.355,783.614h-1.022v-1.022h1.022Z",
    transform: "translate(-755.328 -756.337)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M791.685,783.038H792.7v1.033h-1.014Z",
    transform: "translate(-777.652 -756.701)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M819.161,783.429h1.015v1.032h-1.015Z",
    transform: "translate(-800.078 -757.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M887.62,785.7v-1.018h1.031V785.7Z",
    transform: "translate(-855.954 -758.042)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M744.615,790.058H743.6V789.04h1.019Z",
    transform: "translate(-738.402 -761.6)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M874.964,784.471v1.016h-1.026v-1.016Z",
    transform: "translate(-844.787 -757.87)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M970.837,786.118v1.024h-1.02v-1.024Z",
    transform: "translate(-923.044 -759.214)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M805.33,784.3v-1.008h1.026V784.3Z",
    transform: "translate(-788.789 -756.906)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M853.236,790.963h1.013v1.023h-1.013Z",
    transform: "translate(-827.89 -763.169)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M758.389,789.326v1.013h-1.03v-1.013Z",
    transform: "translate(-749.635 -761.833)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M929.816,786.306H928.78v-1.04c.3,0,.593-.007.885.007a.208.208,0,0,1,.144.141C929.823,785.706,929.816,786,929.816,786.306Z",
    transform: "translate(-889.549 -758.517)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M861.2,785.215h-1.018V784.2H861.2Z",
    transform: "translate(-833.559 -757.647)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M983.592,786.415h1.016v1.016h-1.016Z",
    transform: "translate(-934.287 -759.457)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M915,785.205h1.015v1.025H915Z",
    transform: "translate(-878.305 -758.469)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M799.406,791.1H798.39v-1.02h1.016Z",
    transform: "translate(-783.125 -762.446)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M813.206,791.228h-1.018V790.2h1.018Z",
    transform: "translate(-794.387 -762.547)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M943.749,772.077v.987h-.982v-.987Z",
    transform: "translate(-900.965 -747.754)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M880.935,778.811v-.989h.984v.989Z",
    transform: "translate(-850.498 -752.443)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M949.5,780v-.986h.963V780Z",
    transform: "translate(-906.461 -753.42)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M868.271,777.661v.965h-.985v-.965Z",
    transform: "translate(-839.358 -752.312)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M997.519,774.09v-.961h.984v.961Z",
    transform: "translate(-945.654 -748.613)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M757.7,776.677v-.964h.974v.964Z",
    transform: "translate(-749.913 -750.722)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M983.891,772.763h.976v.985h-.976Z",
    transform: "translate(-934.531 -748.314)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M772.358,775.907v.978h-.986v-.978Z",
    transform: "translate(-761.073 -750.88)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M971.229,773.545h-.957v-.976h.957Z",
    transform: "translate(-923.415 -748.156)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M839.852,778.1v-.97h.975v.97Z",
    transform: "translate(-816.966 -751.876)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M798.842,777.405v-.978h.965v.978Z",
    transform: "translate(-783.494 -751.305)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M730.24,776.231v-.975h.971v.975Z",
    transform: "translate(-727.501 -750.349)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M923.1,779.6h-.977v-.974h.977Z",
    transform: "translate(-884.119 -753.095)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M812.487,776.707h.976v.971h-.976Z",
    transform: "translate(-794.631 -751.533)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M717.553,774.98v.967h-.98v-.967Z",
    transform: "translate(-716.346 -750.124)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M826.128,777.874v-.963h.984v.963Z",
    transform: "translate(-805.765 -751.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M990.6,779.742h.981v.985H990.6Z",
    transform: "translate(-940.011 -754.011)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M908.445,779.324v-.975h.971v.975Z",
    transform: "translate(-872.952 -752.874)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M936.783,778.883v.961H935.8v-.961Z",
    transform: "translate(-895.277 -753.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M786.061,777.187h-.954v-.973h.954Z",
    transform: "translate(-772.283 -751.131)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M977.878,780.513H976.9v-.968h.981Z",
    transform: "translate(-928.822 -753.85)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M853.647,778.389v-.962h.972v.962Z",
    transform: "translate(-828.225 -752.121)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M895.68,778.147v.95h-.97v-.95Z",
    transform: "translate(-861.741 -752.709)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M744.048,775.5h.965v.964h-.965Z",
    transform: "translate(-738.771 -750.548)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1004.334,780.057h.96v.969h-.96Z",
    transform: "translate(-951.216 -754.268)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M964.289,780.2h-.978v-.981c.284,0,.567-.006.849.006a.188.188,0,0,1,.123.135C964.3,779.635,964.289,779.909,964.289,780.2Z",
    transform: "translate(-917.733 -753.583)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M956.464,772.331h.968v.965h-.968Z",
    transform: "translate(-912.145 -747.962)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M882.308,764.308v.925h-.946v-.925Z",
    transform: "translate(-850.847 -741.413)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M875.353,771.041v.917h-.939v-.917Z",
    transform: "translate(-845.176 -746.909)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M915.541,771.717h.917v.937h-.917Z",
    transform: "translate(-878.744 -747.461)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M929.211,772.869v-.926h.938v.926Z",
    transform: "translate(-889.901 -747.645)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M991.935,766.226v.924H991v-.924Z",
    transform: "translate(-940.33 -742.979)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M936.158,766.155v-.917h.937v.917Z",
    transform: "translate(-895.571 -742.172)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M819.562,771.022V770.1h.946v.922Z",
    transform: "translate(-800.406 -746.141)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M963.547,766.65v-.931h.937v.931Z",
    transform: "translate(-917.926 -742.565)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M901.8,772.383v-.939h.925v.939Z",
    transform: "translate(-867.529 -747.238)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M846.988,771.467v-.931h.926v.931Z",
    transform: "translate(-822.791 -746.497)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M778.567,769.283h.9v.936h-.9Z",
    transform: "translate(-766.945 -745.474)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M827.515,763.451v.9h-.943v-.9Z",
    transform: "translate(-806.126 -740.714)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M841.24,764.506h-.908v-.94h.908Z",
    transform: "translate(-817.358 -740.808)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M765.746,769.152v.905H764.8v-.905Z",
    transform: "translate(-755.712 -745.367)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M896.047,765.408h-.912v-.94h.912Z",
    transform: "translate(-862.088 -741.544)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M812.818,764.05v-.918h.928v.918Z",
    transform: "translate(-794.901 -740.454)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1005.687,766.452v.926h-.91v-.926Z",
    transform: "translate(-951.577 -743.163)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M888.177,772.2v-.922h.908v.922Z",
    transform: "translate(-856.409 -747.105)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M861.652,771.707h-.924v-.923h.924Z",
    transform: "translate(-834.005 -746.699)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M738.335,768.656v.916h-.926v-.916Z",
    transform: "translate(-733.352 -744.962)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M799.148,763.793v-.93h.92v.93Z",
    transform: "translate(-783.744 -740.234)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M867.642,765v-.9h.928v.9Z",
    transform: "translate(-839.648 -741.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M793.115,769.531v.929h-.93v-.929Z",
    transform: "translate(-778.06 -745.676)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M854.886,764.7h-.93v-.93h.93Z",
    transform: "translate(-828.478 -740.978)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M751.117,768.853h.92v.93h-.92Z",
    transform: "translate(-744.541 -745.123)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M949.932,766.457v-.917h.91v.917Z",
    transform: "translate(-906.813 -742.419)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M923.4,765.933h-.924V765h.924Z",
    transform: "translate(-884.401 -741.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M977.308,765.965h.919v.91h-.919Z",
    transform: "translate(-929.158 -742.766)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M908.761,765.685v-.9h.927v.9Z",
    transform: "translate(-873.21 -741.799)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M786.441,762.572v.921h-.917v-.921Z",
    transform: "translate(-772.624 -739.996)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M805.862,770.786v-.915h.925v.915Z",
    transform: "translate(-789.223 -745.954)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M724.686,768.406v.912h-.909v-.912Z",
    transform: "translate(-722.226 -744.758)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M833.377,770.352h.91v.909h-.91Z",
    transform: "translate(-811.681 -746.346)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M806.274,756.168h.878v.9h-.878Z",
    transform: "translate(-789.56 -734.769)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M985.252,760.213h-.893v-.888h.893Z",
    transform: "translate(-934.913 -737.346)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M929.48,759.33v-.874h.908v.874Z",
    transform: "translate(-890.12 -736.637)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M861.054,758.119v-.873h.888v.873Z",
    transform: "translate(-834.271 -735.649)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M916.783,759.032h-.877v-.877h.877Z",
    transform: "translate(-879.041 -736.391)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M745.4,762.085v.875h-.883v-.875Z",
    transform: "translate(-739.158 -739.599)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M752.339,756.167h-.883v-.873h.883Z",
    transform: "translate(-744.817 -734.056)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M792.549,755.963h.869v.89h-.869Z",
    transform: "translate(-778.357 -734.602)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M998.971,760.527h-.866v-.881h.866Z",
    transform: "translate(-946.132 -737.608)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M731.676,762.627h-.867v-.89h.867Z",
    transform: "translate(-727.965 -739.314)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M724.066,754.783h.873v.883h-.873Z",
    transform: "translate(-722.462 -733.639)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M737.732,755.973v-.883h.872v.883Z",
    transform: "translate(-733.616 -733.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M971.6,760.08h-.879v-.872h.879Z",
    transform: "translate(-923.784 -737.251)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M944.169,758.635v.871h-.874v-.871Z",
    transform: "translate(-901.396 -736.783)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M717.079,762.5v-.864h.875v.864Z",
    transform: "translate(-716.759 -739.232)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M848.266,757.076v.862H847.4v-.862Z",
    transform: "translate(-823.123 -735.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M888.485,757.708h.871v.875h-.871Z",
    transform: "translate(-856.66 -736.026)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M759.142,762.313v.865h-.875v-.865Z",
    transform: "translate(-750.377 -739.785)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1005.038,753.758v-.867h.875v.867Z",
    transform: "translate(-951.791 -732.094)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M834.559,757.638h-.865v-.874h.865Z",
    transform: "translate(-811.94 -735.256)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M903.07,758.856h-.86v-.87h.86Z",
    transform: "translate(-867.863 -736.253)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M772.794,763.4h-.859v-.869h.859Z",
    transform: "translate(-761.532 -739.966)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M956.987,758.835h.865v.89h-.865Z",
    transform: "translate(-912.572 -736.946)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M875.725,757.413v.874h-.874v-.874Z",
    transform: "translate(-845.532 -735.786)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M778.9,755.818h.86v.869h-.86Z",
    transform: "translate(-767.217 -734.484)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M766.106,755.528v.873h-.874v-.873Z",
    transform: "translate(-756.061 -734.247)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M820.934,757.41h-.863v-.874h.863Z",
    transform: "translate(-800.821 -735.07)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M745.665,748.445v.834h-.846v-.834Z",
    transform: "translate(-739.4 -728.466)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M862.251,743.6v.834h-.846V743.6Z",
    transform: "translate(-834.558 -724.514)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M964.035,752.27h.845v.845h-.845Z",
    transform: "translate(-918.324 -731.588)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M958.2,745.3v.84h-.835v-.84Z",
    transform: "translate(-912.883 -725.901)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M896.44,751.077v.833h-.83v-.833Z",
    transform: "translate(-862.476 -730.614)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M951.247,752.074v.816h-.831v-.816Z",
    transform: "translate(-907.208 -731.428)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M840.788,750.958v-.814h.827v.814Z",
    transform: "translate(-817.73 -729.852)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M882.724,750.834v.827h-.812v-.827Z",
    transform: "translate(-851.295 -730.416)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M903.408,744.427v.811h-.826v-.811Z",
    transform: "translate(-868.166 -725.187)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M971.848,746.413h-.835v-.826h.835Z",
    transform: "translate(-924.02 -726.133)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M909.2,752.193v-.81h.846v.81Z",
    transform: "translate(-873.569 -730.864)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M827.063,750.729v-.837h.819v.837Z",
    transform: "translate(-806.528 -729.647)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M731.188,748.265h.827v.817h-.827Z",
    transform: "translate(-728.275 -728.319)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M854.4,751.215v-.823h.846v.823Z",
    transform: "translate(-828.844 -730.055)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M875.119,744.735v-.818h.836v.818Z",
    transform: "translate(-845.751 -724.77)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M937.53,751.759v.84h-.819v-.84Z",
    transform: "translate(-896.023 -731.171)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M929.963,745.623v-.841h.825v.841Z",
    transform: "translate(-890.515 -725.476)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M944.5,745.917h-.813v-.835h.813Z",
    transform: "translate(-901.716 -725.721)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M998.473,746h.815v.844h-.815Z",
    transform: "translate(-946.433 -726.467)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M847.72,744.273v-.816h.835v.816Z",
    transform: "translate(-823.388 -724.395)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M786.805,750.029h-.83V749.2h.83Z",
    transform: "translate(-772.992 -729.085)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M813.362,750.506v-.836h.831v.836Z",
    transform: "translate(-795.345 -729.466)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M800.448,750.292H799.6v-.818h.846Z",
    transform: "translate(-784.114 -729.305)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M759.406,748.729v.82h-.835v-.82Z",
    transform: "translate(-750.624 -728.698)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M916.175,745.474v-.8h.842v.8Z",
    transform: "translate(-879.261 -725.386)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M889.672,744.943h-.814V744.1h.814Z",
    transform: "translate(-856.965 -724.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M868.226,750.672h.822v.818h-.822Z",
    transform: "translate(-840.125 -730.284)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M992.354,752.842v.8h-.814v-.8Z",
    transform: "translate(-940.773 -732.055)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M985.608,745.842v.812h-.836v-.812Z",
    transform: "translate(-935.25 -726.341)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M773.088,749.772h-.813v-.82h.813Z",
    transform: "translate(-761.81 -728.88)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M923.838,751.6v.81h-.832v-.81Z",
    transform: "translate(-884.836 -731.043)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M977.813,752.493h.829v.826h-.829Z",
    transform: "translate(-929.57 -731.77)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M718.274,747.984v.826h-.818v-.826Z",
    transform: "translate(-717.066 -728.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M841.888,737.321H841.1v-.79h.786Z",
    transform: "translate(-817.986 -718.742)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M759.738,735.891h-.786V735.1h.786Z",
    transform: "translate(-750.935 -717.574)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M834.109,744.083v-.775h.786v.775Z",
    transform: "translate(-812.279 -724.273)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M724.485,742.172v-.783h.79v.783Z",
    transform: "translate(-722.804 -722.707)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M787.1,735.642v.78h-.79v-.78Z",
    transform: "translate(-773.263 -718.016)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M978.969,738.946v.788h-.789v-.788Z",
    transform: "translate(-929.87 -720.713)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M896.7,738.333h-.781v-.79h.781Z",
    transform: "translate(-862.73 -719.568)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M950.683,739.231v-.78h.789v.78Z",
    transform: "translate(-907.426 -720.309)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M780.11,743.167h-.779V742.4h.779Z",
    transform: "translate(-767.569 -723.53)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M827.456,737.132v-.774h.771v.774Z",
    transform: "translate(-806.849 -718.601)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M882.256,738.006v-.778h.77v.778Z",
    transform: "translate(-851.576 -719.311)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M765.708,742.061h.771v.789h-.771Z",
    transform: "translate(-756.45 -723.255)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M717.844,735.184V734.4h.771v.786Z",
    transform: "translate(-717.383 -717.001)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M772.7,735.374h.76v.77h-.76Z",
    transform: "translate(-762.159 -717.797)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M793.1,743.366v-.781h.767v.781Z",
    transform: "translate(-778.806 -723.683)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M964.484,739.511v-.786h.77v.786Z",
    transform: "translate(-918.691 -720.532)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M752.777,741.944v.765h-.79v-.765Z",
    transform: "translate(-745.251 -723.16)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M992.656,739.2v.769h-.78V739.2Z",
    transform: "translate(-941.048 -720.916)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M731.46,735.413v-.766h.791v.766Z",
    transform: "translate(-728.497 -717.203)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M937.076,738.272h.776v.769h-.776Z",
    transform: "translate(-896.32 -720.163)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1006.31,740.3h-.781v-.771h.781Z",
    transform: "translate(-952.192 -721.185)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M813.725,736.931v-.75h.789v.75Z",
    transform: "translate(-795.641 -718.455)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M923.371,738.027h.789v.763h-.789Z",
    transform: "translate(-885.134 -719.963)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M820.483,743.883v-.751h.771v.751Z",
    transform: "translate(-801.157 -724.13)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M909.684,737.7h.767v.789h-.767Z",
    transform: "translate(-873.963 -719.693)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M869.343,737.854h-.785v-.77h.785Z",
    transform: "translate(-840.396 -719.193)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M854.866,737.606v-.787h.771v.787Z",
    transform: "translate(-829.221 -718.977)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M806.776,743.6v-.772h.788v.772Z",
    transform: "translate(-789.97 -723.884)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M738.25,742.386v-.761h.781v.761Z",
    transform: "translate(-734.039 -722.899)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M746.06,734.957v.768h-.768v-.768Z",
    transform: "translate(-739.786 -717.457)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M800.048,736.634v-.768h.768v.768Z",
    transform: "translate(-784.478 -718.199)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M992.958,725.649v.725h-.734v-.725Z",
    transform: "translate(-941.333 -709.86)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M794.2,729.772h-.735v-.734h.735Z",
    transform: "translate(-779.101 -712.626)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M938.037,724.736v.746c-.208,0-.409.011-.607-.007a.21.21,0,0,1-.142-.144c-.018-.19-.007-.384-.007-.595Z",
    transform: "translate(-896.485 -709.115)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M931.169,732.133h-.725V731.4h.725Z",
    transform: "translate(-890.907 -714.553)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M738.638,728.784v-.729h.735v.729Z",
    transform: "translate(-734.355 -711.824)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M848.286,729.928h.728v.733h-.728Z",
    transform: "translate(-823.85 -713.352)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M965.59,725.1v.734h-.735V725.1Z",
    transform: "translate(-918.994 -709.41)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M910.781,724.927h-.734v-.734h.734Z",
    transform: "translate(-874.259 -708.671)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M876.355,731.212h-.731v-.734h.731Z",
    transform: "translate(-846.163 -713.801)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M985.218,733.111v-.729h.734v.729Z",
    transform: "translate(-935.614 -715.355)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M807.888,729.993h-.715v-.734h.715Z",
    transform: "translate(-790.294 -712.806)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M917.521,731.176v.731h-.716v-.731Z",
    transform: "translate(-879.775 -714.371)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M979.3,725.43v.729h-.716v-.729Z",
    transform: "translate(-930.201 -709.681)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M924.48,724.411v.728h-.724v-.728Z",
    transform: "translate(-885.449 -708.849)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M861.981,730.968v-.709h.714v.709Z",
    transform: "translate(-835.028 -713.623)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M971.617,732.221h.716v.706h-.716Z",
    transform: "translate(-924.513 -715.224)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M999.721,733.321h-.714v-.734h.714Z",
    transform: "translate(-946.868 -715.523)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M821.534,730.242h-.726v-.715h.726Z",
    transform: "translate(-801.422 -713.025)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M903.067,731.714v-.7h.736v.7Z",
    transform: "translate(-868.562 -714.236)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M752.346,729.074v-.7h.732v.7Z",
    transform: "translate(-745.544 -712.088)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M944.952,731.715v.725h-.715v-.725Z",
    transform: "translate(-902.165 -714.811)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M725.712,728.558h-.706v-.741h.706Z",
    transform: "translate(-723.229 -711.629)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M766.721,728.6v.709h-.743V728.6Z",
    transform: "translate(-756.67 -712.264)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M780.493,728.75v.726h-.726v-.726Z",
    transform: "translate(-767.925 -712.391)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M957.853,732.66v-.709h.743v.709Z",
    transform: "translate(-913.278 -715.004)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1006.688,726.635h-.713v-.707h.713Z",
    transform: "translate(-952.556 -710.088)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M834.57,730.511v-.719h.715v.719Z",
    transform: "translate(-812.655 -713.241)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M890.105,730.724v.71h-.72v-.71Z",
    transform: "translate(-857.395 -714.002)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M945.284,718.067v.681h-.677v-.681Z",
    transform: "translate(-902.467 -703.672)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M951.155,725.668v-.718h.715v.718Z",
    transform: "translate(-907.812 -709.289)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M842.389,723.168v.682h-.678v-.682Z",
    transform: "translate(-818.484 -707.835)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M882.812,723.867h.671v.678h-.671Z",
    transform: "translate(-852.03 -708.405)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M862.263,717.307v-.666h.686v.666Z",
    transform: "translate(-835.258 -702.507)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M828.689,722.92v.669h-.678v-.669Z",
    transform: "translate(-807.302 -707.633)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M889.744,717.149h.683v.669h-.683Z",
    transform: "translate(-857.688 -702.922)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M752.642,715.424v-.671h.7v.671Z",
    transform: "translate(-745.786 -700.967)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M732.754,721.89h-.669V721.2h.669Z",
    transform: "translate(-729.006 -706.23)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1000.058,719.727h-.675v-.68h.675Z",
    transform: "translate(-947.175 -704.471)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M773.151,722.673V722h.68v.67Z",
    transform: "translate(-762.525 -706.884)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M793.849,716.134v-.668h.679v.668Z",
    transform: "translate(-779.419 -701.549)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M745.74,721.453h.664v.674h-.664Z",
    transform: "translate(-740.152 -706.435)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M896.493,724.787v-.677h.68v.677Z",
    transform: "translate(-863.196 -708.604)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M807.472,716.432v-.664h.687v.664Z",
    transform: "translate(-790.538 -701.795)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M958.991,719.074h-.661V718.4h.661Z",
    transform: "translate(-913.668 -703.946)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M800.484,723.1v-.679h.686v.679Z",
    transform: "translate(-784.834 -707.225)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M835.637,716.2v.682h-.679V716.2Z",
    transform: "translate(-812.972 -702.147)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M931.545,717.852v.67h-.67v-.67Z",
    transform: "translate(-891.259 -703.496)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M917.8,718.352h-.672v-.667h.672Z",
    transform: "translate(-880.041 -703.36)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M904.162,717.423v.652h-.678v-.652Z",
    transform: "translate(-868.903 -703.146)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M876.746,716.881v.678h-.67v-.678Z",
    transform: "translate(-846.532 -702.703)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M869.763,724.278h-.652V723.6h.652Z",
    transform: "translate(-840.847 -708.188)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M855.293,724.119v-.658h.68v.658Z",
    transform: "translate(-829.569 -708.074)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M848.625,717.165v-.653h.678v.653Z",
    transform: "translate(-824.127 -702.402)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M760.149,721.685v.673h-.669v-.673Z",
    transform: "translate(-751.366 -706.625)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M821.261,715.9h.655v.678h-.655Z",
    transform: "translate(-801.792 -701.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M766.486,715.009h.654v.679h-.654Z",
    transform: "translate(-757.085 -701.176)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M814.968,722.691v.668H814.3v-.668Z",
    transform: "translate(-796.115 -707.446)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M787.6,722.227v.656h-.679v-.656Z",
    transform: "translate(-773.764 -707.067)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M780.181,715.228h.667v.659h-.667Z",
    transform: "translate(-768.263 -701.354)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M985.693,718.729h.659v.687h-.659Z",
    transform: "translate(-936.002 -704.212)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M971.9,719.269v-.66h.677v.66Z",
    transform: "translate(-924.744 -704.114)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M718.353,720.981h.677v.66h-.677Z",
    transform: "translate(-717.799 -706.05)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M883.746,710.285v.626H883.1v-.626Z",
    transform: "translate(-852.267 -697.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M828.315,709.342h.633v.625h-.633Z",
    transform: "translate(-807.55 -696.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1000.337,706.052h-.626v-.635h.626Z",
    transform: "translate(-947.443 -693.346)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M841.991,710.213v-.636h.632v.636Z",
    transform: "translate(-818.712 -696.742)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M993.347,712.871h-.642v-.633h.642Z",
    transform: "translate(-941.725 -698.914)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M774.19,709h-.612v-.644h.612Z",
    transform: "translate(-762.873 -695.744)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M896.8,710.483h.638v.633H896.8Z",
    transform: "translate(-863.449 -697.481)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M746.194,707.809h.62v.637h-.62Z",
    transform: "translate(-740.523 -695.299)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M726.079,714.451v.615h-.631v-.615Z",
    transform: "translate(-723.59 -700.72)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M718.736,708.085v-.618h.624v.618Z",
    transform: "translate(-718.111 -695.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1006.394,713.047v-.619h.638v.619Z",
    transform: "translate(-952.898 -699.069)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M760.477,708.142v.621h-.624v-.621Z",
    transform: "translate(-751.671 -695.571)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M814.65,709.025h.62v.631h-.62Z",
    transform: "translate(-796.396 -696.291)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M979.716,712v.62h-.623V712Z",
    transform: "translate(-930.615 -698.719)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M732.388,707.672h.632v.631h-.632Z",
    transform: "translate(-729.254 -695.187)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M952.254,712.113h-.625v-.621h.625Z",
    transform: "translate(-908.199 -698.305)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M986.011,705.927V705.3h.633v.626Z",
    transform: "translate(-936.261 -693.252)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M924.3,711.017h.619v.631H924.3Z",
    transform: "translate(-885.893 -697.917)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M787.2,708.633h.627v.622H787.2Z",
    transform: "translate(-773.987 -695.971)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M959.333,704.835v.6h-.6v-.6Z",
    transform: "translate(-914.001 -692.871)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M856.389,710.473h-.6v-.631h.6Z",
    transform: "translate(-829.971 -696.958)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M937.862,711.959v-.6h.641v.6Z",
    transform: "translate(-896.962 -698.198)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M870.089,710.744h-.615v-.6h.615Z",
    transform: "translate(-841.144 -697.205)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M965.4,711.679h.605v.633H965.4Z",
    transform: "translate(-919.438 -698.458)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M739.187,715.281v-.631h.6v.631Z",
    transform: "translate(-734.803 -700.882)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M911.23,711.445h-.6v-.621h.6Z",
    transform: "translate(-874.738 -697.76)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M801.6,709.5h-.613V708.9h.613Z",
    transform: "translate(-785.248 -696.187)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M952.079,697.817h.571v.6h-.571Z",
    transform: "translate(-908.566 -687.143)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M766.863,702.109v-.6h.585v.6Z",
    transform: "translate(-757.393 -690.161)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M979.373,698.969v-.579h.584v.579Z",
    transform: "translate(-930.843 -687.611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M849.114,703.49V702.9h.587v.588Z",
    transform: "translate(-824.526 -691.294)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M862.856,703.168h.567v.586h-.567Z",
    transform: "translate(-835.742 -691.511)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M869.737,697.1v-.574h.585v.574Z",
    transform: "translate(-841.358 -686.088)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M904.549,704.492h-.585v-.582h.585Z",
    transform: "translate(-869.294 -692.117)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M842.422,696.564v-.589h.585v.589Z",
    transform: "translate(-819.064 -685.64)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M856.065,696.83v-.576h.6v.576Z",
    transform: "translate(-830.199 -685.868)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M966.313,698.148v.577h-.593v-.577Z",
    transform: "translate(-919.7 -687.414)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M931.922,704.467v.567h-.587v-.567Z",
    transform: "translate(-891.634 -692.571)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M725.822,701.393v-.568h.587v.568Z",
    transform: "translate(-723.895 -689.599)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M808.582,702.245v.591H808v-.591Z",
    transform: "translate(-790.969 -690.758)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M993.084,699.2v-.584h.576v.584Z",
    transform: "translate(-942.034 -687.798)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M918.207,704.139v.589h-.586v-.589Z",
    transform: "translate(-880.441 -692.303)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M753.78,701.935H753.2v-.577h.578Z",
    transform: "translate(-746.242 -690.034)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M911.481,697.761h-.587v-.6h.587Z",
    transform: "translate(-874.951 -686.611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M814.92,696.183v-.567h.6v.567Z",
    transform: "translate(-796.617 -685.347)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M794.916,701.995v.58h-.593v-.58Z",
    transform: "translate(-779.805 -690.553)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M973.028,705.147v.567h-.588v-.567Z",
    transform: "translate(-925.184 -693.126)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M925.181,697.465v.576H924.6v-.576Z",
    transform: "translate(-886.137 -686.856)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M740.079,701.694h-.592v-.579h.592Z",
    transform: "translate(-735.048 -689.835)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M938.889,698.27h-.57v-.58h.57Z",
    transform: "translate(-897.334 -687.04)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M945.684,705.258h-.58v-.576h.58Z",
    transform: "translate(-902.873 -692.747)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1006.791,699.413c0-.142,0-.26,0-.378,0-.062.007-.125.012-.2.068-.005.121-.013.174-.014.128,0,.255,0,.4,0v.594Z",
    transform: "translate(-953.221 -687.961)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M780.669,702.289v-.575c.668-.088.638-.084.565.554a.936.936,0,0,1-.127.019C780.97,702.291,780.833,702.289,780.669,702.289Z",
    transform: "translate(-768.661 -690.292)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M822.284,702.559v.573H821.7v-.573Z",
    transform: "translate(-802.151 -691.014)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M884.072,697.4H883.5v-.574h.575Z",
    transform: "translate(-852.589 -686.335)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M876.556,703.455h.567v.577h-.567Z",
    transform: "translate(-846.924 -691.745)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M897.282,696.936h.571v.58h-.571Z",
    transform: "translate(-863.841 -686.424)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M836.073,702.79v.555h-.586v-.555Z",
    transform: "translate(-813.403 -691.202)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M828.663,696.314v-.577h.575v.577Z",
    transform: "translate(-807.834 -685.446)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M890.307,703.731h.556c.093.675.076.638-.556.567Z",
    transform: "translate(-858.148 -691.97)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M719.751,694.5h-.528v-.548h.528Z",
    transform: "translate(-718.509 -683.987)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M754.107,688.244h-.534v-.539h.534Z",
    transform: "translate(-746.545 -678.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M788.241,695.689h-.533v-.548h.533Z",
    transform: "translate(-774.406 -684.959)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M808.927,689.218h-.549v-.539h.549Z",
    transform: "translate(-791.276 -679.684)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M850.048,689.921h-.532v-.556h.532Z",
    transform: "translate(-824.854 -680.245)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M780.977,688.13h.535v.556h-.535Z",
    transform: "translate(-768.913 -679.237)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M972.737,691.916c-.054-.6-.025-.63.522-.528v.528Z",
    transform: "translate(-925.411 -681.859)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M918.55,690.633v.542h-.519v-.542Z",
    transform: "translate(-880.776 -681.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M945.392,691.63v-.517h.541v.517Z",
    transform: "translate(-903.108 -681.672)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M794.657,688.986v-.516h.54v.516Z",
    transform: "translate(-780.078 -679.514)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1000.762,692.556h-.537v-.54h.537Z",
    transform: "translate(-947.863 -682.408)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M904.838,690.986h-.528v-.521h.528Z",
    transform: "translate(-869.577 -681.143)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M733.451,694.25v.515h-.54v-.515Z",
    transform: "translate(-729.682 -684.232)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M747.144,694.445v.529h-.526v-.529Z",
    transform: "translate(-740.869 -684.391)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M959.083,691.88v-.535h.54v.535Z",
    transform: "translate(-914.283 -681.861)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M774.564,694.973v.537h-.541v-.537Z",
    transform: "translate(-763.237 -684.822)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M863.194,689.591h.519v.533h-.519Z",
    transform: "translate(-836.018 -680.429)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M836.362,689.264v.511h-.54v-.511Z",
    transform: "translate(-813.677 -680.162)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M877.009,689.853h.51v.529h-.51Z",
    transform: "translate(-847.294 -680.643)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M760.383,694.732h.525v.522h-.525Z",
    transform: "translate(-752.104 -684.625)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M931.782,690.759h.518v.539h-.518Z",
    transform: "translate(-891.999 -681.383)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M822.206,688.9h.513v.537h-.513Z",
    transform: "translate(-802.563 -679.867)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M726.74,687.784h-.529v-.526h.529Z",
    transform: "translate(-724.212 -678.525)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M890.581,690.666v-.535h.541v.535Z",
    transform: "translate(-858.371 -680.87)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M740.4,688h-.541v-.54h.541Z",
    transform: "translate(-735.353 -678.693)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M986.56,692.324v-.51h.53v.51Z",
    transform: "translate(-936.709 -682.244)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M767.875,688.022v.516h-.524v-.516Z",
    transform: "translate(-757.79 -679.149)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M801.969,695.447v.511h-.53v-.511Z",
    transform: "translate(-785.613 -685.209)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M918.279,677.487V677h.517v.483Z",
    transform: "translate(-880.978 -670.156)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M733.33,680.589h.49v.491h-.49Z",
    transform: "translate(-730.023 -673.082)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1007.849,685.929h-.485v-.494h.485Z",
    transform: "translate(-953.69 -677.037)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M802.238,682.3h-.485v-.5h.485Z",
    transform: "translate(-785.87 -674.074)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M904.657,677.311v-.475h.5v.475Z",
    transform: "translate(-869.86 -670.019)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M911.344,683.773h.49v.474h-.49Z",
    transform: "translate(-875.318 -675.681)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M857.051,683.38h-.49V682.9h.49Z",
    transform: "translate(-830.604 -674.966)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M815.51,682.08h.475v.5h-.475Z",
    transform: "translate(-797.098 -674.299)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M986.861,678.69V678.2h.493v.487Z",
    transform: "translate(-936.955 -671.134)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M952.534,684.445h.5v.473h-.5Z",
    transform: "translate(-908.937 -676.229)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M788.1,681.656h.49v.475h-.49Z",
    transform: "translate(-774.725 -673.953)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M938.853,684.225h.473v.488h-.473Z",
    transform: "translate(-897.771 -676.05)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M994.127,685.121v.494h-.48v-.494Z",
    transform: "translate(-942.493 -676.781)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1000.58,678.957v-.491h.484v.491Z",
    transform: "translate(-948.152 -671.349)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M973.628,678.514h-.493v-.479h.493Z",
    transform: "translate(-925.752 -670.997)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M959.979,678.265h-.492v-.484h.492Z",
    transform: "translate(-914.612 -670.79)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M870.36,682.987h.472v.493h-.472Z",
    transform: "translate(-841.867 -675.039)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M966.138,685.224v-.474h.494v.474Z",
    transform: "translate(-920.041 -676.478)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M747.075,680.867h.475v.5h-.475Z",
    transform: "translate(-741.242 -673.309)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M897.7,684.02v-.471h.492v.471Z",
    transform: "translate(-864.178 -675.498)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M932.609,677.26v.49h-.484v-.49Z",
    transform: "translate(-892.28 -670.365)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M842.89,683.041v-.473h.492v.473Z",
    transform: "translate(-819.446 -674.696)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M946.282,677.989h-.471v-.481h.471Z",
    transform: "translate(-903.45 -670.567)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M719.554,680.936v-.472h.482v.472Z",
    transform: "translate(-718.779 -672.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M829.243,682.314h.475v.484h-.475Z",
    transform: "translate(-808.307 -674.49)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M774.883,681.846h-.476v-.485h.476Z",
    transform: "translate(-763.55 -673.712)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M883.99,683.736v-.469h.479v.469Z",
    transform: "translate(-852.992 -675.268)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M925.164,684.065h.478v.476h-.478Z",
    transform: "translate(-886.598 -675.919)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M891.445,676.608v.468h-.488v-.468Z",
    transform: "translate(-858.678 -669.833)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M761.173,681.1v.485h-.485V681.1Z",
    transform: "translate(-752.352 -673.501)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M980.448,685.015v.469h-.479v-.469Z",
    transform: "translate(-931.33 -676.694)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M823.079,675.435v.432h-.442v-.432Z",
    transform: "translate(-802.915 -668.875)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M768.27,674.984h-.427v-.445h.427Z",
    transform: "translate(-758.192 -668.144)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M829.586,668.77h.439v.435h-.439Z",
    transform: "translate(-808.587 -663.435)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M884.828,670.143h-.443v-.436h.443Z",
    transform: "translate(-853.314 -664.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M816.294,668.93h-.42v-.436h.42Z",
    transform: "translate(-797.395 -663.21)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M898.209,669.988h.42v.436h-.42Z",
    transform: "translate(-864.597 -664.429)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M939.183,671.2v-.418h.443v.418Z",
    transform: "translate(-898.04 -665.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M953.019,670.9h.42v.435h-.42Z",
    transform: "translate(-909.333 -665.172)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M761.058,667.533h.422v.446h-.422Z",
    transform: "translate(-752.654 -662.425)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M994.008,671.654h.437v.421h-.437Z",
    transform: "translate(-942.788 -665.789)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1007.828,671.789h.42v.438h-.42Z",
    transform: "translate(-954.068 -665.899)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M719.941,667.336v-.417h.443v.417Z",
    transform: "translate(-719.095 -661.924)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M774.756,668.244v-.418h.442v.418Z",
    transform: "translate(-763.835 -662.665)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M877.435,676.51h.442v.417h-.442Z",
    transform: "translate(-847.641 -669.753)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M747.374,667.236h.422v.446h-.422Z",
    transform: "translate(-741.486 -662.183)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M836.361,676.211v-.431h.437v.431Z",
    transform: "translate(-814.117 -669.157)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M808.9,675.751v-.421h.43v.421Z",
    transform: "translate(-791.702 -668.79)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M966.639,671.1h.416v.426h-.416Z",
    transform: "translate(-920.45 -665.333)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M857.024,669.211h.415v.424h-.415Z",
    transform: "translate(-830.982 -663.795)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M781.585,675.163v-.42H782v.42Z",
    transform: "translate(-769.409 -668.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M980.717,671.841H980.3v-.43h.419Z",
    transform: "translate(-931.598 -665.591)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M850,676.41v-.415h.425v.415Z",
    transform: "translate(-825.25 -669.332)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M754.556,674.409v.416h-.425v-.416Z",
    transform: "translate(-747.001 -668.038)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M788.979,668.133v.42h-.43v-.42Z",
    transform: "translate(-775.093 -662.915)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M870.7,669.5h.419v.43H870.7Z",
    transform: "translate(-842.148 -664.027)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M925.944,670.462v.419h-.429v-.419Z",
    transform: "translate(-886.884 -664.816)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M802.153,668.757v-.422h.43v.422Z",
    transform: "translate(-786.196 -663.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M795.648,675.059v.426h-.43v-.426Z",
    transform: "translate(-780.536 -668.568)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M864.168,676.218v.419h-.43v-.419Z",
    transform: "translate(-836.462 -669.514)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M726.8,673.814h.421v.429H726.8Z",
    transform: "translate(-724.689 -667.552)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M734.2,667.131v.419h-.428v-.419Z",
    transform: "translate(-730.38 -662.098)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M843.358,669.41v-.421h.42v.421Z",
    transform: "translate(-819.828 -663.614)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M912.224,670.2v.419h-.429V670.2Z",
    transform: "translate(-875.686 -664.606)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M740.4,674.5v-.428h.428v.428Z",
    transform: "translate(-735.797 -667.765)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M987.34,665.158v-.4h.4v.4Z",
    transform: "translate(-937.346 -660.162)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M981.1,657.851v.38h-.391v-.38Z",
    transform: "translate(-931.93 -654.523)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M918.913,663.622h.384V664h-.384Z",
    transform: "translate(-881.496 -659.233)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M974.118,664.579v.371h-.39v-.371Z",
    transform: "translate(-926.236 -660.015)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M837.086,662.116v.4H836.7v-.4Z",
    transform: "translate(-814.389 -658.004)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M905.2,663.723v-.4h.373v.4Z",
    transform: "translate(-870.302 -658.989)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M727.088,660.174h.376v.409h-.376Z",
    transform: "translate(-724.928 -656.419)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M877.726,663.249v-.381h.4v.381Z",
    transform: "translate(-847.879 -658.618)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M823.346,662v.36h-.4V662Z",
    transform: "translate(-803.168 -657.907)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M768.248,661.3v-.392h.373v.392Z",
    transform: "translate(-758.523 -657.021)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M932.962,663.876v.362h-.4v-.362Z",
    transform: "translate(-892.635 -659.441)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M850.787,662.41v.382h-.366v-.382Z",
    transform: "translate(-825.593 -658.244)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M864.1,662.645h.379v.364H864.1Z",
    transform: "translate(-836.761 -658.436)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M809.271,662.1v-.361h.382v.361Z",
    transform: "translate(-792.006 -657.701)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M966.977,657.95v-.383h.373v.383Z",
    transform: "translate(-920.726 -654.291)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M795.947,661.862h-.374v-.392h.374Z",
    transform: "translate(-780.826 -657.477)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M994.35,658.075h.388v.37h-.388Z",
    transform: "translate(-943.067 -654.706)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M782.3,661.2v.385h-.379V661.2Z",
    transform: "translate(-769.68 -657.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M754.887,660.781v.366H754.5v-.366Z",
    transform: "translate(-747.305 -656.915)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M891.9,663.188v.362h-.385v-.362Z",
    transform: "translate(-859.137 -658.879)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M960.395,664.774h-.366V664.4h.366Z",
    transform: "translate(-915.055 -659.868)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M953.671,657.418v.367h-.39v-.367Z",
    transform: "translate(-909.547 -654.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1008.07,658.7v-.364h.382v.364Z",
    transform: "translate(-954.266 -654.918)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M740.743,660.916v-.363h.378v.363Z",
    transform: "translate(-736.073 -656.728)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1001.095,665.438v-.359h.382v.359Z",
    transform: "translate(-948.573 -660.423)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M946.7,664.489h-.385v-.382h.385Z",
    transform: "translate(-903.862 -659.629)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M885.272,656.643h-.336V656.3h.336Z",
    transform: "translate(-853.764 -653.256)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M748.2,653.758v.354h-.34v-.339Z",
    transform: "translate(-741.886 -651.182)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M919.578,650.376h-.334v-.343h.334Z",
    transform: "translate(-881.766 -648.142)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1001.847,651.435v.342h-.346v-.342Z",
    transform: "translate(-948.904 -649.286)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1014.307,665.438v-.359h.382v.359Z",
    transform: "translate(-959.356 -660.423)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1013.77,651.435v.342h-.346v-.342Z",
    transform: "translate(-958.636 -649.286)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M802.988,654.88v.337h-.347v-.337Z",
    transform: "translate(-786.594 -652.098)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M857.416,656.121v-.334h.344v.334Z",
    transform: "translate(-831.302 -652.839)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M946.729,650.527h.339v.345l-.339.017Z",
    transform: "translate(-904.199 -648.545)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M809.945,648.451H809.6v-.345h.343Z",
    transform: "translate(-792.276 -646.569)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M851.129,648.822v.338H850.8v-.338Z",
    transform: "translate(-825.904 -647.154)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M795.958,647.878h.328v.341h-.328Z",
    transform: "translate(-781.14 -646.383)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M864.423,649.078h.335v.331h-.335Z",
    transform: "translate(-837.021 -647.363)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M788.977,654.9v-.331h.335v.331Z",
    transform: "translate(-775.442 -651.842)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M939.705,657.6v-.321h.345v.321Z",
    transform: "translate(-898.466 -654.052)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M734.531,653.649v.334H734.2v-.334Z",
    transform: "translate(-730.732 -651.094)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M816.664,655.1v.334h-.333l-.017-.334Z",
    transform: "translate(-797.754 -652.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M987.839,651.205h.321v.345h-.321Z",
    transform: "translate(-937.753 -649.099)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M960.382,651.094v-.324h.336v.324Z",
    transform: "translate(-915.343 -648.744)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M878.187,649.649v-.339h.324v.339Z",
    transform: "translate(-848.255 -647.552)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M837.06,648.606h.341v.325h-.341Z",
    transform: "translate(-814.687 -646.977)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M892.232,649.88h-.344v-.335h.344Z",
    transform: "translate(-859.439 -647.744)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M843.788,655.947v-.32h.335v.32Z",
    transform: "translate(-820.179 -652.708)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M775.669,654.4v.329l-.345.017V654.4Z",
    transform: "translate(-764.298 -651.704)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M871.552,656.084v.318h-.327v-.318Z",
    transform: "translate(-842.573 -653.081)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M933.006,650.574v-.344h.319v.344Z",
    transform: "translate(-892.998 -648.303)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M926.379,657v.339h-.324V657Z",
    transform: "translate(-887.325 -653.825)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M905.6,649.852h.327v.316H905.6Z",
    transform: "translate(-870.631 -647.994)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M830.1,655.357h.345v.318H830.1Z",
    transform: "translate(-809.007 -652.488)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M898.971,656.843h-.319v-.327h.319Z",
    transform: "translate(-864.959 -653.433)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M720.481,653.478h.345v.317h-.345Z",
    transform: "translate(-719.536 -650.954)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M974.384,651.073v.312h-.347v-.312Z",
    transform: "translate(-926.488 -648.991)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M912.221,657.183v-.315h.351v.315Z",
    transform: "translate(-876.034 -653.721)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M823.282,648.393h.346v.318H823.3C823.293,648.614,823.288,648.518,823.282,648.393Z",
    transform: "translate(-803.442 -646.804)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M761.855,654.195v.308h-.334c-.005-.094-.01-.19-.016-.308Z",
    transform: "translate(-753.019 -651.539)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M940.022,643.934v-.287h.305v.287Z",
    transform: "translate(-898.725 -642.93)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M953.67,644.1a.808.808,0,0,1-.017-.111c0-.053.006-.107.01-.175a1.134,1.134,0,0,1,.13-.025,1.538,1.538,0,0,1,.157.006v.3Z",
    transform: "translate(-909.85 -643.042)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M761.947,640.821v-.286h.291v.286Z",
    transform: "translate(-753.38 -640.39)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M844.327,642.365h-.291c-.006-.095-.011-.18-.018-.287h.309Z",
    transform: "translate(-820.367 -641.649)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M755.005,647.591v-.308h.291c.005.1.01.177.016.282Z",
    transform: "translate(-747.714 -645.898)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M885.536,642.932h-.313c0-.095-.008-.175-.012-.283l.3-.025C885.519,642.727,885.526,642.815,885.536,642.932Z",
    transform: "translate(-853.987 -642.095)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M871.558,642.663v-.308l.292-.016.021.3Z",
    transform: "translate(-842.845 -641.862)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1008.854,645.065h-.309v-.291l.286-.018C1008.839,644.86,1008.845,644.947,1008.854,645.065Z",
    transform: "translate(-954.653 -643.835)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M782.243,647.77h.308c.005.093.01.181.017.295l-.306.014C782.255,647.973,782.25,647.886,782.243,647.77Z",
    transform: "translate(-769.946 -646.295)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M769.024,647.535c0,.1-.009.184-.013.28h-.292v-.28Z",
    transform: "translate(-758.908 -646.103)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M816.751,641.862v-.3h.294v.281Z",
    transform: "translate(-798.111 -641.229)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M830.722,641.963h-.305c-.005-.1-.01-.183-.016-.292l.306-.016C830.712,641.761,830.716,641.848,830.722,641.963Z",
    transform: "translate(-809.252 -641.303)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M899.147,642.842v.3c-.244.067-.362.013-.284-.277Z",
    transform: "translate(-865.112 -642.273)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M775.59,641.124c.005-.113.009-.194.013-.288h.293v.288Z",
    transform: "translate(-764.516 -640.636)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M748.468,640.638H748.2c-.006-.092-.013-.178-.021-.288h.289Z",
    transform: "translate(-742.143 -640.239)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M981.19,644.69V644.4h.289v.275Z",
    transform: "translate(-932.326 -643.545)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M967.48,644.462v-.281h.28v.281Z",
    transform: "translate(-921.136 -643.366)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M789.6,641.347h-.307v-.27h.292C789.592,641.16,789.6,641.24,789.6,641.347Z",
    transform: "translate(-775.701 -640.832)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M994.831,644.637a1.124,1.124,0,0,1,.123-.015c.054,0,.107.005.179.01v.278h-.3Z",
    transform: "translate(-943.46 -643.726)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M727.525,646.786h.275v.259C727.5,647.108,727.494,647.106,727.525,646.786Z",
    transform: "translate(-725.275 -645.492)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M721.1,640.043h-.3c-.006-.088-.011-.166-.019-.271l.307-.027C721.086,639.846,721.09,639.932,721.1,640.043Z",
    transform: "translate(-719.775 -639.745)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M734.485,640.346v-.268l.291-.021c.006.1.01.184.015.289Z",
    transform: "translate(-730.966 -640)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M803.063,641.466v-.305l.275-.012v.3Z",
    transform: "translate(-786.939 -640.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M926.619,643.726h-.282c0-.088-.008-.173-.011-.256C926.647,643.4,926.65,643.407,926.619,643.726Z",
    transform: "translate(-887.546 -642.758)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M857.811,642.269h.29c0,.09.008.168.013.269h-.289C857.821,642.455,857.817,642.377,857.811,642.269Z",
    transform: "translate(-831.624 -641.805)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M912.7,643.475v-.266h.275v.266Z",
    transform: "translate(-876.426 -642.572)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M741.534,647.424h-.29l-.014-.269h.29C741.524,647.238,741.528,647.316,741.534,647.424Z",
    transform: "translate(-736.471 -645.793)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(199.399)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1305.411,814.883h-.983v-1.224h.983Z",
    transform: "translate(-1250.27 -781.693)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1305.864,801.448h-.881v-1.113h.881Z",
    transform: "translate(-1250.723 -770.819)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1306.158,787.766h-.815v-1.058h.815Z",
    transform: "translate(-1251.017 -759.696)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1306.444,774.084h-.75v-1h.75Z",
    transform: "translate(-1251.302 -748.575)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1306.892,760.649h-.65v-.891h.65Z",
    transform: "translate(-1251.75 -737.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1307.229,747.022l-.574-.026v-.837l.574-.028Z",
    transform: "translate(-1252.088 -726.577)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1307.63,733.531h-.483v-.724h.483Z",
    transform: "translate(-1252.489 -715.702)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1307.927,719.9l-.417-.032v-.691h.417Z",
    transform: "translate(-1252.786 -704.581)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1308.177,706.222h-.36v-.634l.36-.034Z",
    transform: "translate(-1253.036 -693.458)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1308.636,692.786l-.257-.017v-.525l.257-.015Z",
    transform: "translate(-1253.495 -682.582)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1308.847,679.1c-.159.038-.22-.028-.208-.187s-.053-.335.208-.314Z",
    transform: "translate(-1253.706 -671.454)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1283.419,821.347c0-.351.016-.7.007-1.053,0-.171.056-.227.224-.222.339.01.679,0,1.043,0v1.271l.008-.009h-1.289Z",
    transform: "translate(-1233.117 -786.928)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1269.78,821.185v-1.249h1.244v1.24h-1.253Z",
    transform: "translate(-1221.983 -786.817)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1298.588,821.7l-1.2-.055v-1.229h1.2q0,.645,0,1.289Z",
    transform: "translate(-1244.524 -787.207)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1187.824,819.839v-1.176h1.191v1.176Z",
    transform: "translate(-1155.098 -785.778)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1139.945,812.155v-1.182h1.2v1.182Z",
    transform: "translate(-1116.019 -779.501)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1258.064,820.4h-1.214v-1.208h1.214Z",
    transform: "translate(-1211.437 -786.21)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1194.76,813.122v-1.176h1.2v1.176Z",
    transform: "translate(-1160.759 -780.295)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1250.793,814.067h-1.187v-1.189h1.187Z",
    transform: "translate(-1205.524 -781.056)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1064.581,816.447h1.174v1.2h-1.174Z",
    transform: "translate(-1054.507 -783.969)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1079.442,818h-1.208V816.8h1.2v1.217Z",
    transform: "translate(-1065.65 -784.254)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1242.619,820.781V819.61h1.2v1.171Z",
    transform: "translate(-1199.821 -786.551)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1134.229,817.7v1.177h-1.19V817.7Z",
    transform: "translate(-1110.382 -784.989)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1201.527,820.059v-1.17h1.181v1.17Z",
    transform: "translate(-1166.282 -785.962)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1120.6,817.5v1.164h-1.174V817.5Z",
    transform: "translate(-1099.273 -784.827)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1237.187,812.619V813.8h-1.17v-1.179Z",
    transform: "translate(-1194.433 -780.845)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1290.74,814.736V813.55h1.18v1.186Z",
    transform: "translate(-1239.098 -781.605)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1264.517,813.162v1.17h-1.179v-1.17Z",
    transform: "translate(-1216.731 -781.288)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1209.7,813.351h-1.174v-1.2h1.174Z",
    transform: "translate(-1171.998 -780.465)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1009.77,815.547h1.178v1.179h-1.178Z",
    transform: "translate(-1009.77 -783.234)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1147.912,817.944v1.185h-1.18v-1.185Z",
    transform: "translate(-1121.559 -785.191)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1098.885,810.17h1.172v1.2h-1.172Z",
    transform: "translate(-1082.506 -778.846)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1174.175,819.562V818.4h1.177v1.167Z",
    transform: "translate(-1143.957 -785.559)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1181.166,811.708h1.178v1.177h-1.178Z",
    transform: "translate(-1149.663 -780.101)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1127.559,810.738v1.169h-1.178v-1.169Z",
    transform: "translate(-1104.948 -779.309)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1153.719,811.252h1.174v1.158h-1.174Z",
    transform: "translate(-1127.261 -779.729)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1050.905,816.246h1.16v1.18h-1.16Z",
    transform: "translate(-1043.344 -783.805)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1091.926,816.984h1.171v1.166h-1.171Z",
    transform: "translate(-1076.826 -784.407)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1229.034,819.41h1.173v1.16h-1.173Z",
    transform: "translate(-1188.733 -786.387)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1215.333,819.11h1.157V820.3h-1.157Z",
    transform: "translate(-1177.55 -786.143)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1113.818,811.671h-1.16v-1.179h1.16Z",
    transform: "translate(-1093.747 -779.109)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1168.65,812.6h-1.162v-1.177h1.162Z",
    transform: "translate(-1138.5 -779.865)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1037.141,816.1h1.173v1.156h-1.173Z",
    transform: "translate(-1032.11 -783.688)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1105.706,817.145h1.16v1.187h-1.16Z",
    transform: "translate(-1088.073 -784.539)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1024.613,815.792v1.165h-1.191v-1.165Z",
    transform: "translate(-1020.913 -783.435)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1222.286,812.444h1.161v1.16h-1.161Z",
    transform: "translate(-1183.226 -780.702)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1078.6,803.136h1.135v1.134H1078.6Z",
    transform: "translate(-1065.946 -773.105)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1064.919,802.908h1.13v1.125h-1.13Z",
    transform: "translate(-1054.782 -772.919)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1278.255,814.563h-1.162V813.4h1.162Z",
    transform: "translate(-1227.959 -781.484)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1119.69,804.979V803.85h1.139v1.129Z",
    transform: "translate(-1099.487 -773.687)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1284.09,807.92V806.8h1.144v1.12Z",
    transform: "translate(-1233.67 -776.095)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1011.211,803.071h-1.13v-1.142h1.13Z",
    transform: "translate(-1010.024 -772.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1017.963,810.033h-1.13v-1.14h1.13Z",
    transform: "translate(-1015.535 -777.804)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1215.647,806.737v-1.126h1.131v1.126Z",
    transform: "translate(-1177.807 -775.125)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1270.481,807.609v-1.131h1.125v1.131Z",
    transform: "translate(-1222.562 -775.832)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1229.3,805.8h1.143v1.134H1229.3Z",
    transform: "translate(-1188.95 -775.277)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1160.494,819.389v-1.158h1.157v1.158Z",
    transform: "translate(-1132.791 -785.425)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1072.8,809.9v1.133h-1.131V809.9Z",
    transform: "translate(-1060.29 -778.624)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1106.063,804.822V803.7h1.119v1.122Z",
    transform: "translate(-1088.364 -773.565)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1162.019,805.722H1160.9V804.58h1.119Z",
    transform: "translate(-1133.122 -774.283)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1188.207,806.182v-1.135h1.131v1.135Z",
    transform: "translate(-1155.41 -774.664)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1133.413,804.1h1.125v1.122h-1.125Z",
    transform: "translate(-1110.687 -773.894)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1051.246,802.6h1.121v1.131h-1.121Z",
    transform: "translate(-1043.623 -772.667)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1044.306,809.435h1.122v1.133h-1.122Z",
    transform: "translate(-1037.958 -778.246)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1037.576,802.455h1.131v1.13h-1.131Z",
    transform: "translate(-1032.465 -772.549)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1298.979,808.139h-1.129V807h1.129Z",
    transform: "translate(-1244.901 -776.259)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1024.953,803.4h-1.124v-1.119h1.124Z",
    transform: "translate(-1021.245 -772.41)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1147.191,804.346h1.1v1.142h-1.1Z",
    transform: "translate(-1121.933 -774.092)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1202,805.315h1.1v1.122H1202Z",
    transform: "translate(-1166.672 -774.883)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1257.914,807.423h-1.1v-1.132h1.1Z",
    transform: "translate(-1211.403 -775.68)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1085.429,810.111h1.1v1.137h-1.1Z",
    transform: "translate(-1071.523 -778.798)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1059.061,810.877h-1.135v-1.106h1.135Z",
    transform: "translate(-1049.075 -778.52)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1175.637,806.013h-1.14v-1.106h1.14Z",
    transform: "translate(-1144.22 -774.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1093.483,804.58h-1.1v-1.123h1.1Z",
    transform: "translate(-1077.2 -773.367)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1243.013,807.212V806.1h1.133v1.108Z",
    transform: "translate(-1200.143 -775.527)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1030.635,809.185h1.1v1.124h-1.1Z",
    transform: "translate(-1026.8 -778.042)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1285.6,794.242h-1.071v-1.088h1.071Z",
    transform: "translate(-1234.028 -764.957)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1264.939,800.821h-1.071v-1.08h1.071Z",
    transform: "translate(-1217.165 -770.334)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1045.678,796.957H1044.6v-1.086h1.075Z",
    transform: "translate(-1038.201 -767.175)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1099.43,796.774h1.078v1.077h-1.078Z",
    transform: "translate(-1082.951 -767.912)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1217.068,791.974v1.075h-1.087v-1.075Z",
    transform: "translate(-1178.079 -763.994)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1271.9,794.023h-1.07v-1.089h1.07Z",
    transform: "translate(-1222.845 -764.778)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1155.3,797.795v1.072h-1.088v-1.072Z",
    transform: "translate(-1127.667 -768.745)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1210.119,799.763h-1.072v-1.081h1.072Z",
    transform: "translate(-1172.42 -769.469)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1032.079,795.594v1.08H1031v-1.08Z",
    transform: "translate(-1027.1 -766.949)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1291.31,801.212v-1.073h1.083v1.073Z",
    transform: "translate(-1239.563 -770.659)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1298.272,794.547v-1.075h1.074v1.075Z",
    transform: "translate(-1245.245 -765.217)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1169.012,799.074h-1.074V797.99h1.074Z",
    transform: "translate(-1138.867 -768.904)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1230.8,792.243v1.082h-1.078v-1.082Z",
    transform: "translate(-1189.291 -764.214)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1113.106,798.189v-1.073h1.083v1.073Z",
    transform: "translate(-1094.113 -768.191)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1236.462,800.309V799.24h1.089v1.069Z",
    transform: "translate(-1194.796 -769.925)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1162.265,791.072v1.072h-1.087v-1.072Z",
    transform: "translate(-1133.349 -763.258)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1058.276,797.208v-1.069h1.085v1.069Z",
    transform: "translate(-1049.361 -767.394)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1257.1,793.873V792.8h1.08v1.07Z",
    transform: "translate(-1211.641 -764.671)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1181.729,798.225h1.071V799.3h-1.071Z",
    transform: "translate(-1150.123 -769.096)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1072.078,796.262h1.081v1.075h-1.081Z",
    transform: "translate(-1060.626 -767.494)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1017.235,796.461V795.4h1.084v1.064Z",
    transform: "translate(-1015.863 -766.788)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1251.235,799.478v1.065h-1.083v-1.065Z",
    transform: "translate(-1205.97 -770.119)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1277.56,799.893h1.073v1.072h-1.073Z",
    transform: "translate(-1228.34 -770.458)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1174.888,791.259h1.081v1.077h-1.081Z",
    transform: "translate(-1144.539 -763.411)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1223.809,799.013v1.071h-1.082v-1.071Z",
    transform: "translate(-1183.586 -769.74)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1196.428,799.61h-1.069v-1.079h1.069Z",
    transform: "translate(-1161.248 -769.346)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1085.692,797.65v-1.076h1.076v1.076Z",
    transform: "translate(-1071.738 -767.749)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1140.553,797.473h1.071v1.076h-1.071Z",
    transform: "translate(-1116.515 -768.482)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1126.9,797.3h1.078v1.077H1126.9Z",
    transform: "translate(-1105.372 -768.342)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1203.378,791.747v1.069h-1.085v-1.069Z",
    transform: "translate(-1166.906 -763.809)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1243.473,792.473h1.082v1.076h-1.082Z",
    transform: "translate(-1200.518 -764.402)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1189.739,792.661h-1.083v-1.076h1.083Z",
    transform: "translate(-1155.777 -763.677)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1127.278,783.713h1.017v1.031h-1.017Z",
    transform: "translate(-1105.68 -757.252)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1010.719,788.488h1.013v1.033h-1.013Z",
    transform: "translate(-1010.545 -761.149)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1024.3,789.873v-1.019h1.028v1.019Z",
    transform: "translate(-1021.631 -761.448)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1195.707,784.959h1.024v1.023h-1.024Z",
    transform: "translate(-1161.532 -758.269)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1292.727,787.632h-1.021v-1.021h1.021Z",
    transform: "translate(-1239.886 -759.617)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1073.506,783.81h-1.014v-1.023h1.014Z",
    transform: "translate(-1060.964 -756.496)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1018.682,781.9v1.015h-1.033V781.9Z",
    transform: "translate(-1016.2 -755.775)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1121.337,790.424v1.022h-1.028v-1.022Z",
    transform: "translate(-1099.992 -762.729)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1134.951,790.762v1.019h-1.031v-1.019Z",
    transform: "translate(-1111.101 -763.005)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1032.3,783.075h-1.026v-1.024h1.026Z",
    transform: "translate(-1027.32 -755.895)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1237.926,786.7h-1.014v-1.033h1.014Z",
    transform: "translate(-1195.163 -758.846)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1065.5,789.514h1.018v1.023H1065.5Z",
    transform: "translate(-1055.256 -761.987)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1251.539,786.914h-1.017v-1.031h1.017Z",
    transform: "translate(-1206.272 -759.023)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1079.147,789.7h1.014v1.032h-1.014Z",
    transform: "translate(-1066.395 -762.137)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1140.914,783.983h1.019v1.028h-1.019Z",
    transform: "translate(-1116.81 -757.472)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1044.978,783.3v-1.016H1046V783.3Z",
    transform: "translate(-1038.507 -756.085)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1059.786,783.614h-1.021v-1.022h1.021Z",
    transform: "translate(-1049.76 -756.337)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1086.117,783.038h1.015v1.033h-1.015Z",
    transform: "translate(-1072.084 -756.701)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1113.593,783.429h1.015v1.032h-1.015Z",
    transform: "translate(-1094.51 -757.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1182.052,785.7v-1.018h1.031V785.7Z",
    transform: "translate(-1150.387 -758.042)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1039.046,790.058h-1.019V789.04h1.019Z",
    transform: "translate(-1032.833 -761.6)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1169.4,784.471v1.016h-1.026v-1.016Z",
    transform: "translate(-1139.22 -757.87)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1265.269,786.118v1.024h-1.02v-1.024Z",
    transform: "translate(-1217.476 -759.214)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1099.762,784.3v-1.008h1.026V784.3Z",
    transform: "translate(-1083.221 -756.906)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1147.668,790.963h1.013v1.023h-1.013Z",
    transform: "translate(-1122.322 -763.169)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1052.821,789.326v1.013h-1.03v-1.013Z",
    transform: "translate(-1044.068 -761.833)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1224.249,786.306h-1.035v-1.04c.3,0,.593-.007.884.007a.209.209,0,0,1,.145.141C1224.256,785.706,1224.249,786,1224.249,786.306Z",
    transform: "translate(-1183.982 -758.517)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1155.631,785.215h-1.018V784.2h1.018Z",
    transform: "translate(-1127.991 -757.647)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1278.023,786.415h1.016v1.016h-1.016Z",
    transform: "translate(-1228.718 -759.457)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1209.435,785.205h1.015v1.025h-1.015Z",
    transform: "translate(-1172.737 -758.469)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1093.838,791.1h-1.016v-1.02h1.016Z",
    transform: "translate(-1077.556 -762.446)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1107.638,791.228h-1.017V790.2h1.017Z",
    transform: "translate(-1088.82 -762.547)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1238.181,772.077v.987h-.983v-.987Z",
    transform: "translate(-1195.397 -747.754)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1175.368,778.811v-.989h.983v.989Z",
    transform: "translate(-1144.931 -752.443)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1243.932,780v-.986h.963V780Z",
    transform: "translate(-1200.893 -753.42)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1162.7,777.661v.965h-.985v-.965Z",
    transform: "translate(-1133.791 -752.312)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1291.951,774.09v-.961h.984v.961Z",
    transform: "translate(-1240.086 -748.613)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1052.131,776.677v-.964h.974v.964Z",
    transform: "translate(-1044.345 -750.722)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1278.322,772.763h.976v.985h-.976Z",
    transform: "translate(-1228.962 -748.314)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1066.79,775.907v.978h-.986v-.978Z",
    transform: "translate(-1055.505 -750.88)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1265.661,773.545h-.957v-.976h.957Z",
    transform: "translate(-1217.847 -748.156)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1134.283,778.1v-.97h.976v.97Z",
    transform: "translate(-1111.397 -751.876)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1093.273,777.405v-.978h.965v.978Z",
    transform: "translate(-1077.925 -751.305)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1024.672,776.231v-.975h.971v.975Z",
    transform: "translate(-1021.933 -750.349)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1217.537,779.6h-.977v-.974h.977Z",
    transform: "translate(-1178.552 -753.095)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1106.919,776.707h.976v.971h-.976Z",
    transform: "translate(-1089.063 -751.533)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1011.986,774.98v.967h-.98v-.967Z",
    transform: "translate(-1010.779 -750.124)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1120.56,777.874v-.963h.984v.963Z",
    transform: "translate(-1100.197 -751.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1285.037,779.742h.981v.985h-.981Z",
    transform: "translate(-1234.443 -754.011)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1202.877,779.324v-.975h.971v.975Z",
    transform: "translate(-1167.384 -752.874)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1231.214,778.883v.961h-.985v-.961Z",
    transform: "translate(-1189.709 -753.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1080.493,777.187h-.954v-.973h.954Z",
    transform: "translate(-1066.715 -751.131)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1272.311,780.513h-.981v-.968h.981Z",
    transform: "translate(-1223.255 -753.85)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1148.079,778.389v-.962h.972v.962Z",
    transform: "translate(-1122.658 -752.121)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1190.113,778.147v.95h-.97v-.95Z",
    transform: "translate(-1156.174 -752.709)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1038.479,775.5h.966v.964h-.966Z",
    transform: "translate(-1033.202 -750.548)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1298.766,780.057h.96v.969h-.96Z",
    transform: "translate(-1245.649 -754.268)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1258.721,780.2h-.978v-.981c.284,0,.567-.006.849.006a.188.188,0,0,1,.122.135C1258.727,779.635,1258.721,779.909,1258.721,780.2Z",
    transform: "translate(-1212.166 -753.583)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1250.9,772.331h.968v.965h-.968Z",
    transform: "translate(-1206.577 -747.962)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1176.74,764.308v.925h-.946v-.925Z",
    transform: "translate(-1145.279 -741.413)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1169.786,771.041v.917h-.938v-.917Z",
    transform: "translate(-1139.609 -746.909)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1209.973,771.717h.917v.937h-.917Z",
    transform: "translate(-1173.176 -747.461)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1223.643,772.869v-.926h.938v.926Z",
    transform: "translate(-1184.333 -747.645)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1286.367,766.226v.924h-.939v-.924Z",
    transform: "translate(-1234.762 -742.979)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1230.59,766.155v-.917h.937v.917Z",
    transform: "translate(-1190.003 -742.172)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1113.994,771.022V770.1h.946v.922Z",
    transform: "translate(-1094.838 -746.141)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1257.979,766.65v-.931h.937v.931Z",
    transform: "translate(-1212.359 -742.565)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1196.232,772.383v-.939h.925v.939Z",
    transform: "translate(-1161.96 -747.238)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1141.42,771.467v-.931h.926v.931Z",
    transform: "translate(-1117.223 -746.497)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1073,769.283h.9v.936h-.9Z",
    transform: "translate(-1061.378 -745.474)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1121.948,763.451v.9H1121v-.9Z",
    transform: "translate(-1100.559 -740.714)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1135.672,764.506h-.908v-.94h.908Z",
    transform: "translate(-1111.79 -740.808)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1060.177,769.152v.905h-.942v-.905Z",
    transform: "translate(-1050.143 -745.367)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1190.478,765.408h-.911v-.94h.911Z",
    transform: "translate(-1156.52 -741.544)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1107.25,764.05v-.918h.928v.918Z",
    transform: "translate(-1089.333 -740.454)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1300.119,766.452v.926h-.911v-.926Z",
    transform: "translate(-1246.009 -743.163)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1182.609,772.2v-.922h.908v.922Z",
    transform: "translate(-1150.841 -747.105)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1156.084,771.707h-.924v-.923h.924Z",
    transform: "translate(-1128.437 -746.699)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1032.767,768.656v.916h-.926v-.916Z",
    transform: "translate(-1027.784 -744.962)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1093.58,763.793v-.93h.92v.93Z",
    transform: "translate(-1078.176 -740.234)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1162.073,765v-.9H1163v.9Z",
    transform: "translate(-1134.08 -741.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1087.547,769.531v.929h-.93v-.929Z",
    transform: "translate(-1072.492 -745.676)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1149.318,764.7h-.93v-.93h.93Z",
    transform: "translate(-1122.91 -740.978)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1045.549,768.853h.92v.93h-.92Z",
    transform: "translate(-1038.973 -745.123)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1244.363,766.457v-.917h.91v.917Z",
    transform: "translate(-1201.245 -742.419)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1217.829,765.933h-.925V765h.925Z",
    transform: "translate(-1178.833 -741.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1271.739,765.965h.92v.91h-.92Z",
    transform: "translate(-1223.589 -742.766)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1203.193,765.685v-.9h.927v.9Z",
    transform: "translate(-1167.642 -741.799)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1080.873,762.572v.921h-.917v-.921Z",
    transform: "translate(-1067.056 -739.996)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1100.294,770.786v-.915h.925v.915Z",
    transform: "translate(-1083.656 -745.954)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1019.118,768.406v.912h-.909v-.912Z",
    transform: "translate(-1016.658 -744.758)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1127.81,770.352h.91v.909h-.91Z",
    transform: "translate(-1106.114 -746.346)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1100.706,756.168h.878v.9h-.878Z",
    transform: "translate(-1083.992 -734.769)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1279.684,760.213h-.893v-.888h.893Z",
    transform: "translate(-1229.345 -737.346)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1223.912,759.33v-.874h.908v.874Z",
    transform: "translate(-1184.553 -736.637)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1155.485,758.119v-.873h.888v.873Z",
    transform: "translate(-1128.703 -735.649)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1211.215,759.032h-.877v-.877h.877Z",
    transform: "translate(-1173.474 -736.391)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1039.837,762.085v.875h-.883v-.875Z",
    transform: "translate(-1033.59 -739.599)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1046.771,756.167h-.883v-.873h.883Z",
    transform: "translate(-1039.25 -734.056)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1086.98,755.963h.869v.89h-.869Z",
    transform: "translate(-1072.789 -734.602)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1293.4,760.527h-.866v-.881h.866Z",
    transform: "translate(-1240.564 -737.608)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1026.107,762.627h-.867v-.89h.867Z",
    transform: "translate(-1022.397 -739.314)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1018.5,754.783h.873v.883h-.873Z",
    transform: "translate(-1016.894 -733.639)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1032.164,755.973v-.883h.872v.883Z",
    transform: "translate(-1028.048 -733.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1266.035,760.08h-.879v-.872h.879Z",
    transform: "translate(-1218.216 -737.251)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1238.6,758.635v.871h-.874v-.871Z",
    transform: "translate(-1195.827 -736.783)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1011.511,762.5v-.864h.875v.864Z",
    transform: "translate(-1011.191 -739.232)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1142.7,757.076v.862h-.871v-.862Z",
    transform: "translate(-1117.555 -735.51)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1182.917,757.708h.871v.875h-.871Z",
    transform: "translate(-1151.092 -736.026)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1053.573,762.313v.865h-.875v-.865Z",
    transform: "translate(-1044.808 -739.785)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1299.471,753.758v-.867h.875v.867Z",
    transform: "translate(-1246.224 -732.094)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1128.991,757.638h-.865v-.874h.865Z",
    transform: "translate(-1106.372 -735.256)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1197.5,758.856h-.859v-.87h.859Z",
    transform: "translate(-1162.295 -736.253)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1067.226,763.4h-.859v-.869h.859Z",
    transform: "translate(-1055.964 -739.966)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1251.419,758.835h.866v.89h-.866Z",
    transform: "translate(-1207.004 -736.946)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1170.156,757.413v.874h-.874v-.874Z",
    transform: "translate(-1139.964 -735.786)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1073.332,755.818h.86v.869h-.86Z",
    transform: "translate(-1061.649 -734.484)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1060.537,755.528v.873h-.874v-.873Z",
    transform: "translate(-1050.493 -734.247)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1115.366,757.41h-.863v-.874h.863Z",
    transform: "translate(-1095.253 -735.07)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1040.1,748.445v.834h-.846v-.834Z",
    transform: "translate(-1033.832 -728.466)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1156.683,743.6v.834h-.846V743.6Z",
    transform: "translate(-1128.99 -724.514)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1258.467,752.27h.845v.845h-.845Z",
    transform: "translate(-1212.756 -731.588)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1252.636,745.3v.84h-.835v-.84Z",
    transform: "translate(-1207.315 -725.901)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1190.872,751.077v.833h-.83v-.833Z",
    transform: "translate(-1156.908 -730.614)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1245.679,752.074v.816h-.831v-.816Z",
    transform: "translate(-1201.641 -731.428)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1135.22,750.958v-.814h.827v.814Z",
    transform: "translate(-1112.162 -729.852)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1177.156,750.834v.827h-.812v-.827Z",
    transform: "translate(-1145.728 -730.416)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1197.839,744.427v.811h-.826v-.811Z",
    transform: "translate(-1162.598 -725.187)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1266.279,746.413h-.835v-.826h.835Z",
    transform: "translate(-1218.451 -726.133)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1203.633,752.193v-.81h.846v.81Z",
    transform: "translate(-1168.001 -730.864)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1121.5,750.729v-.837h.819v.837Z",
    transform: "translate(-1100.96 -729.647)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1025.62,748.265h.827v.817h-.827Z",
    transform: "translate(-1022.707 -728.319)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1148.836,751.215v-.823h.846v.823Z",
    transform: "translate(-1123.276 -730.055)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1169.551,744.735v-.818h.836v.818Z",
    transform: "translate(-1140.183 -724.77)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1231.962,751.759v.84h-.819v-.84Z",
    transform: "translate(-1190.455 -731.171)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1224.4,745.623v-.841h.825v.841Z",
    transform: "translate(-1184.947 -725.476)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1238.931,745.917h-.813v-.835h.813Z",
    transform: "translate(-1196.148 -725.721)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1292.9,746h.815v.844h-.815Z",
    transform: "translate(-1240.864 -726.467)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1142.151,744.273v-.816h.835v.816Z",
    transform: "translate(-1117.819 -724.395)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1081.237,750.029h-.831V749.2h.831Z",
    transform: "translate(-1067.423 -729.085)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1107.794,750.506v-.836h.831v.836Z",
    transform: "translate(-1089.777 -729.466)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1094.88,750.292h-.847v-.818h.847Z",
    transform: "translate(-1078.546 -729.305)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1053.838,748.729v.82H1053v-.82Z",
    transform: "translate(-1045.057 -728.698)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1210.606,745.474v-.8h.842v.8Z",
    transform: "translate(-1173.692 -725.386)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1184.1,744.943h-.815V744.1h.815Z",
    transform: "translate(-1151.397 -724.92)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1162.658,750.672h.822v.818h-.822Z",
    transform: "translate(-1134.557 -730.284)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1286.785,752.842v.8h-.814v-.8Z",
    transform: "translate(-1235.205 -732.055)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1280.04,745.842v.812h-.836v-.812Z",
    transform: "translate(-1229.682 -726.341)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1067.52,749.772h-.813v-.82h.813Z",
    transform: "translate(-1056.242 -728.88)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1218.27,751.6v.81h-.832v-.81Z",
    transform: "translate(-1179.269 -731.043)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1272.245,752.493h.829v.826h-.829Z",
    transform: "translate(-1224.002 -731.77)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1012.706,747.984v.826h-.818v-.826Z",
    transform: "translate(-1011.498 -728.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1136.319,737.321h-.786v-.79h.786Z",
    transform: "translate(-1112.418 -718.742)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1054.169,735.891h-.785V735.1h.785Z",
    transform: "translate(-1045.368 -717.574)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1128.541,744.083v-.775h.785v.775Z",
    transform: "translate(-1106.711 -724.273)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1018.918,742.172v-.783h.79v.783Z",
    transform: "translate(-1017.237 -722.707)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1081.528,735.642v.78h-.79v-.78Z",
    transform: "translate(-1067.694 -718.016)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1273.4,738.946v.788h-.79v-.788Z",
    transform: "translate(-1224.301 -720.713)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1191.134,738.333h-.781v-.79h.781Z",
    transform: "translate(-1157.162 -719.568)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1245.114,739.231v-.78h.79v.78Z",
    transform: "translate(-1201.858 -720.309)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1074.542,743.167h-.779V742.4h.779Z",
    transform: "translate(-1062.001 -723.53)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1121.888,737.132v-.774h.771v.774Z",
    transform: "translate(-1101.281 -718.601)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1176.688,738.006v-.778h.77v.778Z",
    transform: "translate(-1146.009 -719.311)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1060.14,742.061h.771v.789h-.771Z",
    transform: "translate(-1050.882 -723.255)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1012.275,735.184V734.4h.771v.786Z",
    transform: "translate(-1011.815 -717.001)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1067.135,735.374h.76v.77h-.76Z",
    transform: "translate(-1056.591 -717.797)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1087.53,743.366v-.781h.767v.781Z",
    transform: "translate(-1073.238 -723.683)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1258.916,739.511v-.786h.77v.786Z",
    transform: "translate(-1213.123 -720.532)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1047.209,741.944v.765h-.79v-.765Z",
    transform: "translate(-1039.683 -723.16)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1287.089,739.2v.769h-.78V739.2Z",
    transform: "translate(-1235.481 -720.916)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1025.892,735.413v-.766h.791v.766Z",
    transform: "translate(-1022.929 -717.203)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1231.508,738.272h.776v.769h-.776Z",
    transform: "translate(-1190.753 -720.163)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1300.742,740.3h-.781v-.771h.781Z",
    transform: "translate(-1246.624 -721.185)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1108.156,736.931v-.75h.79v.75Z",
    transform: "translate(-1090.073 -718.455)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1217.8,738.027h.789v.763h-.789Z",
    transform: "translate(-1179.567 -719.963)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1114.915,743.883v-.751h.77v.751Z",
    transform: "translate(-1095.589 -724.13)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1204.115,737.7h.767v.789h-.767Z",
    transform: "translate(-1168.394 -719.693)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1163.774,737.854h-.785v-.77h.785Z",
    transform: "translate(-1134.828 -719.193)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1149.3,737.606v-.787h.771v.787Z",
    transform: "translate(-1123.653 -718.977)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1101.208,743.6v-.772H1102v.772Z",
    transform: "translate(-1084.402 -723.884)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1032.682,742.386v-.761h.781v.761Z",
    transform: "translate(-1028.471 -722.899)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1040.492,734.957v.768h-.768v-.768Z",
    transform: "translate(-1034.219 -717.457)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1094.479,736.634v-.768h.768v.768Z",
    transform: "translate(-1078.91 -718.199)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1287.39,725.649v.725h-.734v-.725Z",
    transform: "translate(-1235.764 -709.86)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1088.627,729.772h-.735v-.734h.735Z",
    transform: "translate(-1073.533 -712.626)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1232.469,724.736v.746c-.208,0-.409.011-.607-.007a.21.21,0,0,1-.142-.144c-.018-.19-.007-.384-.007-.595Z",
    transform: "translate(-1190.917 -709.115)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1225.6,732.133h-.725V731.4h.725Z",
    transform: "translate(-1185.339 -714.553)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1033.07,728.784v-.729h.735v.729Z",
    transform: "translate(-1028.787 -711.824)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1142.718,729.928h.728v.733h-.728Z",
    transform: "translate(-1118.282 -713.352)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1260.022,725.1v.734h-.735V725.1Z",
    transform: "translate(-1213.426 -709.41)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1205.213,724.927h-.734v-.734h.734Z",
    transform: "translate(-1168.692 -708.671)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1170.786,731.212h-.73v-.734h.73Z",
    transform: "translate(-1140.596 -713.801)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1279.649,733.111v-.729h.734v.729Z",
    transform: "translate(-1230.045 -715.355)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1102.319,729.993h-.715v-.734h.715Z",
    transform: "translate(-1084.725 -712.806)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1211.952,731.176v.731h-.716v-.731Z",
    transform: "translate(-1174.207 -714.371)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1273.734,725.43v.729h-.715v-.729Z",
    transform: "translate(-1224.633 -709.681)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1218.913,724.411v.728h-.723v-.728Z",
    transform: "translate(-1179.882 -708.849)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1156.413,730.968v-.709h.714v.709Z",
    transform: "translate(-1129.46 -713.623)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1266.049,732.221h.715v.706h-.715Z",
    transform: "translate(-1218.945 -715.224)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1294.153,733.321h-.714v-.734h.714Z",
    transform: "translate(-1241.301 -715.523)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1115.965,730.242h-.726v-.715h.726Z",
    transform: "translate(-1095.854 -713.025)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1197.5,731.714v-.7h.736v.7Z",
    transform: "translate(-1162.994 -714.236)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1046.777,729.074v-.7h.732v.7Z",
    transform: "translate(-1039.975 -712.088)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1239.384,731.715v.725h-.715v-.725Z",
    transform: "translate(-1196.597 -714.811)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1020.144,728.558h-.706v-.741h.706Z",
    transform: "translate(-1017.661 -711.629)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1061.153,728.6v.709h-.743V728.6Z",
    transform: "translate(-1051.102 -712.264)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1074.924,728.75v.726h-.726v-.726Z",
    transform: "translate(-1062.356 -712.391)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1252.285,732.66v-.709h.744v.709Z",
    transform: "translate(-1207.711 -715.004)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1301.119,726.635h-.713v-.707h.713Z",
    transform: "translate(-1246.987 -710.088)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1129,730.511v-.719h.715v.719Z",
    transform: "translate(-1107.087 -713.241)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1184.536,730.724v.71h-.72v-.71Z",
    transform: "translate(-1151.826 -714.002)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1239.716,718.067v.681h-.677v-.681Z",
    transform: "translate(-1196.899 -703.672)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1245.587,725.668v-.718h.715v.718Z",
    transform: "translate(-1202.244 -709.289)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1136.821,723.168v.682h-.678v-.682Z",
    transform: "translate(-1112.916 -707.835)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1177.244,723.867h.671v.678h-.671Z",
    transform: "translate(-1146.462 -708.405)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1156.694,717.307v-.666h.687v.666Z",
    transform: "translate(-1129.689 -702.507)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1123.12,722.92v.669h-.678v-.669Z",
    transform: "translate(-1101.733 -707.633)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1184.176,717.149h.683v.669h-.683Z",
    transform: "translate(-1152.12 -702.922)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1047.074,715.424v-.671h.7v.671Z",
    transform: "translate(-1040.218 -700.967)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1027.185,721.89h-.669V721.2h.669Z",
    transform: "translate(-1023.438 -706.23)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1294.49,719.727h-.675v-.68h.675Z",
    transform: "translate(-1241.607 -704.471)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1067.583,722.673V722h.68v.67Z",
    transform: "translate(-1056.957 -706.884)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1088.28,716.134v-.668h.679v.668Z",
    transform: "translate(-1073.85 -701.549)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1040.172,721.453h.664v.674h-.664Z",
    transform: "translate(-1034.584 -706.435)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1190.926,724.787v-.677h.68v.677Z",
    transform: "translate(-1157.629 -708.604)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1101.9,716.432v-.664h.687v.664Z",
    transform: "translate(-1084.97 -701.795)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1253.423,719.074h-.661V718.4h.661Z",
    transform: "translate(-1208.1 -703.946)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1094.916,723.1v-.679h.686v.679Z",
    transform: "translate(-1079.266 -707.225)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1130.069,716.2v.682h-.678V716.2Z",
    transform: "translate(-1107.404 -702.147)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1225.977,717.852v.67h-.67v-.67Z",
    transform: "translate(-1185.691 -703.496)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1212.235,718.352h-.672v-.667h.672Z",
    transform: "translate(-1174.473 -703.36)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1198.594,717.423v.652h-.678v-.652Z",
    transform: "translate(-1163.335 -703.146)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1171.177,716.881v.678h-.669v-.678Z",
    transform: "translate(-1140.964 -702.703)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1164.2,724.278h-.652V723.6h.652Z",
    transform: "translate(-1135.279 -708.188)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1149.726,724.119v-.658h.679v.658Z",
    transform: "translate(-1124.002 -708.074)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1143.057,717.165v-.653h.678v.653Z",
    transform: "translate(-1118.559 -702.402)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1054.581,721.685v.673h-.669v-.673Z",
    transform: "translate(-1045.799 -706.625)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1115.692,715.9h.656v.678h-.656Z",
    transform: "translate(-1096.224 -701.9)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1060.918,715.009h.654v.679h-.654Z",
    transform: "translate(-1051.517 -701.176)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1109.4,722.691v.668h-.663v-.668Z",
    transform: "translate(-1090.546 -707.446)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1082.032,722.227v.656h-.679v-.656Z",
    transform: "translate(-1068.196 -707.067)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1074.613,715.228h.667v.659h-.667Z",
    transform: "translate(-1062.695 -701.354)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1280.125,718.729h.659v.687h-.659Z",
    transform: "translate(-1230.434 -704.212)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1266.332,719.269v-.66h.677v.66Z",
    transform: "translate(-1219.176 -704.114)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1012.785,720.981h.677v.66h-.677Z",
    transform: "translate(-1012.231 -706.05)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1178.177,710.285v.626h-.643v-.626Z",
    transform: "translate(-1146.699 -697.32)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1122.747,709.342h.633v.625h-.633Z",
    transform: "translate(-1101.982 -696.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1294.769,706.052h-.626v-.635h.626Z",
    transform: "translate(-1241.875 -693.346)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1136.423,710.213v-.636h.632v.636Z",
    transform: "translate(-1113.144 -696.742)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1287.779,712.871h-.642v-.633h.642Z",
    transform: "translate(-1236.157 -698.914)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1068.622,709h-.612v-.644h.612Z",
    transform: "translate(-1057.305 -695.744)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1191.233,710.483h.638v.633h-.638Z",
    transform: "translate(-1157.88 -697.481)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1040.626,707.809h.62v.637h-.62Z",
    transform: "translate(-1034.955 -695.299)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1020.511,714.451v.615h-.631v-.615Z",
    transform: "translate(-1018.022 -700.72)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1013.168,708.085v-.618h.623v.618Z",
    transform: "translate(-1012.544 -695.02)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1300.825,713.047v-.619h.638v.619Z",
    transform: "translate(-1247.329 -699.069)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1054.909,708.142v.621h-.624v-.621Z",
    transform: "translate(-1046.103 -695.571)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1109.082,709.025h.62v.631h-.62Z",
    transform: "translate(-1090.828 -696.291)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1274.148,712v.62h-.624V712Z",
    transform: "translate(-1225.046 -698.719)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1026.819,707.672h.632v.631h-.632Z",
    transform: "translate(-1023.685 -695.187)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1246.685,712.113h-.625v-.621h.625Z",
    transform: "translate(-1202.63 -698.305)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1280.442,705.927V705.3h.633v.626Z",
    transform: "translate(-1230.693 -693.252)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1218.732,711.017h.62v.631h-.62Z",
    transform: "translate(-1180.325 -697.917)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1081.627,708.633h.627v.622h-.627Z",
    transform: "translate(-1068.42 -695.971)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1253.765,704.835v.6h-.595v-.6Z",
    transform: "translate(-1208.433 -692.871)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1150.822,710.473h-.6v-.631h.6Z",
    transform: "translate(-1124.404 -696.958)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1232.294,711.959v-.6h.641v.6Z",
    transform: "translate(-1191.394 -698.198)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1164.521,710.744h-.615v-.6h.615Z",
    transform: "translate(-1135.576 -697.205)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1259.832,711.679h.605v.633h-.605Z",
    transform: "translate(-1213.871 -698.458)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1033.619,715.281v-.631h.6v.631Z",
    transform: "translate(-1029.235 -700.882)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1205.661,711.445h-.6v-.621h.6Z",
    transform: "translate(-1169.17 -697.76)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1096.036,709.5h-.613V708.9h.613Z",
    transform: "translate(-1079.68 -696.187)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1246.511,697.817h.571v.6h-.571Z",
    transform: "translate(-1202.998 -687.143)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1061.3,702.109v-.6h.585v.6Z",
    transform: "translate(-1051.825 -690.161)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1273.805,698.969v-.579h.584v.579Z",
    transform: "translate(-1225.276 -687.611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1143.546,703.49V702.9h.587v.588Z",
    transform: "translate(-1118.958 -691.294)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1157.288,703.168h.567v.586h-.567Z",
    transform: "translate(-1130.174 -691.511)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1164.17,697.1v-.574h.585v.574Z",
    transform: "translate(-1135.791 -686.088)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1198.981,704.492h-.585v-.582h.585Z",
    transform: "translate(-1163.726 -692.117)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1136.854,696.564v-.589h.585v.589Z",
    transform: "translate(-1113.496 -685.64)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1150.5,696.83v-.576h.6v.576Z",
    transform: "translate(-1124.631 -685.868)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1260.744,698.148v.577h-.593v-.577Z",
    transform: "translate(-1214.131 -687.414)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1226.355,704.467v.567h-.587v-.567Z",
    transform: "translate(-1186.068 -692.571)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1020.254,701.393v-.568h.587v.568Z",
    transform: "translate(-1018.327 -689.599)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1103.014,702.245v.591h-.582v-.591Z",
    transform: "translate(-1085.401 -690.758)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1287.516,699.2v-.584h.576v.584Z",
    transform: "translate(-1236.466 -687.798)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1212.639,704.139v.589h-.586v-.589Z",
    transform: "translate(-1174.873 -692.303)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1048.212,701.935h-.578v-.577h.578Z",
    transform: "translate(-1040.675 -690.034)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1205.913,697.761h-.587v-.6h.587Z",
    transform: "translate(-1169.383 -686.611)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1109.352,696.183v-.567h.6v.567Z",
    transform: "translate(-1091.049 -685.347)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1089.348,701.995v.58h-.593v-.58Z",
    transform: "translate(-1074.238 -690.553)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1267.46,705.147v.567h-.588v-.567Z",
    transform: "translate(-1219.617 -693.126)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1219.612,697.465v.576h-.581v-.576Z",
    transform: "translate(-1180.569 -686.856)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1034.511,701.694h-.592v-.579h.592Z",
    transform: "translate(-1029.48 -689.835)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1233.321,698.27h-.57v-.58h.57Z",
    transform: "translate(-1191.766 -687.04)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1240.116,705.258h-.58v-.576h.58Z",
    transform: "translate(-1197.305 -692.747)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1301.223,699.413c0-.142,0-.26,0-.378,0-.062.007-.125.012-.2.068-.005.121-.013.174-.014.128,0,.255,0,.4,0v.594Z",
    transform: "translate(-1247.654 -687.961)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1075.1,702.289v-.575c.668-.088.637-.084.565.554a.931.931,0,0,1-.128.019C1075.4,702.291,1075.266,702.289,1075.1,702.289Z",
    transform: "translate(-1063.094 -690.292)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1116.716,702.559v.573h-.583v-.573Z",
    transform: "translate(-1096.584 -691.014)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1178.5,697.4h-.575v-.574h.575Z",
    transform: "translate(-1147.021 -686.335)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1170.987,703.455h.567v.577h-.567Z",
    transform: "translate(-1141.355 -691.745)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1191.714,696.936h.571v.58h-.571Z",
    transform: "translate(-1158.273 -686.424)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1130.5,702.79v.555h-.585v-.555Z",
    transform: "translate(-1107.836 -691.202)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1123.095,696.314v-.577h.575v.577Z",
    transform: "translate(-1102.266 -685.446)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1184.738,703.731h.556c.093.675.076.638-.556.567Z",
    transform: "translate(-1152.579 -691.97)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1014.182,694.5h-.528v-.548h.528Z",
    transform: "translate(-1012.94 -683.987)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1048.54,688.244h-.534v-.539h.534Z",
    transform: "translate(-1040.978 -678.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1082.673,695.689h-.533v-.548h.533Z",
    transform: "translate(-1068.839 -684.959)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1103.358,689.218h-.549v-.539h.549Z",
    transform: "translate(-1085.708 -679.684)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1144.479,689.921h-.532v-.556h.532Z",
    transform: "translate(-1119.285 -680.245)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1075.408,688.13h.536v.556h-.536Z",
    transform: "translate(-1063.344 -679.237)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1267.169,691.916c-.054-.6-.025-.63.522-.528v.528Z",
    transform: "translate(-1219.844 -681.859)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1212.982,690.633v.542h-.519v-.542Z",
    transform: "translate(-1175.208 -681.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1239.823,691.63v-.517h.541v.517Z",
    transform: "translate(-1197.539 -681.672)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1089.089,688.986v-.516h.539v.516Z",
    transform: "translate(-1074.51 -679.514)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1295.193,692.556h-.537v-.54h.537Z",
    transform: "translate(-1242.294 -682.408)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1199.27,690.986h-.527v-.521h.527Z",
    transform: "translate(-1164.009 -681.143)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1027.884,694.25v.515h-.54v-.515Z",
    transform: "translate(-1024.114 -684.232)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1041.576,694.445v.529h-.526v-.529Z",
    transform: "translate(-1035.301 -684.391)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1253.515,691.88v-.535h.541v.535Z",
    transform: "translate(-1208.715 -681.861)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1069,694.973v.537h-.541v-.537Z",
    transform: "translate(-1057.669 -684.822)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1157.626,689.591h.519v.533h-.519Z",
    transform: "translate(-1130.45 -680.429)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1130.794,689.264v.511h-.54v-.511Z",
    transform: "translate(-1108.109 -680.162)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1171.44,689.853h.51v.529h-.51Z",
    transform: "translate(-1141.725 -680.643)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1054.815,694.732h.526v.522h-.526Z",
    transform: "translate(-1046.536 -684.625)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1226.214,690.759h.518v.539h-.518Z",
    transform: "translate(-1186.432 -681.383)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1116.638,688.9h.513v.537h-.513Z",
    transform: "translate(-1096.996 -679.867)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1021.172,687.784h-.529v-.526h.529Z",
    transform: "translate(-1018.645 -678.525)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1185.013,690.666v-.535h.541v.535Z",
    transform: "translate(-1152.803 -680.87)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1034.834,688h-.541v-.54h.541Z",
    transform: "translate(-1029.786 -678.693)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1280.992,692.324v-.51h.53v.51Z",
    transform: "translate(-1231.141 -682.244)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1062.306,688.022v.516h-.525v-.516Z",
    transform: "translate(-1052.221 -679.149)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1096.4,695.447v.511h-.53v-.511Z",
    transform: "translate(-1080.046 -685.209)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1212.711,677.487V677h.517v.483Z",
    transform: "translate(-1175.41 -670.156)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1027.762,680.589h.49v.491h-.49Z",
    transform: "translate(-1024.455 -673.082)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1302.281,685.929h-.485v-.494h.485Z",
    transform: "translate(-1248.122 -677.037)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1096.67,682.3h-.485v-.5h.485Z",
    transform: "translate(-1080.302 -674.074)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1199.089,677.311v-.475h.5v.475Z",
    transform: "translate(-1164.292 -670.019)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1205.776,683.773h.49v.474h-.49Z",
    transform: "translate(-1169.75 -675.681)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1151.484,683.38h-.49V682.9h.49Z",
    transform: "translate(-1125.037 -674.966)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1109.941,682.08h.476v.5h-.476Z",
    transform: "translate(-1091.53 -674.299)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1281.293,678.69V678.2h.493v.487Z",
    transform: "translate(-1231.387 -671.134)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1246.966,684.445h.5v.473h-.5Z",
    transform: "translate(-1203.369 -676.229)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1082.53,681.656h.49v.475h-.49Z",
    transform: "translate(-1069.156 -673.953)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1233.285,684.225h.473v.488h-.473Z",
    transform: "translate(-1192.203 -676.05)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1288.559,685.121v.494h-.48v-.494Z",
    transform: "translate(-1236.926 -676.781)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1295.012,678.957v-.491h.484v.491Z",
    transform: "translate(-1242.584 -671.349)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1268.06,678.514h-.493v-.479h.493Z",
    transform: "translate(-1220.183 -670.997)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1254.412,678.265h-.492v-.484h.492Z",
    transform: "translate(-1209.045 -670.79)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1164.793,682.987h.471v.493h-.471Z",
    transform: "translate(-1136.3 -675.039)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1260.569,685.224v-.474h.494v.474Z",
    transform: "translate(-1214.472 -676.478)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1041.507,680.867h.475v.5h-.475Z",
    transform: "translate(-1035.674 -673.309)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1192.128,684.02v-.471h.492v.471Z",
    transform: "translate(-1158.611 -675.498)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1227.041,677.26v.49h-.484v-.49Z",
    transform: "translate(-1186.712 -670.365)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1137.322,683.041v-.473h.493v.473Z",
    transform: "translate(-1113.878 -674.696)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1240.715,677.989h-.471v-.481h.471Z",
    transform: "translate(-1197.882 -670.567)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1013.985,680.936v-.472h.481v.472Z",
    transform: "translate(-1013.21 -672.98)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1123.675,682.314h.475v.484h-.475Z",
    transform: "translate(-1102.739 -674.49)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1069.315,681.846h-.476v-.485h.476Z",
    transform: "translate(-1057.982 -673.712)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1178.422,683.736v-.469h.479v.469Z",
    transform: "translate(-1147.424 -675.268)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1219.6,684.065h.478v.476h-.478Z",
    transform: "translate(-1181.03 -675.919)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1185.877,676.608v.468h-.488v-.468Z",
    transform: "translate(-1153.11 -669.833)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1055.6,681.1v.485h-.485V681.1Z",
    transform: "translate(-1046.785 -673.501)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1274.879,685.015v.469h-.479v-.469Z",
    transform: "translate(-1225.761 -676.694)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1117.511,675.435v.432h-.442v-.432Z",
    transform: "translate(-1097.347 -668.875)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1062.7,674.984h-.427v-.445h.427Z",
    transform: "translate(-1052.624 -668.144)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1124.018,668.77h.439v.435h-.439Z",
    transform: "translate(-1103.019 -663.435)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1179.259,670.143h-.443v-.436h.443Z",
    transform: "translate(-1147.745 -664.2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1110.726,668.93h-.42v-.436h.42Z",
    transform: "translate(-1091.828 -663.21)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1192.641,669.988h.42v.436h-.42Z",
    transform: "translate(-1159.029 -664.429)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1233.614,671.2v-.418h.443v.418Z",
    transform: "translate(-1192.471 -665.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1247.451,670.9h.42v.435h-.42Z",
    transform: "translate(-1203.765 -665.172)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1055.489,667.533h.423v.446h-.423Z",
    transform: "translate(-1047.086 -662.425)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1288.44,671.654h.437v.421h-.437Z",
    transform: "translate(-1237.221 -665.789)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1302.26,671.789h.42v.438h-.42Z",
    transform: "translate(-1248.5 -665.899)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1014.374,667.336v-.417h.443v.417Z",
    transform: "translate(-1013.528 -661.924)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1069.189,668.244v-.418h.442v.418Z",
    transform: "translate(-1058.268 -662.665)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1171.866,676.51h.442v.417h-.442Z",
    transform: "translate(-1142.073 -669.753)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1041.806,667.236h.422v.446h-.422Z",
    transform: "translate(-1035.918 -662.183)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1130.793,676.211v-.431h.437v.431Z",
    transform: "translate(-1108.549 -669.157)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1103.33,675.751v-.421h.43v.421Z",
    transform: "translate(-1086.133 -668.79)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1261.07,671.1h.416v.426h-.416Z",
    transform: "translate(-1214.881 -665.333)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1151.456,669.211h.415v.424h-.415Z",
    transform: "translate(-1125.414 -663.795)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1076.017,675.163v-.42h.419v.42Z",
    transform: "translate(-1063.841 -668.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1275.149,671.841h-.42v-.43h.42Z",
    transform: "translate(-1226.029 -665.591)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1144.433,676.41v-.415h.425v.415Z",
    transform: "translate(-1119.682 -669.332)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1048.988,674.409v.416h-.425v-.416Z",
    transform: "translate(-1041.433 -668.038)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1083.409,668.133v.42h-.429v-.42Z",
    transform: "translate(-1069.524 -662.915)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1165.137,669.5h.419v.43h-.419Z",
    transform: "translate(-1136.581 -664.027)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1220.375,670.462v.419h-.429v-.419Z",
    transform: "translate(-1181.316 -664.816)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1096.585,668.757v-.422h.43v.422Z",
    transform: "translate(-1080.628 -663.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1090.079,675.059v.426h-.43v-.426Z",
    transform: "translate(-1074.967 -668.568)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1158.6,676.218v.419h-.43v-.419Z",
    transform: "translate(-1130.894 -669.514)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1021.227,673.814h.421v.429h-.421Z",
    transform: "translate(-1019.121 -667.552)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1028.627,667.131v.419h-.428v-.419Z",
    transform: "translate(-1024.812 -662.098)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1137.79,669.41v-.421h.42v.421Z",
    transform: "translate(-1114.26 -663.614)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1206.656,670.2v.419h-.429V670.2Z",
    transform: "translate(-1170.118 -664.606)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1034.836,674.5v-.428h.428v.428Z",
    transform: "translate(-1030.229 -667.765)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1281.772,665.158v-.4h.4v.4Z",
    transform: "translate(-1231.778 -660.162)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1275.528,657.851v.38h-.391v-.38Z",
    transform: "translate(-1226.362 -654.523)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1213.346,663.622h.384V664h-.384Z",
    transform: "translate(-1175.929 -659.233)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1268.55,664.579v.371h-.39v-.371Z",
    transform: "translate(-1220.668 -660.015)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1131.519,662.116v.4h-.391v-.4Z",
    transform: "translate(-1108.822 -658.004)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1199.631,663.723v-.4H1200v.4Z",
    transform: "translate(-1164.735 -658.989)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1021.52,660.174h.376v.409h-.376Z",
    transform: "translate(-1019.36 -656.419)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1172.157,663.249v-.381h.4v.381Z",
    transform: "translate(-1142.31 -658.618)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1117.778,662v.36h-.4V662Z",
    transform: "translate(-1097.6 -657.907)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1062.68,661.3v-.392h.373v.392Z",
    transform: "translate(-1052.955 -657.021)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1227.395,663.876v.362h-.4v-.362Z",
    transform: "translate(-1187.068 -659.441)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1145.219,662.41v.382h-.366v-.382Z",
    transform: "translate(-1120.025 -658.244)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1158.537,662.645h.379v.364h-.379Z",
    transform: "translate(-1131.194 -658.436)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1103.7,662.1v-.361h.382v.361Z",
    transform: "translate(-1086.438 -657.701)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1261.408,657.95v-.383h.373v.383Z",
    transform: "translate(-1215.157 -654.291)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1090.379,661.862h-.374v-.392h.374Z",
    transform: "translate(-1075.258 -657.477)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1288.782,658.075h.388v.37h-.388Z",
    transform: "translate(-1237.5 -654.706)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1076.73,661.2v.385h-.379V661.2Z",
    transform: "translate(-1064.114 -657.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1049.319,660.781v.366h-.384v-.366Z",
    transform: "translate(-1041.736 -656.915)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1186.336,663.188v.362h-.385v-.362Z",
    transform: "translate(-1153.569 -658.879)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1254.827,664.774h-.365V664.4h.365Z",
    transform: "translate(-1209.487 -659.868)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1248.1,657.418v.367h-.39v-.367Z",
    transform: "translate(-1203.979 -654.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1302.5,658.7v-.364h.382v.364Z",
    transform: "translate(-1248.698 -654.918)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1035.176,660.916v-.363h.378v.363Z",
    transform: "translate(-1030.506 -656.728)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1295.527,665.438v-.359h.382v.359Z",
    transform: "translate(-1243.005 -660.423)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1241.133,664.489h-.385v-.382h.385Z",
    transform: "translate(-1198.294 -659.629)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1179.7,656.643h-.336V656.3h.336Z",
    transform: "translate(-1148.196 -653.256)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1042.637,653.758v.354h-.34v-.339Z",
    transform: "translate(-1036.319 -651.182)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1214.01,650.376h-.334v-.343h.334Z",
    transform: "translate(-1176.198 -648.142)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1296.28,651.435v.342h-.346v-.342Z",
    transform: "translate(-1243.337 -649.286)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1308.738,665.438v-.359h.382v.359Z",
    transform: "translate(-1253.788 -660.423)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1308.2,651.435v.342h-.346v-.342Z",
    transform: "translate(-1253.067 -649.286)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1097.419,654.88v.337h-.347v-.337Z",
    transform: "translate(-1081.026 -652.098)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1151.848,656.121v-.334h.344v.334Z",
    transform: "translate(-1125.734 -652.839)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1241.161,650.527h.339v.345l-.339.017Z",
    transform: "translate(-1198.631 -648.545)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1104.378,648.451h-.343v-.345h.343Z",
    transform: "translate(-1086.709 -646.569)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1145.561,648.822v.338h-.328v-.338Z",
    transform: "translate(-1120.335 -647.154)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1090.39,647.878h.328v.341h-.328Z",
    transform: "translate(-1075.572 -646.383)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1158.854,649.078h.335v.331h-.335Z",
    transform: "translate(-1131.452 -647.363)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1083.408,654.9v-.331h.335v.331Z",
    transform: "translate(-1069.873 -651.842)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1234.137,657.6v-.321h.345v.321Z",
    transform: "translate(-1192.898 -654.052)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1028.963,653.649v.334h-.332v-.334Z",
    transform: "translate(-1025.164 -651.094)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1111.1,655.1v.334h-.333c-.005-.1-.011-.206-.017-.334Z",
    transform: "translate(-1092.186 -652.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1282.271,651.205h.321v.345h-.321Z",
    transform: "translate(-1232.185 -649.099)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1254.814,651.094v-.324h.336v.324Z",
    transform: "translate(-1209.775 -648.744)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1172.619,649.649v-.339h.323v.339Z",
    transform: "translate(-1142.687 -647.552)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1131.491,648.606h.342v.325h-.342Z",
    transform: "translate(-1109.119 -646.977)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1186.664,649.88h-.344v-.335h.344Z",
    transform: "translate(-1153.87 -647.744)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1138.22,655.947v-.32h.335v.32Z",
    transform: "translate(-1114.611 -652.708)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1070.1,654.4v.329l-.345.017V654.4Z",
    transform: "translate(-1058.731 -651.704)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1165.984,656.084v.318h-.328v-.318Z",
    transform: "translate(-1137.004 -653.081)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1227.438,650.574v-.344h.319v.344Z",
    transform: "translate(-1187.431 -648.303)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1220.81,657v.339h-.324V657Z",
    transform: "translate(-1181.756 -653.825)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1200.034,649.852h.327v.316h-.327Z",
    transform: "translate(-1165.064 -647.994)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1124.533,655.357h.344v.318h-.344Z",
    transform: "translate(-1103.44 -652.488)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1193.4,656.843h-.318v-.327h.318Z",
    transform: "translate(-1159.392 -653.433)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1014.913,653.478h.345v.317h-.345Z",
    transform: "translate(-1013.968 -650.954)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1268.816,651.073v.312h-.346v-.312Z",
    transform: "translate(-1220.92 -648.991)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1206.653,657.183v-.315H1207v.315Z",
    transform: "translate(-1170.466 -653.721)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1117.715,648.393h.346v.318h-.331C1117.725,648.614,1117.721,648.518,1117.715,648.393Z",
    transform: "translate(-1097.875 -646.804)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1056.286,654.195v.308h-.334c-.005-.094-.01-.19-.016-.308Z",
    transform: "translate(-1047.451 -651.539)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1234.454,643.934v-.287h.305v.287Z",
    transform: "translate(-1193.157 -642.93)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1248.1,644.1a.785.785,0,0,1-.018-.111c0-.053.005-.107.01-.175a1.147,1.147,0,0,1,.13-.025,1.536,1.536,0,0,1,.157.006v.3Z",
    transform: "translate(-1204.283 -643.042)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1056.379,640.821v-.286h.291v.286Z",
    transform: "translate(-1047.812 -640.39)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1138.758,642.365h-.291c-.006-.095-.011-.18-.018-.287h.309Z",
    transform: "translate(-1114.798 -641.649)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1049.436,647.591v-.308h.291c.005.1.01.177.016.282Z",
    transform: "translate(-1042.145 -645.898)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1179.968,642.932h-.313c0-.095-.008-.175-.012-.283l.3-.025C1179.952,642.727,1179.959,642.815,1179.968,642.932Z",
    transform: "translate(-1148.42 -642.095)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1165.989,642.663v-.308l.292-.016c.007.106.013.193.021.3Z",
    transform: "translate(-1137.276 -641.862)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1303.286,645.065h-.309v-.291l.286-.018C1303.271,644.86,1303.277,644.947,1303.286,645.065Z",
    transform: "translate(-1249.085 -643.835)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1076.675,647.77h.307c.005.093.01.181.017.295l-.306.014C1076.687,647.973,1076.682,647.886,1076.675,647.77Z",
    transform: "translate(-1064.378 -646.295)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1063.456,647.535c-.005.1-.009.184-.013.28h-.292v-.28Z",
    transform: "translate(-1053.34 -646.103)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1111.183,641.862v-.3h.293v.281Z",
    transform: "translate(-1092.543 -641.229)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1125.154,641.963h-.305l-.016-.292.306-.016C1125.144,641.761,1125.148,641.848,1125.154,641.963Z",
    transform: "translate(-1103.684 -641.303)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1193.578,642.842v.3c-.243.067-.361.013-.284-.277Z",
    transform: "translate(-1159.543 -642.273)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1070.022,641.124c.005-.113.009-.194.013-.288h.293v.288Z",
    transform: "translate(-1058.948 -640.636)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1042.9,640.638h-.269c-.007-.092-.013-.178-.021-.288h.289Z",
    transform: "translate(-1036.575 -640.239)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1275.622,644.69V644.4h.288v.275Z",
    transform: "translate(-1226.758 -643.545)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1261.912,644.462v-.281h.28v.281Z",
    transform: "translate(-1215.568 -643.366)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1084.034,641.347h-.307v-.27h.292C1084.024,641.16,1084.028,641.24,1084.034,641.347Z",
    transform: "translate(-1070.134 -640.832)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1289.264,644.637a1.11,1.11,0,0,1,.122-.015c.054,0,.108.005.179.01v.278h-.3Z",
    transform: "translate(-1237.893 -643.726)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1021.957,646.786h.276v.259C1021.929,647.108,1021.926,647.106,1021.957,646.786Z",
    transform: "translate(-1019.707 -645.492)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1015.527,640.043h-.3c-.006-.088-.011-.166-.019-.271l.307-.027C1015.518,639.846,1015.522,639.932,1015.527,640.043Z",
    transform: "translate(-1014.207 -639.745)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1028.917,640.346v-.268l.291-.021c.005.1.01.184.015.289Z",
    transform: "translate(-1025.398 -640)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1097.5,641.466v-.305l.275-.012v.3Z",
    transform: "translate(-1081.371 -640.89)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1221.051,643.726h-.282q-.006-.132-.012-.256C1221.079,643.4,1221.082,643.407,1221.051,643.726Z",
    transform: "translate(-1181.978 -642.758)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1152.243,642.269h.29c0,.09.008.168.013.269h-.289C1152.253,642.455,1152.249,642.377,1152.243,642.269Z",
    transform: "translate(-1126.057 -641.805)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1207.133,643.475v-.266h.275v.266Z",
    transform: "translate(-1170.858 -642.572)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1035.966,647.424h-.29c0-.091-.009-.169-.014-.269h.29C1035.956,647.238,1035.96,647.316,1035.966,647.424Z",
    transform: "translate(-1030.903 -645.793)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(212.446 100.101)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 97.364,
    height: 69.736,
    rx: 9.667,
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(68.195 3.305)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 18.123,
    height: 25.629,
    transform: "translate(20.832 28.735) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 3.331,
    height: 9.861,
    transform: "matrix(-0.707, -0.707, 0.707, -0.707, 2.356, 9.328)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 10.127,
    transform: "translate(4.046 8.997)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 13.858,
    transform: "translate(4.046 12.462)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 13.858,
    transform: "translate(4.046 15.926)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 13.858,
    transform: "translate(4.046 19.391)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 13.858,
    transform: "translate(4.046 22.856)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 13.858,
    transform: "translate(4.046 26.32)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.768 3.461)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 18.122,
    height: 25.629,
    transform: "matrix(-0.989, -0.147, 0.147, -0.989, 17.926, 30.459)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 3.331,
    height: 9.861,
    transform: "translate(2.5 8.549) rotate(-126.556)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 10.017,
    y1: 1.488,
    transform: "translate(4.221 8.47)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 13.708,
    y1: 2.036,
    transform: "translate(3.712 11.897)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 13.708,
    y1: 2.035,
    transform: "translate(3.203 15.324)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 13.708,
    y1: 2.035,
    transform: "translate(2.694 18.751)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 13.708,
    y1: 2.035,
    transform: "translate(2.185 22.178)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 13.708,
    y1: 2.036,
    transform: "translate(1.676 25.605)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(66.195 37.686)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 18.122,
    height: 25.629,
    transform: "translate(17.926 30.459) rotate(-171.553)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 3.331,
    height: 9.861,
    transform: "translate(2.5 8.549) rotate(-126.553)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 10.018,
    y1: 1.488,
    transform: "translate(4.221 8.47)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 13.708,
    y1: 2.035,
    transform: "translate(3.712 11.897)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 13.708,
    y1: 2.036,
    transform: "translate(3.203 15.324)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 13.708,
    y1: 2.036,
    transform: "translate(2.694 18.751)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 13.708,
    y1: 2.036,
    transform: "translate(2.185 22.178)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 13.708,
    y1: 2.035,
    transform: "translate(1.676 25.605)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.993 4.966)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 18.122,
    height: 25.629,
    transform: "translate(23.504 26.671) rotate(172.471)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 3.331,
    height: 9.861,
    transform: "translate(2.644 9.853) rotate(-142.529)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 10.04,
    y2: 1.327,
    transform: "translate(4.276 7.976)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 13.739,
    y2: 1.816,
    transform: "translate(4.73 10.922)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 13.739,
    y2: 1.816,
    transform: "translate(5.184 14.357)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 13.739,
    y2: 1.816,
    transform: "translate(5.638 17.791)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 13.739,
    y2: 1.816,
    transform: "translate(6.092 21.226)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 13.739,
    y2: 1.816,
    transform: "translate(6.546 24.661)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(33.898 38.38)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "d",
    width: 18.123,
    height: 25.629,
    transform: "matrix(-0.985, -0.171, 0.171, -0.985, 17.855, 32.732)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 3.331,
    height: 9.861,
    transform: "translate(14.246 10.285) rotate(-170.149)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 9.059,
    height: 9.059,
    transform: "translate(13.643 23.447) rotate(-170.151)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 5.04,
    height: 5.04,
    transform: "translate(15.586 26.368) rotate(-170.153)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M532.771,448.83l-91,66.221H569.922L541.8,453.511Z",
    transform: "translate(-220.296 -264.04)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(312.475 184.79)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 42.335,
    height: 2.721,
    transform: "translate(42.335 2.721) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "i",
    width: 37.831,
    height: 63.484,
    transform: "translate(40.083 66.205) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "j",
    width: 34.228,
    height: 33.796,
    transform: "translate(38.282 39.54) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "j",
    width: 34.228,
    height: 23.02,
    transform: "translate(38.282 64.176) rotate(180)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    x1: 34.228,
    transform: "translate(4.053 16.814)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "k",
    x1: 34.228,
    transform: "translate(4.053 28.223)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M1042.852,511.045c0,.529.958.957,2.139.957s2.139-.428,2.139-.957-.958-.957-2.139-.957S1042.852,510.516,1042.852,511.045Z",
    transform: "translate(-1023.373 -498.829)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "e",
    cx: 2.139,
    cy: 0.957,
    rx: 2.139,
    ry: 0.957,
    transform: "translate(19.479 22.237)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M1042.852,632.949c0,.528.958.957,2.139.957s2.139-.429,2.139-.957-.958-.957-2.139-.957S1042.852,632.42,1042.852,632.949Z",
    transform: "translate(-1023.373 -598.327)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M1140.085,692.718h0a1.085,1.085,0,0,1-1.085-1.085v-3.217a1.085,1.085,0,0,1,1.085-1.085h0Z",
    transform: "translate(-1101.849 -643.494)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M1140.085,746.081h0A1.085,1.085,0,0,1,1139,745v-3.217a1.085,1.085,0,0,1,1.085-1.085h0Z",
    transform: "translate(-1101.849 -687.049)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M967.365,713.43h0a.958.958,0,0,1-.958-.958v-7.285a.958.958,0,0,1,.958-.958h0a.958.958,0,0,1,.958.958v7.285A.958.958,0,0,1,967.365,713.43Z",
    transform: "translate(-960.979 -657.286)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(236.91 181.688)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M778.02,456.005s.6,5.778-.573,7.163H781.6S783.21,457.659,778.02,456.005Z",
    transform: "translate(-748.685 -451.585)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M680.616,597.709h0a3.33,3.33,0,0,1,2.952-3.67l27.171-3.38.86,7.932-27.5,2.083A3.33,3.33,0,0,1,680.616,597.709Z",
    transform: "translate(-669.635 -561.489)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M642.973,646.89l-2.717-.9,7.5-34.463a3.178,3.178,0,0,1,3.8-2.4h0a3.178,3.178,0,0,1,2.37,3.918Z",
    transform: "translate(-636.709 -576.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M700.728,592.333h0a3.33,3.33,0,0,1,2.427-4.036l26.858-8.919,1.108,4.743a5.978,5.978,0,0,1-4.89,7.266L704.582,594.8A3.33,3.33,0,0,1,700.728,592.333Z",
    transform: "translate(-685.985 -552.281)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M711.19,661.078l-2.818.5L700.94,632.6a3.178,3.178,0,0,1,2.21-3.912h0a3.177,3.177,0,0,1,3.943,2.328Z",
    transform: "translate(-686.144 -592.431)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M733.661,517.508l10.122-13.8-5.165-3.264-9.031,14.291a2.467,2.467,0,0,0,.768,3.4h0A2.467,2.467,0,0,0,733.661,517.508Z",
    transform: "translate(-709.309 -487.852)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M668.5,564.83l13.5,1.646a2.384,2.384,0,0,1,1.792,2.857h0a2.384,2.384,0,0,1-2.856,1.792l-13-3.805Z",
    transform: "translate(-659.293 -540.407)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M750.732,585.713l.134,2.756a6.612,6.612,0,0,1-5.839,6.889l-9.239,1.077s-.23-8.391-11.327-9.066l12.362-1.538,6.47-2.568Z",
    transform: "translate(-705.437 -555.452)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M777.148,513.728l5.083.316a1.534,1.534,0,0,0,1.632-1.027l.484-1.416.512,1.252a1.736,1.736,0,0,0,1.96,1.042l5.219-1-2.549-6.784-.55-8.593a3.509,3.509,0,0,0-3.546-3.285c-.49.006-1.026.02-1.6.045-2.016.088-5.129.475-6.953.72a1.424,1.424,0,0,0-1.214,1.659l.32,1.814a5.325,5.325,0,0,0-.935,3.418,4.549,4.549,0,0,0,2.032,2.8l.333,1.887Z",
    transform: "translate(-746.66 -482.786)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "n",
    width: 3.442,
    height: 4.88,
    transform: "matrix(-0.999, 0.044, -0.044, -0.999, 35.496, 13.049)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M780.565,445.539a7.623,7.623,0,0,0,.761,3.256c.346.779.867,1.544,1.56,1.6a2.038,2.038,0,0,0,1.311-.58,5.674,5.674,0,0,0,2.162-4.026c.089-2.1-1.138-3.865-2.741-3.934a2.992,2.992,0,0,0-2.721,2.079A4.583,4.583,0,0,0,780.565,445.539Z",
    transform: "translate(-751.227 -440.031)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M785.392,471.6s-.038.748-.347.728a.605.605,0,0,0,.651.246",
    transform: "translate(-754.886 -464.316)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M787.434,480.119c.215.1.422-.117.422-.117s.23.6-.08.575S787.434,480.119,787.434,480.119Z",
    transform: "translate(-756.836 -471.171)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M624.862,807.975l-3.9.573,6.21,1.651.4-1.5Z",
    transform: "translate(-620.959 -738.862)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M727.245,805.259l-3.049,2.106,6.332-1.092-.265-1.534Z",
    transform: "translate(-705.221 -736.22)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M645.995,566.785s-1.6,1.29-2.47.972.638-.978.638-.978-3.065-.82-3.023-1.52-.764-2.611,5.561-1.558C646.7,563.7,648.143,564.379,645.995,566.785Z",
    transform: "translate(-637.419 -539.233)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M796.51,569.333l-1.357,3.539.538.251,1.256-3.558Z",
    transform: "translate(-763.136 -544.083)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M848.486,567.242l1.661,3.407-.514.3-1.562-3.434Z",
    transform: "translate(-806.328 -542.376)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M807.005,511.663l4.5-13.133a3.017,3.017,0,0,0-2.075-3.893h0a2.877,2.877,0,0,0-3.522,2.036l-3.623,13.553a2.467,2.467,0,0,0,1.746,3.02h0A2.466,2.466,0,0,0,807.005,511.663Z",
    transform: "translate(-768.892 -483.035)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M711.868,563.291l18.667,4.247a2.384,2.384,0,0,0,2.715-2h0a2.384,2.384,0,0,0-2-2.715l-19-2.057Z",
    transform: "translate(-695.159 -537.09)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M690.528,563.091s-1.563,1.332-2.444,1.036.612-.994.612-.994-3.085-.741-3.061-1.442-.831-2.59,5.519-1.7C691.154,559.99,692.613,560.63,690.528,563.091Z",
    transform: "translate(-673.726 -536.267)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M791.71,498.51c-2.29,1.2-2.4-1.76-2.356-3.009,1.4-.181,3.223-.4,4.788-.526C794.144,494.982,794.578,497.011,791.71,498.51Z",
    transform: "translate(-758.397 -483.392)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M803.347,506.883s1.067-.505,1.213,0a5.5,5.5,0,0,1-1.394,1.066A5.141,5.141,0,0,0,803.347,506.883Z",
    transform: "translate(-769.677 -492.928)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M790.679,506.419a4.474,4.474,0,0,0-.317,1.182,2.615,2.615,0,0,1-.589-1.447A1.714,1.714,0,0,1,790.679,506.419Z",
    transform: "translate(-758.745 -492.507)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M804.147,495.946s1.2.23,1.228.9c0,0,2.183-1.847,1.608-3.4,0,0-.374-.5-1.221.176S805.332,494.821,804.147,495.946Z",
    transform: "translate(-770.477 -481.991)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M787.974,498.042s-1.124,0-1.113.756a4.1,4.1,0,0,1-.252-2.662s.171-.485.814-.119A2.6,2.6,0,0,0,787.974,498.042Z",
    transform: "translate(-756.041 -484.131)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M782.495,436.926h-4.84s-1.034-3.63,1.514-4.457,5.006-.635,6.358.414c1.777,1.379,3.891,3.952,3.064,10.34a24.688,24.688,0,0,1-6.547.482A11.559,11.559,0,0,0,782.495,436.926Z",
    transform: "translate(-748.684 -431.954)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(157.672 151.071)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "x",
    width: 49.06,
    height: 3.762,
    transform: "translate(1.574 96.178)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "x",
    width: 3.157,
    height: 57.573,
    transform: "translate(8.828 42.367)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "x",
    width: 3.157,
    height: 57.573,
    transform: "translate(42.074 42.367)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "x",
    width: 45.684,
    height: 2.714,
    transform: "translate(4.055 40.718)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.814)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M351.157,320.634h2.432l-12.441-55.259-2.419.06Z",
    transform: "translate(-338.729 -265.375)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(26.058)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M450.417,320.634h2.432l-12.441-55.259-2.419.06Z",
    transform: "translate(-437.99 -265.375)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M308.789,339.7H345.1l-12.575-55.854H296.214Z",
    transform: "translate(-296.214 -280.453)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M315.675,339.7h36.307l-12.575-55.854H303.1Z",
    transform: "translate(-301.834 -280.453)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M368.16,299.111H383.94l-.851-3.216H367.309Z",
    transform: "translate(-354.241 -290.285)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M333.781,313.873l9.855,43.771h28.452",
    transform: "translate(-326.877 -304.959)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "x",
    width: 39.546,
    height: 1.682,
    transform: "translate(51.097 59.595) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M398,404.154l3.959-11.675,4.691-2.446,2.521-6.545,2.511-.558,2.862-9.93,5.165,3.676",
    transform: "translate(-379.29 -353.219)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M408.426,331.522l-8.5-2.022L394.8,339.517l-.307,9.817-1.658,4.014-5.779,6.606",
    transform: "translate(-370.362 -317.714)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M393.423,355.588l1.789-6.772,4.184-1.223,3.768-14.024,3.716-.375,2.164-13.813,4.046-5.882",
    transform: "translate(-375.556 -304.652)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "ad",
    transform: "translate(14.066 6.76) rotate(-17.383)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "DATA STATISTIC"))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(204.366 207.825)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.013 0.829)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ae",
    d: "M494.89,623.011h2.757V586.99a5.572,5.572,0,0,1,5.566-5.565H529.6a5.572,5.572,0,0,1,5.566,5.565v36.021h2.757V586.99a8.332,8.332,0,0,0-8.323-8.322H503.213a8.332,8.332,0,0,0-8.323,8.322Z",
    transform: "translate(-494.89 -578.667)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "af",
    d: "M475.179,576.278H522.3a2.122,2.122,0,0,0,2.122-2.122H473.057A2.122,2.122,0,0,0,475.179,576.278Z",
    transform: "translate(-473.057 -574.156)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M645.954,566.938H660.8a1.327,1.327,0,0,1-1.327,1.327H645.954Z",
    transform: "translate(-406.559 -360.44)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M615.687,513.816,608.948,502.1a1.327,1.327,0,0,1,.489-1.812h0l7.4,12.87Z",
    transform: "translate(-377.983 -306.038)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ag",
    d: "M645.075,567.578a.64.64,0,1,0,.64-.64A.64.64,0,0,0,645.075,567.578Z",
    transform: "translate(-406.963 -360.44)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(215.075 196.65)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M540.942,553.806h-2.6a2.723,2.723,0,0,1-2.723-2.724l.037-2.079H543.7l-.037,2.079A2.723,2.723,0,0,1,540.942,553.806Z",
    transform: "translate(-535.622 -542.451)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.198 6.85)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M574.786,554.365v-.443c.8,0,2.116-.667,2.116-1.426s-1.319-1.426-2.116-1.426v-.443c1.006,0,2.558.8,2.558,1.869S575.792,554.365,574.786,554.365Z",
    transform: "translate(-574.786 -550.627)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "ah",
    d: "M543.393,519.135s-1.5,1.279-.713,2.607a1.906,1.906,0,0,1-.074,2.269,3.019,3.019,0,0,0-.782-2.287C540.995,520.812,542.729,519.11,543.393,519.135Z",
    transform: "translate(-540.504 -518.073)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ah",
    d: "M554.853,513.357s-1.5,1.279-.713,2.607a1.906,1.906,0,0,1-.074,2.269,3.021,3.021,0,0,0-.782-2.287C552.455,515.034,554.189,513.332,554.853,513.357Z",
    transform: "translate(-549.858 -513.357)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ah",
    d: "M565.656,518.4s-1.5,1.279-.713,2.607a1.906,1.906,0,0,1-.074,2.269,3.019,3.019,0,0,0-.782-2.288C563.258,520.08,564.992,518.378,565.656,518.4Z",
    transform: "translate(-558.675 -517.475)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(262.369 197.585)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ai",
    d: "M853.79,542.631h1.589a7.192,7.192,0,0,0,7.192-7.192v-13.71a3.576,3.576,0,0,0-1.213-2.684h0a2.393,2.393,0,0,0-3.943,1.41Z",
    transform: "translate(-833.714 -518.445)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ag",
    d: "M869.941,521.768a2.359,2.359,0,0,1,1.215-1.714,2.448,2.448,0,0,1,.43.3,3.576,3.576,0,0,1,1.213,2.684v13.71a7.192,7.192,0,0,1-6.478,7.156Z",
    transform: "translate(-843.942 -519.758)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "aj",
    width: 4.222,
    height: 17.741,
    transform: "translate(14.271 49.458) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ak",
    d: "M3.027,0H10.2A3.026,3.026,0,0,1,13.23,3.026v0a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0v0A3.027,3.027,0,0,1,3.027,0Z",
    transform: "translate(19.127 31.717) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ak",
    width: 7.462,
    height: 4.293,
    transform: "translate(15.963 35.095) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "ak",
    width: 7.462,
    height: 3.167,
    transform: "translate(15.963 52.273) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ak",
    d: "M0,0H18.578a0,0,0,0,1,0,0V0a4.5,4.5,0,0,1-4.5,4.5H4.5A4.5,4.5,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    transform: "translate(21.66 55.694) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ai",
    d: "M768.912,644.624l-1.123,2.578a4.087,4.087,0,0,1-3.748,2.456h-16a3.483,3.483,0,0,1-3.483-3.483h0a3.484,3.484,0,0,1,3.483-3.484h19.6A1.382,1.382,0,0,1,768.912,644.624Z",
    transform: "translate(-744.561 -619.854)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ag",
    d: "M789.2,644.624,788.08,647.2a4.088,4.088,0,0,1-3.748,2.456h-16a3.483,3.483,0,0,1-3.483-3.483h0a3.484,3.484,0,0,1,3.483-3.484h19.6A1.382,1.382,0,0,1,789.2,644.624Z",
    transform: "translate(-761.123 -619.854)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(323.987 159.362)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "ag",
    width: 9.028,
    height: 0.492,
    transform: "translate(1.45 24.956)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M1051.955,396.886h-6.73l-1.423-11.052h9.466Z",
    transform: "translate(-1042.572 -371.985)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.044 2.295)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "al",
    d: "M1072.357,354.1a3.559,3.559,0,0,1,1.125-.6.171.171,0,0,1,.128.012.176.176,0,0,1,.059.118,4.041,4.041,0,0,1-.01,1.213,1.341,1.341,0,0,1-.152.573,1.148,1.148,0,0,1-.264.274,4.11,4.11,0,0,1-3.365.806,1.489,1.489,0,0,1-.852-.427.982.982,0,0,1-.124-1.035,1.009,1.009,0,0,1,.653-.556c.236-.035.482.116.722.135A3.545,3.545,0,0,0,1072.357,354.1Z",
    transform: "translate(-1063.027 -347.891)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "al",
    d: "M1060.99,324.533a1.988,1.988,0,0,1,.261-.917,2.147,2.147,0,0,1,1.813-.641,1.029,1.029,0,0,1,.513.075.9.9,0,0,1,.3.3c.914,1.3.887,3.013.865,4.6q-.047,3.4.157,6.8a.549.549,0,0,1-.072.384.531.531,0,0,1-.348.148,10.462,10.462,0,0,1-2.865.048c-.99-.125-.624-1-.6-1.788.066-1.945-.1-3.887-.134-5.831A25.36,25.36,0,0,1,1060.99,324.533Z",
    transform: "translate(-1056.548 -322.974)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "al",
    d: "M1040.65,329.175a.58.58,0,0,1,.362.112.515.515,0,0,1,.132.223c.269.779-.231,1.731.214,2.425a2.078,2.078,0,0,0,1.251.716l1.713.495a.33.33,0,0,1,.3.408q-.019.681-.038,1.363a10.7,10.7,0,0,1-3.5-.253,2.387,2.387,0,0,1-.889-.446,2.289,2.289,0,0,1-.6-.957,8.153,8.153,0,0,1-.331-3.029C1039.285,329.355,1039.77,329.128,1040.65,329.175Z",
    transform: "translate(-1038.904 -328.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "am",
    d: "M1063.567,327.043a1.533,1.533,0,0,0,.048.6",
    transform: "translate(-1058.738 -326.295)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "am",
    d: "M1070.132,335.823q-.016.452.009.9",
    transform: "translate(-1064.101 -333.461)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "am",
    d: "M1077.169,331.621a4.511,4.511,0,0,0-.28.693",
    transform: "translate(-1069.621 -330.032)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "am",
    d: "M1079.705,337.158q-.232.375-.427.771",
    transform: "translate(-1071.57 -334.551)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "am",
    d: "M1059.557,336.873l.194.573",
    transform: "translate(-1055.474 -334.318)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "am",
    d: "M1059.815,344.238a3.776,3.776,0,0,1,.313.45",
    transform: "translate(-1055.685 -340.33)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "am",
    d: "M1080.682,347.731c0,.184-.158.323-.276.463a1.435,1.435,0,0,0-.275.5",
    transform: "translate(-1072.267 -343.181)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "am",
    d: "M1074.5,347.737a1.577,1.577,0,0,1-.373.841",
    transform: "translate(-1067.371 -343.185)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "am",
    d: "M1076.446,360.412a4.8,4.8,0,0,1-.506.813",
    transform: "translate(-1068.846 -353.531)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "am",
    d: "M1059.547,362.973l.434.553c.038.049.086.1.148.1",
    transform: "translate(-1055.466 -355.621)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "am",
    d: "M1065.569,367.812a1.061,1.061,0,0,0,.4.531",
    transform: "translate(-1060.381 -359.571)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "am",
    d: "M1060.089,371.437a2.131,2.131,0,0,0,.421.6",
    transform: "translate(-1055.908 -362.529)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "am",
    d: "M1076.285,367.38a1.325,1.325,0,0,1-.372.841",
    transform: "translate(-1068.824 -359.218)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "am",
    d: "M1081.375,371.7c.047.014.031.084.006.126q-.267.449-.563.88",
    transform: "translate(-1072.828 -362.744)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "am",
    d: "M1082.757,378.693l-.38.55",
    transform: "translate(-1074.101 -368.452)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "am",
    d: "M1067.88,375.873a1.3,1.3,0,0,0,.381.582",
    transform: "translate(-1062.267 -366.15)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "am",
    d: "M1071.685,369.756a1.427,1.427,0,0,0,.154.576",
    transform: "translate(-1065.373 -361.158)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "am",
    d: "M1059.81,379.07a2.137,2.137,0,0,0,.612.509",
    transform: "translate(-1055.681 -368.76)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "am",
    d: "M1048.081,331.359a2.249,2.249,0,0,1-.445.87",
    transform: "translate(-1045.744 -329.818)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "am",
    d: "M1048.667,338.075l-.419.651",
    transform: "translate(-1046.244 -335.299)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "am",
    d: "M1044.355,334.189a2.279,2.279,0,0,0,.071.442",
    transform: "translate(-1043.066 -332.128)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "am",
    d: "M1038.192,334.346a.932.932,0,0,0,.291.574",
    transform: "translate(-1038.036 -332.256)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "am",
    d: "M1037.344,340.618a2.815,2.815,0,0,0,.551.713",
    transform: "translate(-1037.344 -337.375)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "am",
    d: "M1038.276,347.759l.392.421c.05.054.116.112.187.1",
    transform: "translate(-1038.105 -343.204)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "am",
    d: "M1044.2,345.165a1.748,1.748,0,0,0,.5.725",
    transform: "translate(-1042.94 -341.086)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "am",
    d: "M1050.718,345.946a2.092,2.092,0,0,1-.192.74",
    transform: "translate(-1048.103 -341.724)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "am",
    d: "M1055.378,346.323c.035-.017.067.029.077.066a1.172,1.172,0,0,1,.035.463",
    transform: "translate(-1052.063 -342.029)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "am",
    d: "M1040.685,354.566a1.04,1.04,0,0,0,.573.169",
    transform: "translate(-1040.071 -348.759)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "am",
    d: "M1046.333,353.978a2.686,2.686,0,0,1,.548.05",
    transform: "translate(-1044.681 -348.28)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "am",
    d: "M1046.036,358.4a1.294,1.294,0,0,0,.794-.24",
    transform: "translate(-1044.438 -351.692)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "am",
    d: "M1050.695,360.027l.781-.434",
    transform: "translate(-1048.241 -352.862)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "am",
    d: "M1054.1,352.548a.65.65,0,0,1-.6-.22",
    transform: "translate(-1050.529 -346.933)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "am",
    d: "M1051.958,355.719a1,1,0,0,0-.743.15",
    transform: "translate(-1048.665 -349.685)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "am",
    d: "M1056.252,358.66a6.614,6.614,0,0,1-.442.721",
    transform: "translate(-1052.416 -352.101)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "am",
    d: "M1082.6,357.241q.118-.367.238-.733",
    transform: "translate(-1074.284 -350.344)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "am",
    d: "M1085.459,356.9a2.2,2.2,0,0,1,.386-.675",
    transform: "translate(-1076.615 -350.115)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "am",
    d: "M1089.247,354.662a.7.7,0,0,0,.385-.233q.24-.234.467-.48",
    transform: "translate(-1079.707 -348.257)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "am",
    d: "M1092.652,359.218a7.306,7.306,0,0,0,1.186-.364",
    transform: "translate(-1082.486 -352.259)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "am",
    d: "M1088.808,364.284a3.034,3.034,0,0,0,1.143.518",
    transform: "translate(-1079.349 -356.691)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "am",
    d: "M1065.682,352.243a1.076,1.076,0,0,1-.366-.818",
    transform: "translate(-1060.174 -346.196)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "am",
    d: "M1067.965,348.387a2.486,2.486,0,0,1-.2-.77",
    transform: "translate(-1062.171 -343.088)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "am",
    d: "M1065.115,359.156a1,1,0,0,1-.537-.648",
    transform: "translate(-1059.573 -351.977)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "am",
    d: "M1083.994,367.239a.994.994,0,0,0,.649.611",
    transform: "translate(-1075.42 -359.103)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "am",
    d: "M1084.994,363.71a.776.776,0,0,0,.367.333",
    transform: "translate(-1076.236 -356.223)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M1048.7,385.4h-11.162l-.437-2.845h11.928Z",
    transform: "translate(-1037.105 -369.312)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "an",
    d: "M1046.906,411.676l1.755,3.182,1.532-3.182,1.641,3.182,1.641-3.182,1.333,3.257",
    transform: "translate(-1045.105 -393.077)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M1043.84,418.033l-.26-6.357h9.466l-.178,6.357",
    transform: "translate(-1042.39 -393.077)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "f",
    x2: 0.246,
    y2: 6.385,
    transform: "translate(3.447 18.599)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "f",
    x2: 0.246,
    y2: 6.385,
    transform: "translate(5.104 18.599)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 0.246,
    y2: 6.385,
    transform: "translate(8.247 18.599)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "f",
    x1: 0.246,
    y2: 6.385,
    transform: "translate(6.579 18.599)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.587)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ao",
    d: "M1062.787,311.463a1.189,1.189,0,0,0-.575.543,1.548,1.548,0,0,0-.151.7.9.9,0,0,0,.021.231,1.217,1.217,0,0,0,.48.587.783.783,0,0,0,.383.187c.086.01.2-.018.208-.084a.134.134,0,0,0-.03-.085,2.214,2.214,0,0,1-.345-1.218.677.677,0,0,1,.061-.3c.079-.153.249-.275.3-.437C1063.192,311.39,1062.972,311.38,1062.787,311.463Z",
    transform: "translate(-1062.061 -311.243)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ap",
    d: "M1064.905,310.888a.787.787,0,0,0-.269.232,1.3,1.3,0,0,0-.36,1.15.984.984,0,0,0,.058.33,1.218,1.218,0,0,0,.307.376,1.2,1.2,0,0,0,.257.2.567.567,0,0,0,.349.066c-.025-.192-.071-.381-.1-.572a6.64,6.64,0,0,1-.058-.851,1.094,1.094,0,0,1,.1-.607c.052-.087.161-.228.072-.321S1065,310.844,1064.905,310.888Z",
    transform: "translate(-1063.861 -310.776)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ap",
    d: "M1074.288,312.288c.049.12.126.232.177.352a.859.859,0,0,1-.008.685,1.6,1.6,0,0,1-.256.381c-.068.079-.143.165-.134.259a.9.9,0,0,0,.7-.379.96.96,0,0,0,.16-.85,1.756,1.756,0,0,0-.086-.215q-.15-.326-.335-.641c-.061-.1-.214-.232-.263-.05A.741.741,0,0,0,1074.288,312.288Z",
    transform: "translate(-1071.86 -311.507)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aq",
    d: "M1066.722,311.967a1.631,1.631,0,0,0,.1.577.859.859,0,0,0,.442.456.26.26,0,0,0,.232.011c.063-.041.052-.115.04-.177a9.123,9.123,0,0,1,.161-2.008.3.3,0,0,0-.063-.228c-.306-.315-.621.11-.724.294A2.008,2.008,0,0,0,1066.722,311.967Z",
    transform: "translate(-1065.862 -310.485)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aq",
    d: "M1072.7,311.678a2.988,2.988,0,0,1,.046.516,2.513,2.513,0,0,1-.23.973c-.019.04-.035.092.006.12a.143.143,0,0,0,.079.017.69.69,0,0,0,.549-.386,1.868,1.868,0,0,0,.2-.382,1.269,1.269,0,0,0-.062-.883,1.237,1.237,0,0,0-.553-.746.181.181,0,0,0-.136-.029.082.082,0,0,0-.05.11.774.774,0,0,0,.075.112.392.392,0,0,1,.042.2A3.035,3.035,0,0,0,1072.7,311.678Z",
    transform: "translate(-1070.578 -310.803)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ar",
    d: "M1069.729,311.359a3.1,3.1,0,0,0-.078,1.189.706.706,0,0,0,.344.673c.172.078.161-.047.223-.167a2.689,2.689,0,0,0,.168-.3,1.059,1.059,0,0,0,.043-.363q0-.315,0-.629a1.663,1.663,0,0,0-.055-.52c-.042-.126-.158-.361-.3-.407s-.174.114-.219.211A3.173,3.173,0,0,0,1069.729,311.359Z",
    transform: "translate(-1068.239 -310.76)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(148.96 209.728)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "as",
    x2: 0.176,
    y2: 17.17,
    transform: "translate(11.238 13.819)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "as",
    d: "M315.669,680.7s-5.307.717-5.237,6.157",
    transform: "translate(-299.106 -663.021)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "as",
    d: "M286.569,691.091s4.173.231,4.3,3.336",
    transform: "translate(-279.629 -671.502)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "as",
    d: "M315.831,709.225a4.922,4.922,0,0,0-5.1,4.554",
    transform: "translate(-299.353 -686.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "as",
    d: "M277.917,713.48s6.035.569,6.065,3.479",
    transform: "translate(-272.568 -689.776)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "as",
    d: "M309.955,660.906s1.458-5.325,4.559-7.617",
    transform: "translate(-298.717 -640.648)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.949 8.247)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "at",
    d: "M319.524,636.818s7.884-1.591,6.687-7.39C326.211,629.428,317.7,628.3,319.524,636.818Z",
    transform: "translate(-319.267 -629.379)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "au",
    d: "M327.351,629.648s-4.206,1.715-6.687,7.39",
    transform: "translate(-320.407 -629.598)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "au",
    d: "M345.2,629.648a3.98,3.98,0,0,0-.292,1.415",
    transform: "translate(-340.191 -629.598)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "au",
    d: "M337.495,631.065a2.543,2.543,0,0,0-.079,2.225",
    transform: "translate(-333.882 -630.755)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "au",
    d: "M329.878,634.535s-.511,2.339,0,3.224",
    transform: "translate(-327.742 -633.587)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "au",
    d: "M324.055,640.428s-.28,2.9.271,3.542",
    transform: "translate(-323.117 -638.397)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "au",
    d: "M324.6,661.875a3.655,3.655,0,0,0,2.756.131",
    transform: "translate(-323.62 -655.902)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "au",
    d: "M330.269,652.923a7.187,7.187,0,0,0,3.451.494",
    transform: "translate(-328.247 -648.596)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "au",
    d: "M337.172,644.544a7.106,7.106,0,0,0,3.369.367",
    transform: "translate(-333.881 -641.757)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "au",
    d: "M343.793,638.277a3.282,3.282,0,0,0,2.527.147",
    transform: "translate(-339.285 -636.641)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.244)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "av",
    d: "M292.22,603.923a15.149,15.149,0,0,0-2.532-4.229c-1.766-2.244-2.258-9.222.383-15.183,0,0,9.744,3.991,3.857,15.571C293.452,601.019,292.148,602.462,292.22,603.923Z",
    transform: "translate(-288.227 -584.512)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "au",
    d: "M298.735,586.86a71.78,71.78,0,0,1,2.053,18.331",
    transform: "translate(-296.804 -586.428)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "au",
    d: "M304.419,592.986a11.664,11.664,0,0,1-1,2.9",
    transform: "translate(-300.624 -591.428)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "au",
    d: "M307.9,599.177a23.9,23.9,0,0,1-1.76,4.492",
    transform: "translate(-302.852 -596.482)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "au",
    d: "M310.682,610.551s-.969,3.633-2.925,4.915",
    transform: "translate(-304.167 -605.765)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "au",
    d: "M312.446,626.54s-1.769,3.87-3.572,3.961",
    transform: "translate(-305.079 -618.815)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "au",
    d: "M313.042,643.662a4.727,4.727,0,0,1-3.24,3.265",
    transform: "translate(-305.836 -632.79)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "au",
    d: "M312.006,664.474a2.662,2.662,0,0,1-1.887,1.183",
    transform: "translate(-306.095 -649.777)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "au",
    d: "M294.178,599.177s.828,1.291,1.658,1.546",
    transform: "translate(-293.084 -596.482)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "au",
    d: "M290.312,616.77a4.594,4.594,0,0,0,2.842,1.083",
    transform: "translate(-289.929 -610.841)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "au",
    d: "M289.275,627.8s1.765,1.607,3.372,1.534",
    transform: "translate(-289.082 -619.847)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "au",
    d: "M289.79,644.4s2.224.947,3.493.513",
    transform: "translate(-289.503 -633.39)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "au",
    d: "M291.181,652.544s1.811,1.525,3.412,1.425",
    transform: "translate(-290.638 -640.04)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "au",
    d: "M296.746,665.75a3.7,3.7,0,0,0,2.455.769",
    transform: "translate(-295.18 -650.818)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "as",
    d: "M281.3,658.353a11.329,11.329,0,0,1,5.41,6.216",
    transform: "translate(-275.328 -644.781)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.089 15.586)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "aw",
    d: "M325.469,672.335s2.554-6.3,10.662-.717c0,0-4.457,2.838-7.517,1.695C327.842,673.024,327.211,672.112,325.469,672.335Z",
    transform: "translate(-325.469 -669.308)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "au",
    d: "M336.131,678.149s-6.477-2.3-10.662.717",
    transform: "translate(-325.469 -675.84)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "au",
    d: "M371.567,679.975s.064-.819-1.068-1.305",
    transform: "translate(-362.223 -676.949)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "au",
    d: "M359.781,679.359a3.626,3.626,0,0,0-2.414-2.021",
    transform: "translate(-351.504 -675.862)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "au",
    d: "M351.238,679.966a4.175,4.175,0,0,0-1.923-2.628",
    transform: "translate(-344.932 -675.862)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "au",
    d: "M343.7,681.223s-.064-2.065-1.753-2.553",
    transform: "translate(-338.921 -676.949)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "au",
    d: "M334.488,683.2s-.021-1.125-1.552-1.655",
    transform: "translate(-331.564 -679.293)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "au",
    d: "M333.98,674.34a2.389,2.389,0,0,0,.584-1.486",
    transform: "translate(-332.416 -672.202)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "au",
    d: "M343.271,671.346a2.385,2.385,0,0,0,.448-1.589",
    transform: "translate(-339.999 -669.675)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "au",
    d: "M351.487,670.906a3.985,3.985,0,0,0,.425-1.467",
    transform: "translate(-346.705 -669.415)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "au",
    d: "M358.6,672.536s.927-.411.883-1.075",
    transform: "translate(-352.515 -671.065)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "au",
    d: "M368.877,676.229a1.823,1.823,0,0,0,.832-.489",
    transform: "translate(-360.899 -674.558)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 11.971)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "aw",
    d: "M257.2,652.844s-1.409-6.288-8.363-1.246c0,0-.6,2.675,4.886,1.39A5.305,5.305,0,0,1,257.2,652.844Z",
    transform: "translate(-248.813 -649.64)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "au",
    d: "M248.917,657.732a9.454,9.454,0,0,0,3.415-.357c1.664-.537,3.345-.124,4.948,1.6",
    transform: "translate(-248.898 -655.774)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "au",
    d: "M252.108,661.454a2.334,2.334,0,0,0,1.324-1.374",
    transform: "translate(-251.502 -658.161)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "au",
    d: "M256.282,655.492s.905.223.933.791",
    transform: "translate(-254.909 -654.417)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "au",
    d: "M264.148,657.823a2.076,2.076,0,0,1-1.177,2.188",
    transform: "translate(-260.37 -656.319)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "au",
    d: "M264.3,651.671s1.378.23,1.345,1.051",
    transform: "translate(-261.45 -651.298)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "au",
    d: "M275.95,657.389s.621,1.524-.448,1.924",
    transform: "translate(-270.597 -655.965)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "au",
    d: "M277.917,649.924a1.8,1.8,0,0,1,.4,1.452",
    transform: "translate(-272.568 -649.872)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "au",
    d: "M284.7,660.555a.7.7,0,0,1-.42.978",
    transform: "translate(-277.765 -658.549)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "au",
    d: "M286.449,653.874s.689.911.327,1.425",
    transform: "translate(-279.532 -653.096)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.597 17.026)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "av",
    d: "M269.958,680.5s-2.607-5.617-7.011-2.3c0,0-.259,3.711,2.747,2.686C267.478,680.27,267.613,681.576,269.958,680.5Z",
    transform: "translate(-262.942 -677.146)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "au",
    d: "M262.972,682.836a68.215,68.215,0,0,0,7.011,2.3",
    transform: "translate(-262.966 -681.79)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "au",
    d: "M270.921,678.4a2.25,2.25,0,0,1,.356,1.491",
    transform: "translate(-269.454 -678.17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "au",
    d: "M263.759,688.025s.435.325,2.158-.568",
    transform: "translate(-263.609 -685.562)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "au",
    d: "M277.917,677.151a4.175,4.175,0,0,1,.622,2.263",
    transform: "translate(-275.165 -677.15)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "au",
    d: "M269.442,691.544a5.728,5.728,0,0,0,2.54-1.421",
    transform: "translate(-268.247 -687.738)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "au",
    d: "M286.963,679.577s.8,1.32.232,2.234",
    transform: "translate(-282.548 -679.13)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "au",
    d: "M284.285,693.167s.484.115,1.115-.772",
    transform: "translate(-280.362 -689.592)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "au",
    d: "M293.788,685.655s.322,1.081,0,1.427",
    transform: "translate(-288.118 -684.091)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.913 21.315)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "at",
    d: "M324.51,702.694s3.4-5.287,7.091.472c0,0-.15,1.571-3.343.926S325.928,702.625,324.51,702.694Z",
    transform: "translate(-324.51 -700.478)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "au",
    d: "M332.123,709.655a7.175,7.175,0,0,0-6.974-.64",
    transform: "translate(-325.032 -706.967)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "au",
    d: "M355.414,712.324s-1.274-.9-.921-1.593",
    transform: "translate(-348.932 -708.847)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "au",
    d: "M346.33,708.729s-.088,2.124,1.027,2.252",
    transform: "translate(-342.318 -707.213)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "au",
    d: "M334.748,708.982s-.092,1.563.791,1.787",
    transform: "translate(-332.864 -707.419)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "au",
    d: "M337.707,700.478a2.162,2.162,0,0,0-1.109,1.517",
    transform: "translate(-334.376 -700.478)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "au",
    d: "M346.278,703.438s-1.122.214-1.375.917",
    transform: "translate(-341.155 -702.894)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "au",
    d: "M354.146,707.99s-.692-.124-.8.405",
    transform: "translate(-348.042 -706.599)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.162 22.38)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "aw",
    d: "M267.609,708.563s-2.668-4.543-7.034-.833a6.018,6.018,0,0,0,3.371,1.364A8.192,8.192,0,0,0,267.609,708.563Z",
    transform: "translate(-260.575 -706.273)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "au",
    d: "M260.575,713.406s4.864-.754,7.034.833",
    transform: "translate(-260.575 -711.949)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "au",
    d: "M266.207,710.121a1.425,1.425,0,0,1,.994.571",
    transform: "translate(-265.172 -709.414)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "au",
    d: "M275.5,706.546s.556.175,1.294,1.3",
    transform: "translate(-272.758 -706.496)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "au",
    d: "M287.987,708.575s.729.636.535,1.2",
    transform: "translate(-282.949 -708.152)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "au",
    d: "M265.38,714.014s1.3-.083,1.649-.786",
    transform: "translate(-264.497 -711.95)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "au",
    d: "M274.99,715.17s1.52-.358,1.955-1.326",
    transform: "translate(-272.341 -712.452)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "au",
    d: "M286.889,716.976a3.049,3.049,0,0,0,1.213-1.031",
    transform: "translate(-282.053 -714.167)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "ax",
    d: "M259.168,738.984v5.121a8.491,8.491,0,0,0,8.491,8.491h3.8a8.491,8.491,0,0,0,8.491-8.491v-5.121Z",
    transform: "translate(-257.265 -710.592)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviousPaperAnalysis);
export default __webpack_public_path__ + "static/media/previous-paper-analysis.707979202e219fa98854059a145d64ae.svg";
export { ForwardRef as ReactComponent };